import { auditBlockEn } from './auditLocales'

const en = {
  iconPicker: {
    title: 'Choose an icon',
    titlePhoto: 'Choose a photo',
    searchPlaceholder: 'Search icons...',
    background: 'Background',
    customColor: 'Custom colour',
    colors: {
      teal: 'Teal',
      blue: 'Blue',
      indigo: 'Indigo',
      violet: 'Violet',
      fuchsia: 'Fuchsia',
      pink: 'Pink',
      red: 'Red',
      amber: 'Amber',
      emerald: 'Emerald',
      cyan: 'Cyan',
      slate: 'Slate',
      deepCyan: 'Deep cyan',
      purple: 'Purple'
    },
    tabIcons: 'Icons',
    tabPhoto: 'Own photo',
    photoDrop: 'Drag an image here or',
    photoReplace: 'Replace the image or',
    photoDropAction: 'choose a file',
    photoRemove: 'Remove',
    photoHint:
      'PNG, JPG, SVG · up to {{size}} MB · at least {{pixels}}×{{pixels}}',
    photoTypeError: 'Only PNG, JPG or SVG images are accepted.',
    photoSizeError: 'The file is larger than {{size}} MB.',
    photoDimensionError: 'The image is smaller than {{size}}×{{size}}.',
    select: 'Select',
    emptyTitle: 'No icons found',
    emptyDescription: 'Try a different search term.'
  },
  agents: {
    scopes: {
      app: {
        core: 'Core',
        crm: 'CRM',
        hrm: 'HRM',
        notification: 'Notifications',
        squad: 'Squad'
      },
      action: {
        read: 'Read',
        write: 'Write',
        manage: 'Manage',
        provision: 'Provision',
        invoke: 'Invoke'
      },
      gatedHint: 'Connect {{app}} tools to grant this access.',
      gatedConnect: 'Connect tools'
    }
  },
  tickets: {
    create: 'Create ticket',
    submitTab: 'Submit ticket',
    myTicketsTab: 'My tickets',
    cancel: 'Cancel',
    submit: 'Submit',
    successCreate: 'Ticket created successfully',
    ticket: 'Ticket',
    example: 'Login error in the system.',
    description: 'Description',
    example_description:
      'When trying to log in, an error message appears. Urgent check is required.',
    attachments: 'Attachments',
    dragAndDrop: 'Drag and drop files here, or',
    selectFile: 'select',
    uploadHint: 'Support for single or bulk upload.',
    status: 'Status',
    statuses: {
      open: 'Open',
      inProgress: 'In progress',
      pending: 'Pending',
      solved: 'Solved',
      completed: 'Completed'
    },
    statusFilter: 'Filter',
    open: 'Open',
    closed: 'Closed',
    createdOn: 'Created',
    startDate: 'Start date',
    dueDate: 'Due date',
    noComments: 'No comments yet',
    commentPlaceholder: 'Add a reply...',
    commentAdded: 'Comment added successfully',
    closedChatReadOnly: 'This ticket is closed. Chat is read-only.',
    commentFromClickup: 'Support',
    commentsLoadError: 'Failed to load comments',
    noTickets: 'No tickets yet. Submit a ticket from the first tab.',
    listError: 'Failed to load tickets',
    retry: 'Retry',
    originalRequest: 'Original request',
    detailsLoadError: 'Failed to load ticket details',
    priority: {
      label: 'Priority',
      urgent: 'Urgent',
      high: 'High',
      normal: 'Normal',
      low: 'Low'
    },
    opened: 'Opened',
    activity: 'Activity',
    emoji: 'Emoji',
    hasUpdate: 'Has an update'
  },
  common: {
    retry: 'Retry',
    backToLogin: 'Back to login',
    comingSoon: 'Coming soon',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete'
  },
  errors: {
    somethingWentWrong: 'Something went wrong. Please try again.'
  },
  not_found: {
    title: 'Page not found',
    back_home: 'Back to home'
  },
  ui: {
    loading: 'Loading',
    loadError: 'Could not load this content',
    loadErrorDescription: 'Check your connection and try again.',
    retry: 'Try again',
    breadcrumb: 'Breadcrumb',
    tableEmpty: 'No data',
    noValue: '—'
  },
  placeholders: {
    name: 'Enter name',
    description: 'Enter description',
    email: 'user@example.com',
    fullName: 'Enter full name',
    appName: 'Enter app name',
    teamName: 'Enter team name',
    roleName: 'Enter role name',
    functionName: 'Enter function name',
    displayName: 'Enter display name',
    connectionName: 'Enter connection name',
    credentialName: 'Enter credential name',
    webhookName: 'Enter webhook name',
    webhookUrl: 'https://example.com/webhook',
    clientId: 'Enter client ID',
    clientSecret: 'Enter client secret',
    abbreviation: 'e.g. ENG',
    scope: 'openid profile email',
    issuerUrl: 'https://issuer.example.com/',
    jwksUrl: 'https://example.com/.well-known/jwks.json',
    authorizeUrl: 'https://example.com/authorize',
    tokenUrl: 'https://example.com/token'
  },
  audit: auditBlockEn,
  welcome_back: 'Welcome back',
  sign_in: 'Sign in',
  sign_up: 'Sign up',
  welcome_to_skalx: 'Welcome to Skalx',
  sign_up_to_create: 'Sign up to create your account',
  auth_hero_title: 'One account, every Skalx app',
  auth_hero_subtitle:
    'Manage your organizations, teams, and access from a single secure identity.',
  auth_hero_feature_sso: 'Single sign-on across the suite',
  auth_hero_feature_orgs: 'Organizations, teams, and roles in one place',
  auth_hero_feature_security: 'Security, sessions, and audit built in',
  next: 'Next',
  have_account: 'Already have an account?',
  have_questions: 'Have questions?',
  contact_us: 'Contact us',
  company_name: 'Company name',
  domain: 'Domain',
  email: 'Email',
  phone_number: 'Phone number',
  password: 'Password',
  input_placeholder_password: 'Enter your password',
  i_agree: 'I agree to the',
  terms_and_conditions: 'Terms and Conditions',
  terms_title: 'Terms and Conditions',
  terms_updated: 'Effective date: January 29, 2026',
  terms_intro:
    'These Terms govern your access to and use of the EBS account and services. By creating an account or using the service, you agree to these Terms.',
  terms_section_acceptance_title: 'Acceptance',
  terms_section_acceptance_body:
    'You must be able to form a binding agreement and use the service only as permitted by law.',
  terms_section_account_title: 'Account security',
  terms_section_account_body:
    'You are responsible for maintaining the confidentiality of your credentials and for all activity under your account.',
  terms_section_use_title: 'Acceptable use',
  terms_section_use_body:
    'Do not misuse the service, interfere with its operation, or access it in unauthorized ways.',
  terms_section_privacy_title: 'Privacy',
  terms_section_privacy_body:
    'We process personal data as described in our privacy practices and applicable law.',
  terms_section_availability_title: 'Availability',
  terms_section_availability_body:
    'The service is provided "as is" and may be modified, interrupted, or discontinued without prior notice.',
  terms_section_changes_title: 'Changes and termination',
  terms_section_changes_body:
    'We may update these Terms or suspend access for violations or security reasons.',
  terms_contact: 'Questions about these Terms? Contact us at',
  password_repeat: 'Repeat password',
  passwords_must_match: 'Passwords must match',
  created_by: 'Created by',
  brand: {
    visitWebsite: 'Visit skalx.ai'
  },
  required_field_error: 'This field is required',
  form_validation_error: 'Please correct the errors in the form',
  first_name: 'First name',
  last_name: 'Last name',
  registration_success: 'Registration completed successfully',
  back: 'Back',
  continue: 'Continue',
  registration_check_email: 'Check your email for a confirmation link',
  registration_email_sent_title: 'Check your email',
  registration_email_sent_description:
    'We sent a confirmation link to {{email}}. Please open it to set your password and finish registration.',
  registration_confirm_title: 'Set your password',
  registration_confirm_description:
    'Create a password to finish your registration',
  registration_confirm_missing_token_title: 'Confirmation link is invalid',
  registration_confirm_missing_token_description:
    'This link is missing a confirmation token. Please open the latest link from your email or start registration again.',
  registration_token: 'Confirmation token',
  registration_token_placeholder: 'Paste the token from your email',
  invalid_domain_format:
    'Domain must start with a letter, end with a letter or number, and contain only lowercase letters, numbers and single hyphens',
  password_min_length: 'Password must be at least 8 characters long',
  password_policy:
    'Password must be at least 10 characters, include one uppercase letter, one number, and one special character from this list (!@#$%^&*()_+)',
  registration: 'Registration',
  sign_in_your_account: 'Sign in to your account',
  do_not_have_account: "Don't have an account?",
  forgot_password: 'Forgot password?',
  submit: 'Submit',
  enter_email_send_new_one: 'Enter your email and we will send you a new one',
  check_email_instruction:
    'Check your email for a link to reset your password. If you don’t see it, check your spam folder.',
  reset_password_again: 'Try again or use a different email',
  reset_password_missing_token_title: 'Reset link is invalid',
  reset_password_missing_token_description:
    'This link is missing a reset token. Request a new password reset email to continue.',
  reset_password_request_new_link: 'Request a new reset link',
  invitation_title: 'Join {{organization}}',
  invitation_subtitle: 'Set up your account to accept the invitation',
  invitation_email_hint: 'The invitation was sent to {{email}}',
  invitation_accept: 'Accept invitation',
  invitation_accepted: 'Invitation accepted — sign in to continue',
  invitation_existing_account:
    'You already have an account. Sign in and the workspace will be waiting for you.',
  invitation_sign_in_to_join: 'Sign in to join',
  invitation_missing_token_title: 'Invitation link is invalid',
  invitation_missing_token_description:
    'This link is missing an invitation token. Please open the latest invitation from your email.',
  invitation_invalid_title: 'This invitation can no longer be used',
  invitation_invalid_description:
    'It may have expired, been revoked, or already been accepted. Ask an administrator of the workspace to send a new one.',
  login_success: 'Login successful',
  auth: {
    signInWithGoogle: 'Sign in with Google',
    signUpWithGoogle: 'Sign up with Google',
    signUpWithApple: 'Sign up with Apple',
    signInWithApple: 'Sign in with Apple',
    signInWithPasskey: 'Sign in with passkey',
    signInWithCustomProvider: 'Sign in with {{name}}',
    passkeyRecommendation: {
      title: 'Secure your account with a passkey',
      description:
        'Use fingerprint, face recognition, or screen lock for faster and more secure sign-in.',
      setup: 'Set up passkey',
      later: 'Maybe later',
      dontAsk: "Don't ask again",
      nameLabel: 'Passkey name',
      namePlaceholder: 'e.g. My laptop',
      success: 'Passkey added! You can now sign in with it.',
      alreadyRegistered: 'This device already has a passkey set up'
    },
    signInWithEntraid: 'Sign in with Microsoft',
    or: 'or continue with',
    resendCooldownHint: 'Please wait a moment before resending.',
    resendInSeconds_one: 'You can resend in {{count}} second.',
    resendInSeconds_other: 'You can resend in {{count}} seconds.',
    passwordSignInUnavailable: 'Password sign-in is currently unavailable.',
    mfaRequired: 'Additional verification is required. Check your email.',
    mfa: {
      otpTitle: 'Verify your identity',
      otpDescription:
        'We sent a verification code to your email. Enter it below to continue.',
      setupTitle: 'Set up two-factor authentication',
      setupDescription:
        'Your workspace requires multi-factor authentication. We emailed a verification code to confirm your second factor — enter it below to finish setting up and sign in.',
      otpLabel: 'Verification code',
      otpRequired: 'Please enter the verification code',
      codeExpired: 'The code has expired. Request a new one.',
      codeExpiresIn: 'Code expires in {{time}}',
      keepMeLoggedIn: 'Keep me logged in on this device',
      resendOtp: 'Resend code',
      otpSent: 'A new code was sent to your email',
      moreOptions: 'More options',
      useBackupCode: 'Use a backup code',
      backupCodeTitle: 'Use a backup code',
      backupCodeDescription: 'Enter one of your recovery codes to sign in.',
      backupCodeLabel: 'Backup code',
      backupCodeRequired: 'Please enter a backup code',
      tokenExpired: 'Your session has expired. Please sign in again.'
    },
    emailOtp: {
      title: 'Sign in with email',
      subtitle: "Enter your email and we'll send you a one-time code.",
      emailLabel: 'Email address',
      emailPlaceholder: 'you@example.com',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Please enter a valid email',
      submit: 'Continue',
      codeTitle: 'Enter your verification code',
      codeSubtitle:
        'We sent a code to <email>{{email}}</email>. Enter it below to sign in.',
      codeLabel: 'Verification code',
      codeRequired: 'Please enter the verification code',
      codeExpired: 'The code has expired. Request a new one.',
      codeExpiresIn: 'Code expires in {{time}}',
      codeSent: 'A new code was sent to your email',
      resend: 'Resend code',
      shortLabel: 'Email',
      useOtpInstead: 'Sign in with a one-time code instead',
      usePasswordInstead: 'Sign in with password instead',
      backToSignIn: 'Back to sign-in',
      tokenExpired: 'Your sign-in session has expired. Please try again.',
      linkSentTitle: 'Check your email',
      linkSentSubtitle:
        'We sent a sign-in link to <email>{{email}}</email>. Click the button in the email to sign in instantly.',
      linkResend: 'Resend email',
      or: 'or',
      enterCodeInstead: 'Enter the code manually',
      useLinkInstead: 'Use the email link',
      linkCallback: {
        verifying: 'Signing you in…',
        subtitle: 'Hold on while we verify your sign-in link.',
        errorTitle: 'Sign-in link is invalid or expired',
        errorBody:
          'This link can no longer be used. Request a new code or use the 6-digit code from the email.',
        backToSignIn: 'Back to sign-in'
      }
    },
    qrSignIn: {
      title: 'Sign in with QR code',
      subtitle:
        'Open the Skalx mobile app on a device where you are already signed in, then scan this code.',
      useQrInstead: 'Sign in with QR code instead',
      refresh: 'Refresh',
      heroTitle: 'Sign in with QR code',
      heroDescription:
        'Scan this code with your phone camera to sign in instantly.',
      waiting: 'Waiting for scan. Code expires in {{seconds}}s.',
      scanned: 'Scanned. Confirm the sign-in on your phone.',
      tryAgain: 'Try again',
      cancel: 'Cancel QR sign-in',
      deniedToast: 'QR sign-in was cancelled on your phone.',
      canceledToast: 'QR sign-in was cancelled.',
      expired: {
        title: 'Code expired',
        description:
          'This QR code is no longer active. Generate a new code to continue.'
      },
      denied: {
        title: 'Sign-in cancelled',
        description:
          'The request was denied on your phone. Start again if this was you.'
      },
      canceled: {
        title: 'QR sign-in cancelled',
        description: 'Start again when you are ready to scan a new code.'
      },
      error: {
        title: 'QR sign-in is unavailable',
        description:
          'We could not start or continue this QR sign-in. Try again in a moment.'
      },
      approved: {
        title: 'Approved',
        description: 'Finishing your sign-in...'
      }
    },
    noLoginMethodsEnabled:
      'No sign-in methods are enabled for this organization. Contact your administrator.',
    googleCallbackMissingParams: 'Invalid sign-in response. Please try again.',
    googleNotLinkedToOrg:
      'Google sign-in is not linked to this organization. Link it in your profile or sign in with another method.',
    appleCallbackMissingParams:
      'Invalid Apple sign-in response. Please try again.',
    appleNotLinkedToOrg:
      'Apple sign-in is not linked to this organization. Link it in your profile or sign in with another method.',
    register: {
      accountTitle: 'Create your account',
      accountSubtitle:
        'Start with your personal account. You can add or join workspaces after signing in.',
      switchToWorkspaceFlow: 'Sign up and create a workspace in one flow',
      switchToAccountFlow:
        'Sign up with account only (optional workspace later)',
      accountContinuesToWorkspaceSetup:
        'Continue by creating your first workspace. When the API supports it, this step can be skipped for account-only signup.',
      accountLinkShort: 'Sign up (account only)'
    },
    onboarding: {
      title: 'Complete your setup',
      description: 'Create your first organization to get started.',
      tokenReady: 'You can continue in the next step.',
      createOrganization: 'Create organization',
      missingToken: 'Invalid or missing onboarding link. Please sign in again.'
    }
  },
  email_sent_success: 'Email sent successfully',
  password_reset_success: 'Password reset successfully',
  reset_password: 'Reset password',
  enter_new_password: 'Enter new password',
  logout: 'Logout',
  menu: {
    organizations: 'Organizations',
    home: 'Home',
    account: 'Account',
    workspaces: 'Workspaces',
    billing: 'Billing'
  },
  shell: {
    menu: {
      home: 'Home',
      overview: 'Overview',
      users: 'Users',
      roles: 'Roles',
      organization: 'Organization',
      ssoSaml: 'SSO & SAML',
      authentication: 'Authentication',
      apps: 'Apps',
      agents: 'Agents',
      domains: 'Domains',
      publicAccess: 'Public access',
      aiConnectors: 'AI connectors',
      auditLog: 'Audit log',
      companyGraph: 'Company graph',
      workspaceSettings: 'Workspace settings',
      billing: 'Billing',
      createWorkspace: 'Create workspace',
      comingSoon: 'Coming soon',
      groups: {
        gettingStarted: 'Getting started',
        workspace: 'Workspace',
        identity: 'Identity',
        applications: 'Applications',
        developers: 'Developers',
        compliance: 'Compliance',
        settings: 'Settings'
      },
      tags: {
        ai: 'AI',
        preview: 'Preview'
      }
    },
    welcome: {
      greeting: 'Welcome to'
    },
    switcher: {
      switchWorkspace: 'Switch workspace',
      accountSettings: 'Account settings',
      createWorkspace: 'Create new workspace',
      signOut: 'Sign out',
      ariaLabel: 'Active workspace',
      noWorkspace: 'No workspace',
      noWorkspaceMeta: 'Create one to get started'
    },
    user: {
      accountSettings: 'Account settings',
      signOut: 'Sign out',
      fallback: 'User'
    },
    topbar: {
      searchPlaceholder: 'Search…',
      docs: 'Docs',
      openWorkspace: 'Open workspace — {{url}}',
      language: 'Language',
      theme: 'Theme',
      themeMode: {
        light: 'Light',
        dark: 'Dark',
        system: 'System'
      }
    },
    sidebar: {
      expand: 'Expand',
      collapse: 'Collapse'
    },
    gettingStarted: {
      title: 'Getting started',
      progress: '{{done}}/{{total}}',
      encouragement: 'Keep it up!',
      more: 'Checklist actions',
      learnMore: 'Learn more',
      hideForDays: 'Hide for {{days}} days',
      dismiss: 'Hide for good',
      errors: {
        generic:
          'This step could not be completed. Open its page and try again.',
        code_expired: 'The verification code expired. Ask for a new one.',
        code_invalid: 'The verification code was not accepted.',
        m365_admin_consent_required:
          'A Microsoft 365 administrator has to approve this connection.',
        domain_not_verified: 'The domain has not been verified yet.',
        import_parse_failed: 'The imported file could not be read.',
        provisioning_failed:
          'Setting the workspace up failed. Retry it from Workspace settings.'
      },
      dismissModal: {
        title: 'Hide the checklist?',
        subtitle: 'Tell us why and it stays gone.',
        reasons: {
          already_set_up: 'Already set up my way',
          not_relevant: 'Not relevant to my role',
          later: 'I’ll do it later',
          not_interested: 'Not interested'
        }
      },
      items: {
        invite_users: {
          title: 'Invite your team',
          description:
            'Send invites to the people you work with — a workspace comes to life once someone else is in it.',
          cta: 'Invite'
        },
        roles: {
          title: 'Roles and permissions',
          description:
            'Describe who may do what: assemble roles out of permissions instead of granting them one by one.',
          cta: 'Set up'
        },
        authentication: {
          title: 'Set up authentication',
          description:
            'Connect SSO or your own provider so the team signs in with their work account.',
          cta: 'Set up'
        },
        workspace_settings: {
          title: 'Review workspace settings',
          description:
            'Name, logo, domains and timezone — the details every member of the workspace sees.',
          cta: 'Review'
        },
        profile: {
          title: 'Fill in your profile',
          description:
            'A name and a photo are how colleagues recognise you in lists, mentions and audit trails.',
          cta: 'Fill in'
        },
        security: {
          title: 'Protect your account',
          description:
            'Add a passkey or turn on two-factor authentication so a password alone is not enough to sign in as you.',
          cta: 'Protect'
        },
        apps: {
          title: 'See what is installed',
          description:
            'The apps of this workspace are what you will actually work in day to day. Have a look around.',
          cta: 'Take a look'
        }
      }
    },
    footer: {
      ariaLabel: 'Site footer',
      brand: 'Skalx',
      poweredBy: 'Powered by',
      versionTooltip: 'App build version',
      status: {
        operational: 'All systems normal',
        tooltip: 'Realtime status — status.skalx.ai'
      },
      links: {
        docs: 'Docs',
        status: 'Status',
        changelog: 'Changelog',
        privacy: 'Privacy',
        support: 'Support'
      }
    },
    account: {
      profile: 'Basic profile',
      authentication: 'Authentication',
      security: 'Security',
      notifications: 'Notifications',
      activity: 'Activity',
      audit: 'Audit',
      sessions: 'Sessions & devices'
    }
  },
  organization: {
    pageTitle: 'Organization',
    pageSubtitle:
      'Divisions, departments and teams — chart, tree and browse views.',
    types: {
      division: 'Division',
      department: 'Department',
      team: 'Team'
    },
    views: {
      chart: 'Chart',
      tree: 'Tree',
      browse: 'Browse'
    },
    toolbar: {
      searchPlaceholder: 'Find a team or person…',
      types: {
        all: 'Type',
        divisions: 'Divisions',
        departments: 'Departments',
        teams: 'Teams'
      }
    },
    kpis: {
      divisions: 'Divisions',
      departments: 'Departments',
      teams: 'Teams',
      membersAssigned: 'Members assigned',
      openPositions: 'Open positions',
      of: 'of {{total}}'
    },
    actions: {
      export: 'Export',
      newDivision: 'New division',
      viewDetails: 'View details',
      edit: 'Edit',
      delete: 'Delete',
      more: 'More actions',
      addShort: 'Add',
      add: {
        division: 'Add division',
        department: 'Add department',
        team: 'Add team'
      }
    },
    tree: {
      columns: {
        name: 'Name',
        lead: 'Lead',
        headcount: 'Headcount',
        subUnits: 'Sub-units'
      },
      empty: 'No divisions, departments or teams yet.',
      expand: 'Expand',
      collapse: 'Collapse',
      leadVacant: 'Lead vacant',
      subUnitsCount_one: '{{count}} sub-unit',
      subUnitsCount_other: '{{count}} sub-units'
    },
    browse: {
      columns: {
        name: 'Name',
        type: 'Type',
        parent: 'Parent',
        lead: 'Lead',
        headcount: 'Headcount',
        openPositions: 'Open positions',
        created: 'Created'
      },
      workspaceRoot: 'Workspace',
      total_one: '{{count}} unit total',
      total_other: '{{count}} units total'
    },
    detail: {
      inParent: 'in {{parent}}',
      stats: {
        headcount: 'Headcount',
        budgeted: 'Budgeted',
        open: 'Open',
        subUnits: 'Sub-units'
      },
      lead: {
        title: 'Lead',
        none: 'No lead assigned yet',
        change: 'Change lead',
        assign: 'Assign lead'
      },
      subUnits: {
        departmentPlural: 'Departments',
        teamPlural: 'Teams',
        divisionPlural: 'Divisions'
      },
      members: {
        title: 'Members',
        empty: 'No direct members yet.',
        showAll: 'Show all {{count}} members →',
        add: 'Add member',
        remove: 'Remove from team',
        addModal: {
          title: 'Add member to {{team}}',
          userLabel: 'User',
          userPlaceholder: 'Search a teammate',
          userRequired: 'Pick a user to add',
          submit: 'Add member',
          cancel: 'Cancel',
          noCandidates: 'Everyone is already a member of this team.'
        },
        removeConfirm: {
          title: 'Remove member?',
          content:
            'Remove {{name}} from "{{team}}"? They keep their account and any other team assignments.',
          confirm: 'Remove',
          cancel: 'Cancel'
        }
      },
      metadata: {
        title: 'Metadata',
        unitId: 'Unit ID',
        type: 'Type',
        parent: 'Parent',
        created: 'Created'
      }
    },
    form: {
      createTitle: 'Create {{type}}',
      editTitle: 'Edit {{type}}',
      cancel: 'Cancel',
      create: 'Create',
      saveChanges: 'Save changes',
      fields: {
        name: 'Name',
        type: 'Type',
        parent: 'Parent',
        abbreviation: 'Abbreviation',
        description: 'Description',
        lead: 'Lead'
      },
      placeholders: {
        name: 'e.g. Engineering, Sales EMEA',
        parent: 'Select parent unit',
        description: 'Optional description — what does this unit own?',
        lead: 'Pick a member to lead this unit'
      },
      required: {
        name: 'Name is required',
        parent: 'Parent unit is required'
      },
      noParents: 'No {{type}} units yet — create one first to nest under it.',
      notApiBackedFields: {
        title: 'Some fields are visual-only for now',
        description:
          'Color, budget headcount and headcount targets shown in the example mockups are not yet persisted by the API. They will appear with the "API pending" badge until backend support lands.',
        examples: 'Color · budget headcount · open positions'
      }
    },
    delete: {
      title: 'Delete this unit?',
      content:
        'This will permanently delete "{{name}}". Members will keep their accounts but lose this team assignment.',
      confirm: 'Delete unit',
      cancel: 'Cancel'
    },
    toasts: {
      created: 'Unit created',
      createFailed: 'Failed to create unit',
      updated: 'Unit updated',
      updateFailed: 'Failed to update unit',
      deleted: 'Unit deleted',
      deleteFailed: 'Failed to delete unit',
      memberAdded: 'Member added',
      memberAddFailed: 'Failed to add member',
      memberRemoved: 'Member removed',
      memberRemoveFailed: 'Failed to remove member',
      teamRoleGranted: 'Role granted to the team',
      teamRoleRevoked: 'Role revoked from the team'
    },
    notApiBacked: {
      short: 'API pending',
      tooltip:
        'This field is shown for layout parity with the design mockups but is not yet persisted by the API.',
      budget:
        'Budget headcount and open-position tracking are not yet persisted by the API.',
      exportTooltip:
        'CSV export is not yet wired to the API — the button is shown for layout parity.',
      exportToast: 'Export is not yet implemented (no API endpoint).'
    }
  },
  users: {
    title: 'Users',
    tabs: {
      people: 'Users',
      groups: 'Groups',
      joinRequests: 'Join requests'
    },
    joinRequests: {
      searchPlaceholder: 'Search by name or email',
      approveAs: 'Approve as',
      approve: 'Approve',
      reject: 'Decline',
      approveConfirm: 'Let {{email}} into this workspace?',
      rejectConfirm: 'Decline the request from {{email}}?',
      approved: '{{email}} was added to the workspace.',
      rejected: 'The request from {{email}} was declined.',
      columns: {
        person: 'Person',
        requested: 'Requested',
        status: 'Status',
        reviewed: 'Reviewed',
        actions: 'Actions'
      },
      status: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Declined'
      }
    },
    groups: {
      searchPlaceholder: 'Search groups…',
      organizationScope: 'Workspace',
      memberCount_one: '{{count}} member',
      memberCount_other: '{{count}} members',
      columns: {
        name: 'Group',
        members: 'Members',
        roles: 'Roles granted',
        created: 'Created',
        updated: 'Updated'
      },
      actions: {
        create: 'New group',
        edit: 'Edit',
        delete: 'Delete',
        more: 'More actions'
      },
      form: {
        createTitle: 'New group',
        editTitle: 'Edit group',
        name: 'Name',
        namePlaceholder: 'e.g. Support team',
        nameRequired: 'Give the group a name.',
        members: 'Members',
        addMember: 'Add member',
        removeMember: 'Remove from group',
        membersEmpty: 'No members yet.',
        membersPlaceholder: 'Search teammates',
        membersHint: 'Changes are saved with the group.',
        roles: 'Roles granted',
        rolesPlaceholder: 'Search roles',
        rolesTruncated:
          'Showing the first 200 roles. Narrow the workspace role list if one is missing.',
        rolesHint:
          'Members receive these roles — and access to the applications the roles belong to.',
        save: 'Save',
        cancel: 'Cancel',
        created: 'Group created',
        updated: 'Group updated'
      },
      detail: {
        metadata: 'Details',
        rolesEmpty: 'This group grants no roles yet.',
        showAllMembers: 'Show all {{count}} members →',
        removeSuccess: 'Member removed from the group',
        removeConfirm: {
          title: 'Remove from group',
          content:
            'Remove {{name}} from “{{group}}”? They keep any role they also hold personally or through another group.',
          confirm: 'Remove'
        }
      },
      delete: {
        title: 'Delete group',
        description:
          'Delete “{{name}}”? Its members keep their accounts — only the group is removed.',
        submit: 'Delete group',
        success: 'Group deleted'
      }
    },
    statuses: {
      all: 'All',
      active: 'Active',
      invited: 'Invited',
      suspended: 'Suspended',
      inactive: 'Inactive'
    },
    roles: {
      owner: 'Owner',
      admin: 'Admin',
      employee: 'Member'
    },
    invite: {
      drawerTitle: 'Invite members',
      description:
        'Add one or more email addresses, pick a role, and (optionally) assign a manager. We’ll send each person an invitation email.',
      submit: 'Send invitations',
      cancel: 'Cancel',
      success_one: 'Invitation sent',
      success_other: '{{count}} invitations sent',
      fields: {
        emails: 'Email addresses',
        emailsPlaceholder: 'name@example.com, another@example.com',
        emailsTooltip:
          'Press Enter, comma, or space after each address to add it as a tag.',
        role: 'Role',
        manager: 'Manager',
        managerPlaceholder: 'Search a teammate',
        managerHint: 'Optional — the person who will manage the invitees.'
      },
      error: {
        noEmails: 'Add at least one email address.',
        invalidEmails: 'Not a valid email: {{emails}}',
        workspaceNotReady:
          'Workspace details are still loading — please try again in a moment.'
      }
    },
    filters: {
      searchPlaceholder: 'Search by name or email…',
      allStatuses: 'Status',
      allRoles: 'All roles',
      allTeams: 'All teams',
      teamChip: 'Team',
      joinedChip: 'Joined',
      joinedFromPlaceholder: 'Joined from',
      joinedToPlaceholder: 'Joined to',
      mfaValues: {
        all: 'MFA · any',
        on: 'MFA enabled',
        off: 'MFA disabled',
        required: 'Required, not enrolled'
      },
      moreFilters: 'More filters',
      chipsLabel: 'Filters',
      statusChip: 'Status',
      roleChip: 'Role',
      mfaChip: 'MFA',
      is: 'is',
      clearAll: 'Clear all'
    },
    columns: {
      user: 'User',
      email: 'Email',
      role: 'Role',
      status: 'Status',
      jobTitle: 'Job title',
      manager: 'Manager',
      teams: 'Teams',
      mfa: 'MFA',
      mfaEnabled: 'Enabled',
      mfaDisabled: 'Disabled',
      lastSignIn: 'Last sign-in',
      joined: 'Joined',
      source: 'Source'
    },
    export: {
      empty: 'Nothing to export — the current filters return no rows.',
      success_one: 'Exported {{count}} user',
      success_other: 'Exported {{count}} users'
    },
    lastSignIn: {
      never: 'Never'
    },
    toolbar: {
      selected_one: '{{count}} selected',
      selected_other: '{{count}} selected',
      clear: 'Clear',
      showing: 'Showing {{shown}} of {{total}} users',
      total_one: '{{count}} total',
      total_other: '{{count}} total'
    },
    actions: {
      view: 'View profile',
      edit: 'Edit user',
      changeRole: 'Change role',
      resendInvite: 'Resend invite',
      invitation: 'Invitation',
      reactivate: 'Reactivate',
      suspend: 'Suspend',
      archive: 'Archive user',
      unarchive: 'Unarchive user',
      delete: 'Delete',
      requireMfa: 'Require MFA',
      disableMfa: 'Stop requiring MFA',
      resetMfa: 'Reset MFA',
      resetPassword: 'Reset password',
      impersonate: 'Impersonate',
      export: 'Export',
      invite: 'Invite users',
      more: 'More actions',
      apiPending: {
        changeRole: 'Change role — API endpoint not wired yet.',
        resendInvite: 'Resend invite — API endpoint not wired yet.',
        reactivate: 'Reactivate — API endpoint not wired yet.',
        suspend: 'Suspend — API endpoint not wired yet.',
        delete: 'Delete user — API endpoint not wired yet.',
        bulkSuspend: 'Bulk suspend — API endpoint not wired yet.',
        bulkDelete: 'Bulk delete — API endpoint not wired yet.',
        invite:
          'Invite users — UI is shown; existing endpoint is wired in the legacy users page.',
        export: 'Export — API endpoint not wired yet.',
        edit: 'Edit user — API endpoint not wired yet.',
        resetPassword: 'Reset password — API endpoint not wired yet.',
        impersonate: 'Impersonate — API endpoint not wired yet.',
        requireMfa: 'Require MFA — API endpoint not wired yet.'
      }
    },
    lifecycle: {
      inviteState: {
        pending: 'Invite pending',
        expired: 'Invite expired',
        accepted: 'Active',
        revoked: 'Invite revoked'
      },
      inviteExpires: 'Invite expires {{when}}',
      inviteExpired: 'Invite expired {{when}}',
      requiresAcceptance: 'Available once the member accepts their invite',
      joinLink: {
        action: 'Join link',
        copied: 'Join link copied to clipboard',
        disabledHint:
          'Enable self-service join in workspace settings to share a link.'
      },
      revokeInvite: {
        action: 'Revoke invite',
        title: 'Revoke invitation?',
        description:
          'This cancels the pending invitation for {{name}}. The invite link stops working immediately.',
        submit: 'Revoke invite',
        success: 'Invitation revoked'
      },
      resetPassword: {
        title: 'Send password reset?',
        description:
          'We will email {{name}} a secure link to choose a new password. Their current password keeps working until they use it.',
        submit: 'Send reset link',
        success: 'Password reset email sent'
      },
      requireMfa: {
        title: 'Require two-factor auth?',
        description:
          'Two-factor authentication will be turned on for {{name}}. They will be asked to verify by email or authenticator at their next sign-in.',
        submit: 'Require MFA',
        success: 'MFA is now required for this member'
      },
      disableMfa: {
        title: 'Stop requiring two-factor auth?',
        description:
          'MFA will no longer be required for {{name}} in this workspace. Their existing two-factor setup stays active — this only lifts the workspace requirement, it does not remove their enrollment. To help a member who lost their authenticator, use Reset MFA instead.',
        submit: 'Stop requiring',
        success: 'MFA is no longer required for this member'
      },
      resetMfa: {
        title: 'Reset two-factor auth?',
        description:
          "{{name}}'s recovery codes, trusted devices, and lockouts will be cleared so they re-enroll from scratch. MFA stays on (email codes still work, so they are not locked out). You never see their recovery codes — they generate fresh ones in their own security settings.",
        submit: 'Reset MFA',
        success: 'MFA reset for this member'
      },
      impersonate: {
        title: 'Impersonate this member?',
        description:
          'You will start a session as {{name}}. Your own admin session is restored when you exit impersonation.',
        warning:
          'Every action you take will be performed as this member and recorded in the audit log.',
        submit: 'Start impersonation',
        success: 'Impersonation session started',
        banner: 'You are impersonating {{name}}',
        exit: 'Exit impersonation'
      },
      sessions: {
        title: 'Active sessions',
        subtitle: 'Devices currently signed in as this member',
        empty: 'No active sessions.',
        current: 'Current',
        revoke: 'Revoke',
        revokeAll: 'Revoke all',
        revokeConfirm: 'Revoke this session? The device will be signed out.',
        revokeAllConfirm:
          'Revoke all sessions for this member? They will be signed out on every device.',
        revoked: 'Session revoked',
        revokedAll_one: 'Revoked {{count}} session',
        revokedAll_other: 'Revoked {{count}} sessions',
        failed: 'Could not revoke session',
        unknownDevice: 'Unknown device',
        columns: {
          device: 'Device',
          location: 'Location',
          ip: 'IP address',
          lastActive: 'Last active',
          created: 'Started'
        }
      }
    },
    modals: {
      cancel: 'Cancel',
      changeRole: {
        title: 'Change role',
        description:
          'Choose a new role for {{name}}. Their access level updates immediately.',
        fieldLabel: 'New role',
        submit: 'Save changes',
        cancel: 'Cancel',
        success: 'Role updated'
      },
      suspend: {
        title: 'Suspend user?',
        description:
          'Suspending {{name}} will sign them out and block sign-in until they are reactivated.',
        warning:
          'Active sessions are revoked and pending tasks may be reassigned.',
        submit: 'Suspend user',
        success: 'User suspended'
      },
      reactivate: {
        title: 'Reactivate user?',
        description:
          '{{name}} will be able to sign in again with their existing credentials.',
        submit: 'Reactivate user',
        success: 'User reactivated'
      },
      delete: {
        title: 'Delete user from workspace',
        description:
          'This removes {{name}} from the workspace. Their account is not deleted globally.',
        warning:
          'This cannot be undone. Per-workspace data and access will be lost.',
        confirmLabel: 'To confirm, type their email:',
        submit: 'Delete user',
        success: 'User removed from workspace'
      },
      resendInvite: {
        title: 'Resend invitation',
        description:
          'We will send a fresh invitation email so the user can finish setting up their account.',
        recipient: 'Sending to:',
        submit: 'Resend invitation',
        success: 'Invitation resent'
      },
      archive: {
        title: 'Archive user',
        description:
          'Archiving {{name}} blocks their sign-in and hands off the records they still own in this workspace.',
        checking: 'Checking what this user owns…',
        checkFailed: 'Could not load this user’s records. Try again.',
        noBlockers:
          'This user has no active records that block archiving. They can be archived directly.',
        hasBlockers:
          'This user still owns active records. Choose a colleague to take them over — the records are reassigned, then the user is archived.',
        depsTitle: 'Active records',
        services: { crm: 'CRM', hrm: 'HRM' },
        entityCount_one: '{{count}} active',
        entityCount_other: '{{count}} active',
        replaceLabel: 'Reassign records to',
        replacePlaceholder: 'Select a colleague…',
        replaceRequired: 'Select a user to reassign the records to.',
        manualHint:
          'Prefer to handle it yourself? You can open the relevant app and reassign these records manually, then archive the user here once nothing is left.',
        submit: 'Archive user',
        submitReplace: 'Reassign & archive',
        success: 'User archived',
        job: {
          pending: 'Queued…',
          processing: 'Reassigning records and archiving…',
          succeeded: 'User archived',
          failed: 'Archiving failed'
        },
        jobError:
          'Some records could not be reassigned. No changes were applied.'
      },
      unarchive: {
        title: 'Unarchive user',
        description:
          'Unarchiving {{name}} restores their sign-in and record ownership in this workspace.',
        submit: 'Unarchive user',
        success: 'User unarchived'
      },
      bulk: {
        note: 'Each user is processed individually — partial failures are reported.',
        suspend: {
          title_one: 'Suspend {{count}} user?',
          title_other: 'Suspend {{count}} users?',
          description_one:
            'Suspending {{count}} user will sign them out and block sign-in until reactivated.',
          description_other:
            'Suspending {{count}} users will sign them out and block sign-in until reactivated.',
          warning: 'Active sessions are revoked.',
          submit: 'Suspend',
          success_one: '{{count}} user suspended',
          success_other: '{{count}} users suspended',
          partial_one: '{{count}} user could not be suspended',
          partial_other: '{{count}} users could not be suspended'
        },
        reactivate: {
          title_one: 'Reactivate {{count}} user?',
          title_other: 'Reactivate {{count}} users?',
          description_one: '{{count}} user will be able to sign in again.',
          description_other: '{{count}} users will be able to sign in again.',
          submit: 'Reactivate',
          success_one: '{{count}} user reactivated',
          success_other: '{{count}} users reactivated',
          partial_one: '{{count}} user could not be reactivated',
          partial_other: '{{count}} users could not be reactivated'
        },
        delete: {
          title_one: 'Remove {{count}} user from workspace?',
          title_other: 'Remove {{count}} users from workspace?',
          description_one: 'This removes {{count}} user from the workspace.',
          description_other: 'This removes {{count}} users from the workspace.',
          warning:
            'Per-workspace data and access will be lost — this cannot be undone.',
          submit: 'Remove',
          success_one: '{{count}} user removed',
          success_other: '{{count}} users removed',
          partial_one: '{{count}} user could not be removed',
          partial_other: '{{count}} users could not be removed'
        }
      }
    },
    hero: {
      lastSignIn: 'Last sign-in',
      mfaUnknown: 'MFA · status pending',
      mfaOn: '2FA · enrolled',
      mfaOff: '2FA · not enrolled',
      statusHint: 'Current account status — active, invited, or suspended.',
      roleHint: 'Workspace role — determines what this account can access.',
      mfaHint:
        'Whether two-factor authentication is enrolled for this account.',
      ssoHint:
        'How this account signs in — single sign-on (SSO) or manual credentials.',
      userId: 'User ID',
      via: 'via',
      source: {
        sso: 'SSO',
        manual: 'Manual'
      },
      alerts: {
        neverSignedIn:
          'This user has not signed in yet. They may still be onboarding.',
        apiPendingFields:
          'MFA, sign-in source and per-app access aren’t yet exposed by the API — they’re shown for layout parity.'
      }
    },
    detail: {
      tabs: {
        overview: 'Overview',
        access: 'App access',
        sessions: 'Sessions',
        audit: 'Audit'
      },
      tabsPlaceholders: {
        access:
          'Per-application access and roles will appear here once the API exposes the application access list.',
        sessions:
          'Active device sessions will appear here once the sessions API is wired.',
        audit:
          'User-scoped audit events will appear here once the audit API is wired.'
      },
      identity: {
        title: 'Identity',
        subtitle: 'Personal information on file',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone',
        birthDate: 'Birth date',
        jobTitle: 'Job title',
        position: 'Position',
        language: 'Language',
        userId: 'User ID',
        externalId: 'External ID',
        verified: 'Verified',
        phoneNotVerifiedTooltip:
          'Phone verification status is not yet persisted by the API.'
      },
      workspaceAccess: {
        title: 'Workspace access',
        groups: 'Groups',
        noGroups: 'Not a member of any group',
        subtitle: 'A user has a single workspace role',
        role: 'Workspace role',
        joined: 'Joined',
        headUser: 'Reports to',
        teams: 'Teams',
        noTeams: 'Not assigned to any team',
        roleUpdated: 'Role updated',
        roleFailed: 'Failed to update role',
        headUserUpdated: 'Manager updated',
        headUserPlaceholder: 'Search a member'
      },
      workspaceRoles: {
        title: 'Workspace roles',
        subtitle:
          'This section shows only custom workspace roles. The member’s base role is shown in the Workspace access card.',
        placeholder: 'Select roles',
        empty: 'No custom roles defined in this workspace yet',
        save: 'Save',
        cancel: 'Cancel',
        saveSuccess: 'Roles updated',
        saveFailed: 'Failed to update roles'
      },
      access: {
        tabTitle: 'App access',
        tabSubtitle:
          'One row per workspace app · toggle access and pick a role',
        emptyAllApps: 'This workspace has no applications yet.',
        rolePlaceholder: 'Select role',
        noRoleAvailable: 'No roles available',
        pickRolePrompt: 'Pick a role',
        saveSuccess: 'App access updated',
        saveFailed: 'Could not update app access'
      },
      authentication: {
        title: 'Authentication',
        password: 'Password',
        passwordMeta:
          'Password last-changed date is not yet tracked by the API.',
        managedBySso: 'Managed by SSO',
        mfa: 'Two-factor auth',
        mfaUnknown: 'Enrollment status not exposed yet',
        mfaEnabled: 'Enrolled',
        mfaRequiredTag: 'Required',
        mfaRequiredMeta: 'Multi-factor authentication is required',
        mfaDisabledMeta: 'Not enrolled in multi-factor auth',
        mfaMethod: 'Two-factor method',
        mfaMethodEnrolledMeta: 'Authenticator or email codes set up',
        mfaMethodNotEnrolledMeta: 'No second factor set up yet',
        mfaNotEnrolled: 'Not set up',
        mfaRequire: 'Require two-factor',
        mfaRequireOnMeta: 'Must verify at next sign-in',
        mfaRequireOffMeta: 'Can sign in without a second factor',
        reset: 'Reset',
        emailVerified: 'Email verified',
        ssoProvider: 'SSO provider',
        ssoLinkedMeta: 'Linked · {{id}}',
        ssoNotLinked: 'Not linked',
        sso: 'SSO',
        link: 'Link',
        linked: 'Linked',
        enforce: 'Require',
        disable: 'Stop requiring',
        apiPending: {
          enforceMfa: 'Enforcing MFA — endpoint not wired yet.',
          linkSso: 'Linking SSO — endpoint not wired yet.'
        }
      },
      quickStats: {
        signIns30d: 'Sign-ins · 30d',
        appsUsed: 'Apps used',
        sessions: 'Sessions'
      },
      recentActivity: {
        title: 'Recent activity',
        seeAll: 'See all →',
        empty: 'No recent activity yet.',
        error: 'Recent activity could not be loaded.'
      },
      audit: {
        searchPlaceholder: 'Search events',
        dateRangeLabel: 'Date range',
        empty: 'No audit events recorded for this user yet.',
        noMatches: 'No events match the current filters.',
        filters: {
          allApplications: 'Application',
          allEventTypes: 'Event type',
          allSeverities: 'Severity',
          clear: 'Clear'
        },
        toolbar: {
          events_one: '{{count}} event',
          events_other: '{{count}} events'
        },
        columns: {
          time: 'Time',
          event: 'Event',
          application: 'Application',
          description: 'Description',
          severity: 'Severity',
          ip: 'IP'
        }
      }
    },
    notApiBacked: {
      mfa: 'MFA enrollment status is not yet persisted by the API.'
    },
    breadcrumb: {
      users: 'Users',
      notFound: 'User not found'
    },
    notFound: {
      title: 'User not found',
      subtitle:
        'This user is not a member of this workspace, or the link is out of date.',
      back: 'Back to members'
    },
    editForm: {
      title: 'Edit user',
      cancel: 'Cancel',
      save: 'Save changes',
      saveSuccess: 'User updated',
      saveFailed: 'Failed to update user',
      aboutMe: 'About',
      birthDatePlaceholder: 'Select date',
      manager: 'Manager',
      managerPlaceholder: 'Search a teammate',
      managerHint: 'The person who manages this user.',
      required: {
        firstName: 'First name is required',
        lastName: 'Last name is required'
      }
    },
    addToGroup: {
      action: 'Add to group',
      title: 'Add to a group',
      groupLabel: 'Group',
      groupPlaceholder: 'Select a group',
      groupRequired: 'Pick a group',
      submit: 'Add',
      cancel: 'Cancel',
      success: 'Added to the group',
      noGroups: 'No groups available — create one in the Groups tab first.'
    },
    addToTeam: {
      action: 'Add to team',
      title: 'Add to a team',
      teamLabel: 'Team',
      teamPlaceholder: 'Select a team',
      teamRequired: 'Pick a team',
      submit: 'Add',
      cancel: 'Cancel',
      noTeams: 'No teams available — create one in Organization first.'
    }
  },
  workspaceHome: {
    chatPlaceholder: 'Ask Skalx AI about users, security, apps or audits…',
    welcome: {
      title: 'What would you like to do?',
      subtitle:
        'Skalx AI can investigate users, audit access, run security reports and configure your workspace. It only acts on what you can already see.'
    },
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
      late: 'Burning the midnight oil',
      fallbackName: 'there'
    },
    suggestions: {
      owner: {
        admins: 'Who has admin access?',
        securityReview: 'Review workspace security',
        accessChanges: 'Who changed access lately?',
        orgChart: 'Show the org chart'
      },
      admin: {
        members: 'Show members and their roles',
        inviteMember: 'Invite a new member',
        signInMethods: 'Which sign-in methods are on?',
        accessChanges: 'Who changed access lately?'
      },
      employee: {
        myTeam: 'Who is on my team?',
        orgChart: 'Who reports to whom?',
        myApps: 'Which apps can I open?',
        myAccess: 'What access do I have?'
      }
    },
    composer: {
      send: 'Send',
      stop: 'Stop'
    },
    streaming: {
      thinking: 'Skalx AI is thinking…',
      cycle: {
        thinking: 'Thinking',
        reasoning: 'Reasoning',
        searching: 'Searching',
        analyzing: 'Analyzing',
        crunching: 'Crunching',
        looking_up: 'Looking it up',
        connecting: 'Connecting the dots',
        almost_ready: 'Almost ready'
      }
    },
    feedback: {
      helpful: 'Helpful',
      notHelpful: 'Not helpful',
      failed: "Couldn't save your rating"
    },
    copy: {
      copy: 'Copy',
      copied: 'Copied',
      failed: "Couldn't copy"
    },
    timeline: {
      thinking: 'Thinking…',
      thoughts: 'Thoughts',
      working: 'Working steps',
      request: 'Request',
      response: 'Response'
    },
    approval: {
      title: 'This action needs your approval',
      actionRequest: 'Action needs approval',
      toolLabel: 'Requested action:',
      destructive: 'Destructive',
      noDetails: 'No additional details.',
      approve: 'Approve',
      always: 'Always approve',
      alwaysHint: 'Always run {{tool}} for this agent without asking again.',
      reject: 'Reject',
      approved: 'Approved',
      rejected: 'Rejected',
      severityHint: "The agent's own read of how risky this action is.",
      severity: {
        none: 'No risk',
        low: 'Low risk',
        medium: 'Medium risk',
        high: 'High risk',
        critical: 'Critical risk'
      },
      confidenceLabel: 'Confidence',
      confidenceHint:
        'How sure the agent is that this is the right action to take.',
      whatWillHappen: 'What will happen'
    },
    question: {
      clarification: 'Needs a clarification',
      questionLabel: 'Question',
      selected: 'Answered',
      otherButton: 'Other',
      otherPlaceholder: 'Or type your own answer…',
      submit: 'Submit',
      answered: 'Answered'
    },
    scrollToBottom: 'Scroll to latest',
    attachments: {
      attach: 'Attach files',
      remove: 'Remove file',
      retry: 'Retry upload',
      uploadFailed: 'Upload failed. Try again.',
      uploading: 'Uploading {{name}}',
      open: 'Open',
      download: 'Download',
      fromYou: 'You',
      fromAgent: 'Agent',
      empty: 'No files in this chat yet',
      loadError: "Couldn't load files.",
      retryLoad: 'Retry',
      unavailable: 'This file is not available yet',
      sendRefused:
        "These files can't be sent with this message. Remove them and attach again.",
      problems: {
        unsupported: 'This file type is not supported',
        too_large: 'Images up to 5 MB, other files up to 20 MB',
        too_many: 'Up to 10 files per message'
      }
    },
    files: {
      open: 'Files',
      title: 'Chat files'
    },
    history: {
      title: 'Chat history',
      back: 'Back to start',
      newChat: 'New chat',
      hide: 'Hide history',
      searchPlaceholder: 'Search chats…',
      today: 'Today',
      yesterday: 'Yesterday',
      older: 'Older',
      empty: 'No conversations yet',
      noResults: 'No chats match your search',
      delete: 'Delete conversation',
      deleteConfirm: 'Delete this conversation?',
      processing: 'The agent is working on this chat',
      awaitingInput: 'This chat is waiting for your input'
    },
    errors: {
      notConfiguredTitle: 'AI assistant not configured',
      notConfigured:
        'Set VITE_APP_SQUAD_AGENT_ID (and VITE_APP_SQUAD_API) in your environment to enable the assistant. The current build has no Squad agent configured.',
      stopped: 'Stopped.',
      empty: 'The agent returned no response.',
      approvalRequired:
        'This action needs your approval before it can continue.',
      generic: 'Could not reach the AI assistant. Please try again.',
      questionPending: "Answer the agent's question first, then send the files."
    }
  },
  workspaceOverview: {
    title: 'Welcome to {{workspace}}',
    subtitle: "This is your team's home. Pick a section below to get started.",
    fallbackWorkspace: 'your workspace',
    inviteCta: 'Invite teammates',
    primaryCta: 'Invite teammates',
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
      late: 'Up late',
      fallbackName: 'there'
    },
    demo: {
      label: 'Demo',
      expired: 'expired',
      daysLeft_one: '{{count}} day left',
      daysLeft_other: '{{count}} days left',
      endsOn: 'Demo access ends {{date}}',
      noExpiry: 'No expiration date',
      noExpiryTooltip: 'Expiration date is not set'
    },
    sections: {
      stats: 'Workspace stats',
      shortcuts: 'Shortcuts',
      activity: 'Recent activity'
    },
    companyGraph: {
      title: 'Company Graph',
      preview: 'Preview',
      subtitle: '{{count}} connected resources · live view',
      pageDescription:
        'A living map of your workspace — resources, connections, and live activity.',
      details: 'Details',
      recentActivity: 'Recent activity',
      connections: 'Connections',
      liveActivity: 'Live activity',
      noActivity: 'No recent activity',
      sample: 'Sample data',
      close: 'Close',
      active: 'Active',
      lastActive: 'Last active',
      needsAttention: 'Needs attention',
      allClear: 'All clear — nothing needs attention',
      viewDetails: 'View details',
      highlights: 'Highlights',
      liveEvents: 'Live events',
      noEdgeEvents: 'No events on this connection yet',
      tabs: {
        graph: 'Graph',
        activity: 'Activity',
        aiInsights: 'AI Insights'
      },
      filters: {
        allActors: 'Actor',
        allEntities: 'Type',
        search: 'Search activity…'
      },
      feedEmpty: 'No activity matches your filters',
      insights: {
        latestChanges: 'Latest changes',
        suggested: 'Try asking',
        greeting:
          'Ask me about your company activity — deals, leads, email, or time off.',
        askPlaceholder: 'Ask about leads, deals, email…',
        send: 'Send',
        thinking: 'Thinking…',
        period: {
          today: 'Today',
          '7d': '7 days',
          '30d': '30 days'
        }
      },
      legend: {
        company: 'Company',
        database: 'Databases',
        email: 'Email',
        app: 'Apps',
        user: 'Users',
        agent: 'AI Agents'
      },
      kpi: {
        activeSessions: 'Active sessions',
        eventsPerMin: 'Events / min',
        agentsRunning: 'Agents running',
        openAlerts: 'Open alerts'
      },
      events: {
        backupDone: 'Automated backup completed',
        slowQuery: 'Slow query > 2s logged',
        failoverPassed: 'Failover test passed',
        emailsSent: 'Batch of emails sent',
        emailBounced: 'Email bounced (invalid address)',
        mailboxSynced: 'Mailboxes synced',
        ticketsResolved: 'Resolved support tickets',
        agentRetry: 'Retried after API 429',
        recordsSynced: 'Records synced',
        memberInvited: 'Invited a new member',
        appDeploy: 'Deployment succeeded',
        appSession: 'New sessions started',
        userSignin: 'Signed in',
        userToken: 'Rotated access token',
        agentCalledApp: 'called {{target}}',
        agentSyncedData: 'synced data to {{target}}',
        appQueriedDb: 'queried {{target}}',
        appSentEmail: 'sent mail via {{target}}',
        sentData: 'sent data to {{target}}'
      }
    },
    hero: {
      domain: 'Primary domain',
      created: 'Created',
      role: 'Your role',
      manage: 'Manage settings',
      openWorkspace: 'Open workspace',
      noDomain: 'No domain set'
    },
    signInActivity: {
      title: 'Sign-in activity',
      subtitle: 'Last 30 days · UTC',
      signIns: 'Sign-ins · 30d',
      avgPerDay: 'Avg per day',
      failed: 'Failed',
      uniqueUsers: 'Unique users',
      legendSignIns: 'Sign-ins',
      legendFailures: 'Failures'
    },
    securitySignals: {
      title: 'Security signals',
      viewAll: 'View all'
    },
    appsHealth: {
      title: 'Applications health',
      subtitle: 'Real-time uptime and request volume per app',
      manage: 'Manage apps',
      sessions: 'Sessions',
      errorRate: 'Error rate',
      p95: 'P95'
    },
    planUsage: {
      title: 'Plan & usage',
      upgrade: 'Upgrade'
    },
    details: {
      title: 'Workspace details',
      manage: 'Manage settings',
      name: 'Name',
      domain: 'Primary domain',
      created: 'Created',
      role: 'Your role',
      stats: {
        members: 'Members',
        apps: 'Apps',
        roles: 'Roles',
        authMethods: 'Auth methods enabled',
        mfaCoverage: 'MFA coverage'
      }
    },
    tiles: {
      users: 'Members and teams in this workspace',
      roles: 'Permissions and role assignments',
      apps: 'Connected applications',
      security: 'SSO, SAML and sign-in policy',
      apiKeys: 'Workspace API keys',
      audit: 'Recent administrative activity'
    },
    activity: {
      title: 'Recent activity',
      viewAll: 'Open audit log',
      systemActor: 'System',
      emptyTitle: 'No activity yet',
      emptyDescription:
        'Activity from your team will appear here as soon as people start working.'
    }
  },
  home: {
    greeting: 'Hi {{name}}, what do you want to make?',
    chatPlaceholder: 'Describe your idea, Agent will bring it to life...',
    chatHint: 'AI assistant for auth and workspace setup',
    send: 'Plan',
    suggestionsTitle: 'Suggested starters',
    suggestions: {
      sso: {
        title: 'Set up workspace SSO',
        description:
          'Enable Google and Entra ID sign-in for your workspace members.'
      },
      invite: {
        title: 'Create onboarding workspace',
        description: 'Start a clean workspace or use built-in apps and presets.'
      },
      security: {
        title: 'Strengthen account security',
        description:
          'Review personal auth methods and enforce stronger sign-in policies.'
      }
    }
  },
  credentials: {
    optional: 'optional',
    reasonLabel: 'Reason',
    reasonPlaceholder: 'Why is this credential being revoked?',
    newExpiryLabel: 'New expiry',
    newExpiryPlaceholder: 'No expiry',
    revokeOldLabel: 'Revoke the previous credential'
  },
  workspace: {
    credentials: {
      status: {
        active: 'Active',
        revoked: 'Revoked',
        expired: 'Expired'
      },
      columns: {
        status: 'Status',
        expires: 'Expires',
        lastUsed: 'Last used',
        created: 'Created',
        createdBy: 'Created by',
        id: 'Credential ID'
      },
      noExpiry: 'Never',
      neverUsed: 'Never used',
      revokedReason: 'Reason: {{reason}}',
      revokedAt: 'Revoked {{at}}',
      noPermissions: 'No permissions granted for this app.',
      appSummary: '{{permissions}} permissions across {{resources}} resources',
      tokenReveal: {
        title: 'Copy your API key now',
        body: 'This is the only time the key will be shown. Store it in a secure place — once you leave or reload this page, it cannot be recovered.',
        done: 'I have saved the key'
      },
      quickStart: {
        title: 'Quick start',
        intro:
          'Send the key in the Authorization header of every request. Each bound app owns its own endpoints, request bodies, and responses — see the app docs for details.',
        copy: 'Copy example',
        docs: 'API documentation',
        endpointHint:
          'Replace <APP_ENDPOINT> with the endpoint from your app’s docs. Each bound app defines its own routes and payload shape.',
        tokenHint:
          'The token is shown only once at creation. Replace <YOUR_API_TOKEN> with the value you saved when the credential was created.',
        tips: {
          storage:
            'Store the key in a secret manager or a server-side environment variable — never commit it to source control.',
          transport: 'Only send the key over HTTPS.',
          rotate:
            'Rotate the key on a schedule or immediately if it may have leaked.',
          scope:
            'Grant the smallest set of permissions and app bindings the caller actually needs.'
        }
      }
    },
    aiConnectors: {
      sectionTitle: 'AI connectors',
      sectionDescription:
        'Connect Claude, ChatGPT, Gemini, Cursor and other AI clients to this workspace. Each connection acts as you and never gets more than your own permissions.',
      services: {
        core: {
          name: 'Core',
          description: 'Members, teams, roles and workspace settings.'
        },
        crm: {
          name: 'CRM',
          description: 'Contacts, companies, leads, deals and tasks.'
        },
        notification: {
          name: 'Notifications',
          description: 'Your notifications and their read state.'
        },
        squad: {
          name: 'Squad',
          description: 'AI agents, their runs, approvals and memory.'
        }
      },
      clients: {
        claude: 'Claude (web / desktop)',
        claudeCode: 'Claude Code',
        chatgpt: 'ChatGPT',
        geminiCli: 'Gemini CLI',
        cursor: 'Cursor',
        vscode: 'VS Code',
        other: 'Other (token)'
      },
      connect: {
        serviceStep: 'Service',
        clientStep: 'AI client',
        instructionsStep: 'Connect',
        chooseService: 'Which service should the AI client reach?',
        chooseClient: 'Which AI client do you use?',
        noServices:
          'No service is available to you yet. Ask a workspace admin to enable one in AI connectors.',
        mcpUrl: 'MCP server URL',
        mcpUrls: 'MCP server URLs',
        repeatPerUrl: 'Add one connector per URL above.',
        tokenOneService:
          'A personal token is issued for one service. Pick a single service to use one.',
        snippetTitle: 'Configuration',
        copy: 'Copy',
        copied: 'Copied',
        copyFailed: "Couldn't copy. Select the text and copy it manually.",
        tokenLocked:
          'Copy your token before you continue. Dismiss it to choose another service or client.',
        oauthHint:
          'On first use the client opens a Skalx page: sign in, choose this workspace and allow access.',
        steps: {
          claude: {
            s1: 'In Claude, open Settings → Connectors.',
            s2: 'Click “Add custom connector”.',
            s3: 'Paste the MCP server URL, click Add, then Connect.'
          },
          chatgpt: {
            s1: 'In ChatGPT, open Settings → Apps & Connectors.',
            s2: 'Turn on Developer mode in the advanced settings.',
            s3: 'Click Create, paste the MCP server URL and choose OAuth as the authentication.'
          },
          claudeCode: {
            s1: 'Run this in your terminal.',
            s2: 'Start Claude Code, run /mcp and sign in to {{server}}.'
          },
          geminiCli: {
            s1: 'Add this to ~/.gemini/settings.json.',
            s2: 'Restart Gemini CLI and run /mcp auth {{server}} to sign in.'
          },
          cursor: {
            s1: 'Add this to ~/.cursor/mcp.json (or .cursor/mcp.json in a project).',
            s2: 'Open Cursor Settings → MCP and sign in to {{server}} when asked.'
          },
          vscode: {
            s1: 'Add this to .vscode/mcp.json in your project.',
            s2: 'Start {{server}} from that file and sign in when VS Code asks.'
          },
          other: {
            s1: 'Issue a personal token below. It is shown only once.',
            s2: 'Add the server to your client and send the token in the Authorization header.'
          }
        },
        serviceOff: 'Off in this workspace.',
        adminServicesHint:
          'Turn a service on to let members connect AI clients to it. Turning it off disconnects every client.',
        waitingTitle: 'Waiting for the AI client…',
        waitingBody:
          'Finish the steps above and allow access on each Skalx page that opens. This step completes by itself once the client is connected.',
        connectedTitle: 'Connected',
        connectedBody: '{{name}} can now use {{services}} in this workspace.',
        done: 'Done',
        open: 'Connect',
        title: 'Connect an AI client',
        closeWithTokenTitle: 'Close without saving the token?',
        closeWithTokenBody:
          'The personal token is shown only once. Copy it before you close, or issue a new one later.',
        closeWithTokenOk: 'Close'
      },
      pat: {
        noScopes: 'This service has no scopes in the catalog yet.',
        title: 'Personal token',
        intro:
          'For clients without OAuth. The token acts as you, is limited to the scopes you pick and expires on the date you set.',
        name: 'Name',
        namePlaceholder: 'e.g. Laptop script',
        nameRequired: 'Enter a name',
        expiresAt: 'Expires on',
        expiresRequired: 'Choose an expiry date within one year',
        scopes: 'Scopes',
        issue: 'Issue token',
        placeholderHint:
          'Replace <YOUR_PERSONAL_TOKEN> with the token you issue above.'
      },
      connections: {
        columns: {
          client: 'Client',
          user: 'User',
          service: 'Service',
          scopes: 'Scopes',
          status: 'Status',
          created: 'Created',
          lastUsed: 'Last used'
        },
        kind: {
          oauth: 'OAuth',
          pat: 'Personal token'
        },
        scopesCount_one: '{{count}} scope',
        scopesCount_other: '{{count}} scopes',
        revokeReasons: {
          user: 'Revoked by the user',
          admin: 'Revoked by an admin',
          policy_disabled: 'Service turned off',
          personal_tokens_disabled: 'Personal tokens turned off',
          client: 'Revoked by the AI client',
          refresh_reuse: 'Token reuse detected',
          membership_removed: 'Removed from the workspace',
          membership_blocked: 'Suspended in the workspace',
          app_access_removed: 'App access removed'
        },
        countLabel: 'connections',
        filters: {
          service: 'All services',
          user: 'All users'
        },
        empty:
          'No AI client is connected to this workspace yet. Click Connect to add one.',
        emptyMine:
          'You have not connected an AI client yet. Click Connect to add one.',
        revoke: 'Revoke',
        revokeTitle: 'Revoke this connection?',
        revokeBody:
          'The AI client loses access within seconds. To use it again, connect it again.',
        revoked: 'Connection revoked',
        editScopes: 'Scopes',
        scopesTitle: 'Scopes of {{name}}',
        scopesHint:
          'What this connection may do. It never gets more than your own permissions in the service.',
        scopesSave: 'Save',
        scopesSaved: 'Scopes updated'
      },
      servicesTab: {
        enabledAria: 'Enable {{service}} for AI clients',
        empty: 'No AI connector services are available in this workspace yet.',
        needsInstance: 'Install {{service}} in this workspace to enable it.',
        notConfigured:
          'Not configured for this environment. {{service}} cannot be enabled until it is set up.',
        saved: 'Service updated',
        disableTitle: 'Turn off {{service}} for AI clients?',
        disableBody:
          'Every connection and personal token for this service stops working within seconds.',
        disable: 'Turn off'
      },
      consent: {
        title: '{{client}} wants to access your Skalx data',
        unverified: 'Unverified',
        unverifiedHint:
          'Skalx has not verified this client. Allow only if you started this connection yourself.',
        redirectsTo: 'You will return to {{host}}.',
        service: 'Service',
        workspace: 'Workspace',
        workspacePlaceholder: 'Choose a workspace',
        scopes: 'It will be able to',
        noScopes: 'Sign in only, no data access.',
        actsAsYou:
          'The client acts as you and never gets more than your own permissions.',
        noWorkspaceTitle: 'No workspace allows this connection',
        noWorkspaceBody:
          '{{service}} is not enabled for AI clients in any workspace you can use. Ask a workspace admin to enable it in AI connectors, then connect again.',
        expiredTitle: 'This request has expired',
        expiredBody:
          'Go back to your AI client and start the connection again.',
        allow: 'Allow',
        deny: 'Deny'
      }
    },
    publicAccess: {
      sectionTitle: 'Public access credentials',
      sectionDescription:
        'Tokens that grant public (unauthenticated) access to selected apps and their permissions. The token is shown only once at creation or rotation — copy it then and store it securely.',
      create: 'Create credential',
      createDrawerTitle: 'New public access credential',
      editDrawerTitle: 'Edit public access credential',
      rotate: 'Rotate',
      revoke: 'Revoke',
      namePlaceholder: 'e.g. Public booking widget',
      expiresAt: 'Expires at',
      expiresAtPlaceholder: 'No expiration',
      noExpiry: 'Never',
      neverUsed: 'Never used',
      empty: 'No public access credentials yet.',
      revokedReason: 'Reason: {{reason}}',
      revokedAt: 'Revoked {{at}}',
      rotateConfirmTitle: 'Rotate credential?',
      rotateConfirmBody:
        'A new token will be issued. The current credential keeps working unless you revoke it below.',
      revokeConfirmTitle: 'Revoke credential?',
      revokeConfirmBody:
        'This token will stop working for all integrations using it. This action cannot be undone.',
      toolbar: {
        count_one: '{{count}} credential',
        count_other: '{{count}} credentials',
        credentialsLabel: 'credentials'
      },
      status: {
        active: 'Active',
        revoked: 'Revoked',
        expired: 'Expired'
      },
      columns: {
        name: 'Name',
        apps: 'Apps',
        appsCount_one: '{{count}} app',
        appsCount_other: '{{count}} apps',
        status: 'Status',
        expires: 'Expires',
        lastUsed: 'Last used',
        actions: 'Actions'
      },
      bindings: {
        label: 'App access',
        addApp: 'Add app',
        removeApp: 'Remove app',
        appPlaceholder: 'Select app',
        permissionsPlaceholder: 'Select permissions',
        permissionCount_one: '{{count}} permission',
        permissionCount_other: '{{count}} permissions',
        required: 'Add at least one app.',
        unbindableApp: "A selected app can't be bound (missing identifier).",
        none: 'No apps bound.'
      },
      messages: {
        updated: 'Credential updated',
        revoked: 'Credential revoked',
        rotated: 'Credential rotated'
      },
      detail: {
        back: 'Back to Public access credentials',
        tokenReveal: {
          title: 'Copy your API key now',
          body: 'This is the only time the key will be shown. Store it in a secure place — once you leave or reload this page, it cannot be recovered.',
          done: 'I have saved the key'
        },
        overview: {
          title: 'Overview',
          id: 'Credential ID',
          created: 'Created',
          createdBy: 'Created by',
          noPermissions: 'No permissions granted for this app.',
          resourceCount_one: '{{count}} resource',
          resourceCount_other: '{{count}} resources',
          appSummary:
            '{{permissions}} permissions across {{resources}} resources'
        },
        quickStart: {
          title: 'Quick start',
          intro:
            'Send the key in the Authorization header of every request. Each bound app owns its own endpoints, request bodies, and responses — see the app docs for details.',
          copy: 'Copy example',
          endpointHint:
            'Replace <APP_ENDPOINT> with the endpoint from your app’s docs. Each bound app defines its own routes and payload shape.',
          tokenHint:
            'The token is shown only once at creation. Replace <YOUR_API_TOKEN> with the value you saved when the credential was created.',
          tips: {
            storage:
              'Store the key in a secret manager or a server-side environment variable — never commit it to source control.',
            transport: 'Only send the key over HTTPS.',
            rotate:
              'Rotate the key on a schedule or immediately if it may have leaked.',
            scope:
              'Grant the smallest set of permissions and app bindings the caller actually needs.'
          }
        }
      }
    },
    tab: {
      overview: 'Overview',
      users: 'Users',
      members: 'Users',
      roles: 'Roles',
      security: 'Security',
      ssoScim: 'SSO / SCIM',
      domains: 'Domains',
      agents: 'Agents',
      audit: 'Audit',
      billing: 'Billing & usage'
    },
    overviewPage: {
      sectionTitle: 'Overview',
      sectionDescription:
        'Summary of this workspace, quick stats, and shortcuts to common settings.',
      workspaceId: 'Workspace ID',
      primaryDomain: 'Primary domain',
      created: 'Created',
      statMembers: 'Members',
      statApps: 'Apps',
      statRoles: 'Roles',
      statAuthMethods: 'Auth methods',
      statSsoScim: 'SSO / SCIM',
      statApiKeys: 'API keys',
      platformModel: 'Platform model',
      platformModelValue:
        'This workspace acts as the identity core for members, providers, security policy, and app access.',
      appPortfolio: 'App portfolio',
      appPortfolioValue:
        '{{builtIn}} built-in and {{custom}} custom apps currently consume the workspace core across {{count}} configured apps.',
      identityCoverage: 'Identity coverage',
      identityCoverageValue:
        '{{authMethods}} sign-in methods, {{roles}} roles, {{sso}} SSO connections, and {{scim}} SCIM sync points are active in this workspace.',
      apiSurface: 'API surface',
      apiSurfaceValue:
        '{{apiKeys}} workspace API keys support automation across {{apps}} app integrations.',
      platformHealth: 'Platform health',
      platformHealthSso: 'SSO',
      platformHealthScim: 'SCIM',
      platformHealthMfa: 'MFA adoption',
      platformHealthApiKeysExpiring: 'API keys expiring',
      platformHealthConnected: '{{count}} connected',
      platformHealthNotConfigured: 'Not configured',
      platformHealthSyncActive: 'Sync active',
      platformHealthExpiresSoon: 'Expires within 30 days',
      goToMembers: 'Manage members',
      goToApps: 'View apps',
      goToSecurity: 'Security settings'
    },
    membersPage: {
      sectionDescription: 'Workspace users, invitations, app access and roles.'
    },
    membersTeams: {
      /** Section title above a table: e.g. "Members (12)" */
      listTitleWithCount: '{{label}} ({{count}})',
      tabs: {
        members: 'Members',
        teams: 'Teams',
        divisions: 'Divisions',
        departments: 'Departments'
      },
      teamsCardTitle: 'Workspace teams',
      teamsCardDescription:
        'Create teams, group members by function, and attach organization roles to those team memberships.',
      teamMembersTitle: 'Team memberships',
      createTeam: 'Create team',
      manageTeam: 'Manage team',
      assignMember: 'Assign member',
      createRole: 'Create team role',
      assignMemberTitle: 'Assign member to team',
      editMemberRolesTitle: 'Edit team roles',
      createRoleTitle: 'Create team role',
      editRoleTitle: 'Edit team role',
      createTeamModalTitle: 'Create workspace team',
      deleteConfirm: 'Delete this team?',
      deleteRoleConfirm: 'Delete this team role?',
      removeMemberConfirm: 'Remove this member from the team?',
      selectTeam: 'Select a team to manage its members and roles.',
      emptyTeams: 'No teams yet.',
      emptyTeamRoles: 'No team roles yet.',
      emptyTeamMembers: 'No members assigned to this team yet.',
      childTeam: 'Child team',
      headRole: 'Head role',
      membersCount: '{{count}} members',
      columns: {
        team: 'Team',
        type: 'Type',
        members: 'Members',
        teams: 'Teams',
        actions: 'Actions'
      },
      membersColumns: {
        member: 'Member',
        roles: 'Roles',
        permissions: 'Permissions',
        actions: 'Actions'
      },
      roleColumns: {
        role: 'Role',
        permissions: 'Permissions',
        actions: 'Actions'
      },
      form: {
        teamName: 'Team name',
        teamType: 'Team type',
        abbreviation: 'Abbreviation',
        parentTeam: 'Parent team',
        member: 'Member',
        teamRoles: 'Team roles',
        roleName: 'Role name',
        headRole: 'Head role',
        permissionGroup: 'Permission group',
        application: 'Application',
        permissions: 'Permissions'
      },
      teamRolesTitle: 'Team roles',
      addPermissionGroup: 'Add permission group',
      teamType: {
        branch: 'Branch',
        department: 'Department',
        section: 'Section'
      },
      messages: {
        teamCreated: 'Team created successfully',
        teamDeleted: 'Team deleted successfully',
        roleCreated: 'Team role created',
        roleUpdated: 'Team role updated',
        roleDeleted: 'Team role deleted',
        memberAssigned: 'Member assigned to team',
        membershipUpdated: 'Team roles updated',
        memberRemoved: 'Member removed from team'
      }
    },
    orgChart: {
      tabTitle: 'Org Chart',
      types: {
        company: 'Company',
        division: 'Division',
        department: 'Department',
        team: 'Team'
      },
      membersLabel: 'members',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      resetView: 'Reset view',
      collapseHint: 'Click to collapse/expand',
      memberTable: {
        name: 'Name',
        role: 'Role',
        email: 'Email',
        joined: 'Joined'
      },
      mockNotice:
        'Sample data for layout and flows. It resets on full page reload and is not synced to the API yet.',
      organization: 'Organization',
      backToMembers: 'Back to members',
      notFound: 'This item is no longer in the sample directory.',
      actions: {
        manage: 'Manage',
        edit: 'Edit',
        open: 'Actions',
        view: 'View'
      },
      columns: {
        name: 'Name',
        owner: 'Responsible',
        roles: 'Roles',
        division: 'Division',
        department: 'Department',
        departments: 'Departments',
        teams: 'Teams',
        members: 'Members',
        actions: 'Actions'
      },
      fields: {
        name: 'Name',
        abbreviation: 'Abbreviation',
        abbreviationHelp: 'Uppercase letters only, 2-10 characters',
        description: 'Description',
        owner: 'Responsible',
        ownerPlaceholder: 'Select responsible person',
        parent: 'Parent',
        parentDivision: 'Division',
        department: 'Department'
      },
      divisions: {
        hint: 'Divisions sit under the workspace. They group departments; there is no parent selector because the workspace is the parent.',
        add: 'Add division',
        drawerTitle: 'Add division',
        editDrawerTitle: 'Edit division',
        deleteConfirm:
          'Delete this division? Departments under it will become unassigned.'
      },
      division: {
        departmentsTableTitle: 'Departments in this division',
        departmentsTableHint:
          'Open a department to manage its teams, or add a new one under this division.',
        addDepartmentDrawerTitle: 'Add department to this division'
      },
      departments: {
        hint: 'Departments may optionally belong to a division. Teams must belong to a department.',
        add: 'Add department',
        drawerTitle: 'Add department',
        editDrawerTitle: 'Edit department',
        divisionPlaceholder: 'Optional — assign to a division',
        noDivision: 'No division',
        deleteConfirm:
          'Delete this department? Teams under it will become unassigned.'
      },
      department: {
        teamsTableTitle: 'Teams in this department',
        teamsTableHint:
          'Teams always sit under a department. Open one to manage memberships.',
        addTeamDrawerTitle: 'Add team to this department'
      },
      teams: {
        hint: 'Teams always belong to a department. Pick the department when creating a team.',
        add: 'Add team',
        drawerTitle: 'Add team',
        editDrawerTitle: 'Edit team',
        deleteConfirm: 'Delete this team? Members will be unassigned.'
      },
      team: {
        membersTableTitle: 'Team members',
        membersTableHint:
          'Workspace members assigned to this team. Remove access or invite more from the Members tab.',
        addMember: 'Add members',
        addMemberDrawerTitle: 'Add members to team',
        selectMember: 'Member',
        selectMembers: 'Workspace members',
        selectMembersPlaceholder: 'Select one or more members',
        removeMember: 'Remove',
        removeMemberConfirm: 'Remove this member from the team?'
      },
      memberDetail: {
        email: 'Email',
        phone: 'Phone',
        location: 'Location',
        joinedAt: 'Joined workspace',
        manager: 'Manager',
        sectionAccess: 'Workspace access',
        permissions: 'Permissions',
        permissionsEmpty: 'No permissions recorded for this sample member.',
        sectionFunctions: 'Role & functions',
        jobTitle: 'Job title',
        functions: 'Functions',
        functionsEmpty: 'No functions assigned.',
        sectionTeams: 'Teams',
        teamsEmpty: 'Not assigned to any team yet.',
        appAccess: {
          sectionTitle: 'App access',
          selectRole: 'Select a role',
          noRoleAvailable: 'No role available',
          emptyState: 'No applications in this workspace yet.',
          permissionsUpdated: 'App access updated'
        }
      },
      nodeDetail: {
        owner: 'Responsible',
        members: 'Members',
        childUnits: 'Direct units',
        directReports: 'Direct reports'
      },
      invites: {
        title: 'Invitations',
        description:
          'Manage pending invitations to your workspace. Invited users will receive an email to join.',
        empty: 'No pending invitations.',
        inviteButton: 'Invite by email',
        drawerTitle: 'Invite people',
        submit: 'Send invites',
        emailsPlaceholder: 'Type or paste emails, separated by comma or space',
        fields: {
          emails: 'Email addresses',
          manager: 'Manager',
          teams: 'Teams',
          team: 'Team'
        },
        teamPlaceholder: 'Optional — one team per invite',
        columns: {
          emails: 'Emails',
          manager: 'Manager',
          teams: 'Teams',
          status: 'Status',
          invitedAt: 'Invited',
          actions: 'Actions'
        },
        actions: {
          resend: 'Resend invite',
          revoke: 'Mark expired'
        }
      },
      inviteStatus: {
        pending: 'Pending',
        expired: 'Expired',
        accepted: 'Accepted'
      },
      members: {
        title: 'Members',
        hint: 'Active people in this workspace sample. Block or unblock without leaving the table.',
        addButton: 'Add member',
        drawerTitle: 'Add member',
        submit: 'Add member',
        notFound: 'No results for "{{keyword}}"',
        notFoundHint:
          'This person is not in the system yet. Send an invite to create their account.',
        fields: {
          name: 'Full name',
          email: 'Email',
          role: 'Workspace role',
          manager: 'Manager',
          teams: 'Teams',
          team: 'Team'
        },
        teamPlaceholder: 'Optional — one team per member',
        columns: {
          name: 'Name',
          email: 'Email',
          role: 'Role',
          manager: 'Manager',
          teams: 'Teams',
          status: 'Status',
          actions: 'Actions'
        },
        actions: {
          block: 'Block member',
          unblock: 'Unblock member'
        }
      },
      memberStatus: {
        active: 'Active',
        inactive: 'Inactive',
        blocked: 'Blocked',
        invited: 'Invited'
      },
      workspaceRole: {
        owner: 'Owner',
        admin: 'Admin',
        employee: 'Member'
      },
      validation: {
        emailsRequired: 'Add at least one email address.',
        nameRequired: 'Enter a name.',
        departmentRequired: 'Select the department for this team.',
        membersRequired: 'Select at least one member.',
        organizationNotReady: 'Workspace is still loading, please try again.'
      },
      messages: {
        divisionAdded: 'Division added.',
        divisionUpdated: 'Division updated.',
        departmentAdded: 'Department added.',
        departmentUpdated: 'Department updated.',
        teamAdded: 'Team added.',
        teamUpdated: 'Team updated.',
        inviteCreated: 'Invitation recorded.',
        inviteResent: 'Invitation resent.',
        inviteRevoked: 'Invitation marked expired.',
        memberAdded: 'Member added.',
        memberBlocked: 'Member blocked.',
        memberUnblocked: 'Member unblocked.',
        memberAddedToTeam: 'Member added to team.',
        membersAddedToTeam: 'Members added to team.',
        memberRemovedFromTeam: 'Member removed from team.',
        divisionDeleted: 'Division deleted.',
        departmentDeleted: 'Department deleted.',
        teamDeleted: 'Team deleted.',
        memberUpdated: 'Member updated.'
      }
    },
    billingPage: {
      sectionTitle: 'Billing & usage',
      sectionDescription:
        'Workspace-level usage preview. Detailed subscription management may use account billing when connected.',
      goToAccountBilling: 'Open account billing',
      usageTitle: 'Usage overview',
      period: {
        current: 'This month',
        previous: 'Last month',
        quarter: 'Last quarter'
      },
      overageWarning:
        'High usage detected for {{period}}. Some metrics are approaching their limits.'
    },
    users: {
      stub: 'Workspace member management will be available here.',
      openDirectory: 'Open user directory',
      memberTableTitle: 'Workspace members',
      memberCountSuffix: 'members',
      columns: {
        member: 'Member',
        role: 'Role',
        status: 'Status',
        joinedAt: 'Joined at',
        actions: 'Actions'
      },
      status: {
        active: 'Active',
        invited: 'Invited',
        suspended: 'Suspended'
      },
      remove: 'Remove',
      removeConfirm: 'Remove this member from workspace?',
      invite: {
        nameLabel: 'Full name',
        email: 'User email',
        roleLabel: 'Role',
        submit: 'Invite user',
        success: 'Invitation sent successfully',
        modalTitle: 'Invite member',
        openButton: 'Invite member',
        manager: 'Manager (optional)',
        role: 'Role'
      }
    },
    billing: {
      mockNotice:
        'Usage figures below are sample data for the UI. They will connect to your billing API when available.',
      period: 'Billing period',
      apiRequests: 'API requests',
      storageGb: 'Storage',
      aiTokensUsed: 'AI tokens used',
      aiTokensLimit: 'AI token allowance'
    },
    agents: {
      title: 'Agents',
      description:
        'Register AI agents as governed, tenant-scoped identities. Grant least-privilege access to apps, broker their access to external tools, then rotate, revoke, and audit them.',
      mockNotice:
        'Preview data — agents, connections, and tokens are stored in the local mock. Token issuance and external OAuth handshakes are simulated until the backend lands.',
      register: 'Register agent',
      empty:
        'No agents yet. Register one to give an AI agent scoped access to your apps and tools.',
      moreScopes: '+{{count}} more',
      kpi: {
        agents: 'Agents',
        active: 'Active',
        delegated: 'Delegated',
        expiringSoon: 'Expiring soon',
        pendingApprovals: 'Pending approvals'
      },
      visibility: {
        private: 'Private',
        public: 'Public',
        restricted: 'Restricted'
      },
      tier: {
        system: 'System',
        template: 'Template',
        workspace: 'Workspace',
        personal: 'Personal'
      },
      restricted: {
        label: 'Restricted'
      },
      runAs: {
        shareWarning: {
          title: 'Your automations will keep running as you',
          body: 'This agent carries {{count}} of your triggers ({{schedules}} scheduled, {{channels}} webhook, {{widgets}} widget). Once it is open to the workspace, colleagues can change what it does — and those runs will still use your permissions.',
          confirm: 'Share anyway',
          cancel: 'Keep restricted'
        }
      },
      toolExecution: {
        ask: 'Ask before running tools',
        auto: 'Run tools autonomously'
      },
      delete: {
        confirmTitle: 'Delete agent?',
        confirmBody:
          '“{{name}}” is removed permanently along with its scope grants. This cannot be undone.',
        success: 'Agent deleted'
      },
      toolbar: {
        showing: 'Showing {{shown}} of {{total}}'
      },
      intro: {
        lead: 'Agents are non-human identities your organization deploys to act in the platform — autonomously or on behalf of a user. They sign in with short-lived, tenant-scoped tokens (never static keys) and reach external tools through a secure vault.',
        howTitle: 'How it works',
        whereTitle: 'When to use it',
        where:
          'Use an agent whenever software — an automation, a bot, or an AI assistant — needs governed access to your apps or external tools, with full audit and instant revocation.',
        hide: 'Hide guide',
        show: 'How agents work',
        steps: {
          register: {
            title: '1 · Register',
            desc: 'Create an agent identity — Service (autonomous) or Delegated (acts for a user).'
          },
          scope: {
            title: '2 · Grant access',
            desc: 'Give least-privilege access to specific apps and operations.'
          },
          connect: {
            title: '3 · Connect tools',
            desc: 'Optionally connect Gmail, Slack and more via the vault — the agent never sees credentials.'
          },
          authenticate: {
            title: '4 · Authenticate',
            desc: 'The agent receives short-lived, tenant-scoped tokens. No static keys.'
          },
          call: {
            title: '5 · Call tools',
            desc: 'Capabilities are exposed as MCP tools the agent can discover and call.'
          },
          approve: {
            title: '6 · Approve',
            desc: 'High-risk calls pause for human approval via device or CIBA before running.'
          },
          govern: {
            title: '7 · Govern',
            desc: 'Rotate, revoke, verify and audit every action at any time.'
          }
        },
        typesTitle: 'Two kinds of agents'
      },
      agentType: {
        service: 'Service',
        delegated: 'Delegated'
      },
      agentTypeHint: {
        service:
          'Owned by the org and acts autonomously via the client-credentials grant.',
        delegated:
          'Owned by a user and acts on their behalf via authorization-code + token exchange.'
      },
      status: {
        active: 'Active',
        suspended: 'Suspended',
        revoked: 'Revoked',
        expired: 'Expired'
      },
      list: {
        search: 'Search by name or client ID',
        openRow: 'Open {{name}}',
        filterType: 'Type',
        filterVerified: 'Verification',
        all: 'All',
        expiringSoon: 'Expiring soon',
        kpiTotal: 'Agents',
        kpiActive: 'Active',
        kpiDelegated: 'Delegated',
        kpiExpiring: 'Expiring soon',
        kpiPendingApprovals: 'Pending approvals'
      },
      verified: {
        yes: 'Verified',
        no: 'Unverified'
      },
      verifiedTooltip:
        'Verified agents can be granted broader access. Unverified agents should be restricted.',
      columns: {
        name: 'Agent',
        type: 'Type',
        actingUser: 'Acts for',
        scopes: 'App access',
        connections: 'Connections',
        lastActive: 'Last active',
        created: 'Created',
        status: 'Status',
        actions: 'Actions'
      },
      noConnections: 'No tools',
      noScopes: 'No app access',
      moreApps: '+{{count}} more',
      lastActiveNever: 'Never',
      actions: {
        open: 'Open',
        rotate: 'Rotate secret',
        revoke: 'Revoke',
        delete: 'Delete',
        configure: 'Configure',
        viewActivity: 'Activity',
        suspend: 'Suspend',
        resume: 'Resume',
        reconnect: 'Reconnect'
      },
      rotate: {
        confirmTitle: 'Rotate agent secret?',
        confirmBody:
          'The current secret stops working immediately. The new secret is shown once.',
        success: 'Secret rotated'
      },
      revoke: {
        confirmTitle: 'Revoke agent?',
        confirmBody:
          '“{{name}}” loses all access immediately and its tokens are invalidated. This cannot be undone.',
        success: 'Agent revoked'
      },
      messages: {
        registered: 'Agent registered',
        updated: 'Agent updated',
        scopesUpdated: 'Scopes updated',
        scopeRevoked: 'Scope revoked',
        connected: 'Tool connected',
        disconnected: 'Tool disconnected',
        reconnected: 'Tool reconnected',
        tokenIssued: 'Test token issued',
        verifiedSet: 'Verification updated',
        suspended: 'Agent suspended',
        resumed: 'Agent resumed'
      },
      reveal: {
        title: 'Agent credentials',
        warning: 'Copy the client secret now — it is shown only once.',
        clientId: 'Client ID',
        secret: 'Client secret',
        done: 'Done'
      },
      form: {
        registerTitle: 'Register agent',
        editTitle: 'Configure agent',
        registerNotice:
          'The agent acts on behalf of whoever chats with it, via the workspace’s shared Core OAuth client. After registering, connect tools and grant access on the agent’s page.',
        name: 'Name',
        nameRequired: 'Enter a name',
        nameDuplicate: 'An agent with this name already exists',
        namePlaceholder: 'e.g. Billing research agent',
        description: 'Description',
        descriptionOptional: 'optional',
        descriptionPlaceholder: 'What this agent does and any boundaries.',
        systemPrompt: 'System prompt',
        systemPromptHint: 'Instructions that shape how the agent responds.',
        systemPromptPlaceholder: 'You are a helpful assistant that…',
        visibility: 'Visibility',
        tier: 'Ownership',
        tierHint:
          'Personal agents are yours alone; workspace agents are shared with the organization.',
        restricted: 'Restrict to assigned users only',
        restrictedHint:
          'By default the agent follows its tier (personal = only you; workspace = everyone). Turn on to limit it to the users you assign.',
        toolExecutionMode: 'Tool execution',
        toolExecutionModeHint:
          'Autonomous runs write tools without asking. Ask pauses for your approval before each write/destructive tool. Read-only tools always run.',
        autoApprovedTools: 'Always-approved tools',
        autoApprovedToolsHint:
          'Tools the user chose “Always approve” for in chat — they skip the approval prompt for this agent. Remove a tag to start asking again.',
        autoApprovedToolsEmpty: 'None yet.',
        type: 'Agent type',
        typeRequired: 'Choose an agent type',
        actingUser: 'Acts on behalf of',
        actingUserRequired: 'Select the user this agent acts for',
        actingUserPlaceholder: 'Select a workspace member',
        actingUserHint:
          'Delegated tokens carry both this user and the agent; effective access is the intersection of the two.',
        scopes: 'Allowed scopes',
        scopesHint:
          'The capability ceiling the agent may request. For each user who chats with it, effective access is these scopes intersected with that user’s permissions (least privilege).',
        addScope: 'Add app',
        app: 'App',
        appPlaceholder: 'Select an app',
        appAlreadyAdded: 'Already added',
        permissions: 'Permissions',
        permissionsPlaceholder: 'All permissions in this app',
        noPermissions: 'This app has no granular permissions yet.',
        removeScope: 'Remove',
        ttl: 'Access token lifetime',
        ttlHint: 'Short-lived; refresh with rotation is supported.',
        ttlSuffix: 'min',
        expiresAt: 'Agent expiry',
        expiresAtOptional: 'optional',
        expiresAtPlaceholder: 'No expiry',
        cancel: 'Cancel',
        submit: 'Register agent',
        save: 'Save changes'
      },
      detail: {
        notFound: 'Agent not found',
        tabs: {
          overview: 'Overview',
          mcp: 'MCP',
          access: 'Access',
          approvals: 'Approvals',
          connections: 'Connections',
          externalTools: 'External',
          activity: 'Activity'
        },
        hero: {
          clientId: 'Client ID',
          actingUser: 'Acts for',
          owner: 'Owner',
          type: 'Type',
          created: 'Created',
          expires: 'Expires',
          noExpiry: 'No expiry',
          scopes: 'Allowed scopes',
          scopesCount: '{{count}} scope',
          scopesCount_other: '{{count}} scopes',
          model: 'Model'
        }
      },
      overview: {
        identityTitle: 'Delegated identity',
        identityBody:
          'Requests act as “{{name}}” on behalf of whoever is chatting with it, via the workspace’s shared Core OAuth client. There is no per-agent secret, token lifetime, or fixed acting user.',
        identityHint:
          'Effective access on each request is the agent’s allowed scopes intersected with that user’s Skalx permissions, enforced by Core.',
        agentId: 'Agent ID',
        workspaceClient: 'Workspace client (org)',
        scopeCeiling: 'Scope ceiling',
        provider: 'Model',
        toolExecutionMode: 'Tool execution'
      },
      access: {
        title: 'Allowed scopes',
        save: 'Save scopes',
        intersectionTitle: 'How effective access is computed',
        intersectionBody:
          'Scopes are granted per connection below — each connected tool (and each instance) has its own. For every user who chats with this agent, it can only do (the granted scopes) ∩ (what that user is allowed in Skalx). Manage who may use agents in <rolesLink>Roles</rolesLink>.',
        emptyBody:
          'This agent has no connected tools yet. Connect an MCP server first, then grant its scopes here.',
        emptyCta: 'Connect a tool',
        noScopesForApp: 'This connection has no configurable scopes.',
        empty: 'No scopes granted.'
      },
      mcp: {
        introTitle: 'Connect tools (MCP)',
        introBody:
          'Connect the apps this agent may use, and grant each connection its permissions below. The agent can only do (the scopes you grant) ∩ (what each user is allowed in Skalx).',
        permissions: 'Permissions',
        title: 'Tool connections',
        empty: 'No tool integrations are available to connect yet.',
        connect: 'Connect',
        connectedTag: 'Connected',
        connected: 'Tool connected',
        detached: 'Tool detached',
        detach: 'Detach',
        detachConfirm: 'Detach this server from the agent?',
        enabledTip: 'Enabled — the agent can call this server’s tools.',
        disabledTip: 'Disabled — attached but its tools aren’t callable.',
        availableTitle: 'Available integrations',
        activeTitle: 'Connected tools',
        activeIntroTitle: 'Tools this agent can use',
        activeIntroBody:
          'MCP servers connected to this agent. Disable one to stop its tools being callable without detaching it. Add new tools from the Connections tab.',
        activeEmpty:
          'No tools connected yet. Add some from the Connections tab.',
        noInstance: 'No {{app}} app is installed in this workspace.'
      },
      builtinTools: {
        introTitle: 'Built-in tools',
        introBody:
          'Function tools this agent can call directly. Toggle one on to enable it for this agent.',
        title: 'Available tools',
        empty: 'No tools available.',
        otherCategory: 'Other',
        enabledTip: 'Enabled — the agent can call this tool.',
        disabledTip: 'Disabled — turn on to let the agent call it.',
        updated: 'Tools updated',
        externalIntroTitle: 'Third-party tools',
        externalIntroBody:
          'Tools provided by external services like Firecrawl. Toggle one on to enable it for this agent.',
        externalTitle: 'Provider tools',
        externalEmpty: 'No third-party tools available.',
        apiKeyLabel: '{{provider}} API key',
        apiKeyPlaceholder: 'Paste your API key',
        apiKeyHelp:
          'Stored per-agent. Required — the runtime does not carry a fallback key.',
        apiKeyMissing: 'No key set yet — add one or the tool can’t run.',
        apiKeySaved: 'API key saved'
      },
      connections: {
        title: 'External tool connections',
        subtitle:
          'Connected accounts the agent reaches through the credential vault.',
        brokerNote:
          'The vault stores and refreshes third-party tokens server-side. The agent and LLM never see the underlying credentials.',
        connect: 'Connect tool',
        connectTitle: 'Connect external tool',
        connectNotice:
          'In production this opens the provider’s OAuth consent. Here the connection is simulated.',
        provider: 'Tool',
        providerPlaceholder: 'Select a tool',
        account: 'Account',
        accountPlaceholder: 'e.g. agent@company.com',
        accountRequired: 'Enter the account to connect',
        toolScopes: 'Tool permissions',
        toolScopesPlaceholder: 'Operations the agent may perform',
        empty: 'No tools connected.',
        columns: {
          tool: 'Tool',
          account: 'Account',
          status: 'Status',
          scopes: 'Permissions',
          lastRefreshed: 'Token refreshed',
          actions: 'Actions'
        },
        status: {
          connected: 'Connected',
          expired: 'Expired',
          revoked: 'Revoked'
        },
        neverRefreshed: 'Not yet',
        reconnect: 'Reconnect',
        disconnect: 'Disconnect',
        disconnectConfirmTitle: 'Disconnect this tool?',
        disconnectConfirmBody:
          'The agent will immediately lose the ability to call {{tool}}.'
      },
      activity: {
        title: 'Activity',
        subtitle: 'Run history for {{name}}.',
        empty: 'No recorded activity yet.',
        tokens: '{{count}} tokens',
        trigger: {
          chat: 'Chat run',
          schedule: 'Scheduled run',
          webhook: 'Webhook run',
          api: 'API run'
        },
        status: {
          pending: 'Queued',
          running: 'Running',
          done: 'Done',
          error: 'Error',
          paused: 'Paused'
        },
        columns: {
          action: 'Action',
          when: 'When'
        }
      },
      tools: {
        introTitle: 'Tools the agent can call (MCP)',
        introBody:
          'Capabilities are exposed as MCP tools and managed in Squad. Each call still inherits this agent’s allowed scopes, intersected per user with their Skalx permissions.',
        mcpTitle: 'MCP discovery',
        mcpSubtitle:
          'What an MCP client fetches to learn this agent’s endpoint and tool catalog.',
        discoveryUrl: 'Discovery document',
        mcpEndpoint: 'MCP endpoint',
        title: 'Tools',
        mcpServers: 'MCP servers',
        managedInSquad:
          'Tools and MCP servers are configured for this agent in Squad.',
        subtitle:
          'Capabilities attached to this agent. Each maps to an app permission or a connected tool.',
        add: 'Add tool',
        addTitle: 'Add a tool',
        addNotice:
          'Pick a capability from the catalog. You can change its approval policy afterwards.',
        addPlaceholder: 'Select a capability',
        empty: 'No tools yet. Add one to let this agent perform an action.',
        remove: 'Remove',
        removeConfirmTitle: 'Remove this tool?',
        removeConfirmBody: 'The agent will no longer be able to call {{tool}}.',
        test: 'Test call',
        run: 'Run call',
        testTitle: 'Test call · {{tool}}',
        testApprovalNote:
          'This tool requires approval — the call will pause as a pending request instead of running immediately.',
        inputLabel: 'Tool input (JSON)',
        requiresApproval: 'Requires approval',
        autoRuns: 'Runs automatically',
        recentCallsTitle: 'Recent tool calls',
        columns: {
          tool: 'Tool',
          source: 'Source',
          risk: 'Risk',
          approval: 'Approval policy',
          enabled: 'Enabled'
        },
        callColumns: {
          tool: 'Tool',
          status: 'Result',
          when: 'When'
        },
        source: {
          app: 'App',
          connector: 'Connector'
        },
        risk: {
          low: 'Low',
          medium: 'Medium',
          high: 'High'
        },
        callStatus: {
          succeeded: 'Succeeded',
          denied: 'Denied',
          pending_approval: 'Awaiting approval',
          failed: 'Failed'
        },
        messages: {
          added: 'Tool added',
          updated: 'Tool updated',
          removed: 'Tool removed'
        },
        result: {
          okTitle: 'Call completed',
          heldTitle: 'Sent for approval',
          heldBody:
            'This call needs human approval ({{method}}). Resolve it in the Approvals tab.',
          userCode: 'Device code'
        }
      },
      approvals: {
        introTitle: 'Human-in-the-loop approvals',
        introBody:
          'Tool calls that need a human decision pause here before they run. Approving resumes the agent and lets the call proceed; denying blocks it.',
        pendingTitle: 'Pending ({{count}})',
        pendingEmpty:
          'No approvals waiting. Gated tool calls will appear here.',
        historyTitle: 'Decision history',
        filterAll: 'All',
        pendingCount: '{{count}} pending',
        scope: {
          agent: 'This agent',
          workspace: 'All agents'
        },
        approve: 'Approve',
        deny: 'Deny',
        denyTitle: 'Deny this request?',
        reasonLabel: 'Reason',
        reasonPlaceholder: 'Optional note recorded with the decision.',
        status: {
          pending: 'Pending',
          accepted: 'Approved',
          edited: 'Approved (edited)',
          rejected: 'Denied',
          answered: 'Answered'
        },
        columns: {
          action: 'Action',
          requested: 'Requested',
          when: 'When',
          agent: 'Agent',
          status: 'Status',
          resolved: 'Resolved'
        },
        messages: {
          approved: 'Request approved — resuming the agent',
          denied: 'Request denied',
          failed: 'Could not resolve the request'
        }
      }
    },
    apps: {
      title: 'Workspace apps',
      description:
        'Manage application catalog, roles, credentials, webhooks, and audit events.',
      routeShellDescription:
        'Configure this app, its roles, credentials, webhooks, and audit trail.',
      create: 'Create app',
      createModalTitle: 'Create workspace app',
      browseCatalog: 'Browse catalog',
      createCustomLocal: 'Add custom app',
      navLabel: 'App sections',
      nav: {
        overview: 'Overview',
        people: 'People',
        groups: 'Groups',
        roles: 'Roles',
        oidc: 'OIDC',
        scim: 'SCIM',
        credentials: 'Credentials',
        webhooks: 'Webhooks',
        // Same label as the flag-gated `webhooks` section above. They never appear together
        // today -- that flag defaults off and this section only exists on a CRM app.
        outboundWebhooks: 'Webhooks',
        activity: 'Activity',
        settings: 'Settings'
      },
      groups: {
        columns: {
          name: 'Group',
          members: 'Members',
          roles: 'Roles in this app',
          updated: 'Updated',
          otherApps_one: '+{{count}} role in another app',
          otherApps_other: '+{{count}} roles in other apps',
          otherAppsHint: 'This group also grants: {{roles}}'
        },
        actions: {
          add: 'Add group',
          create: 'New group',
          editRoles: 'Change roles',
          revoke: 'Revoke access'
        },
        modal: {
          addTitle: 'Add a group to this app',
          editTitle: 'Change roles',
          accessNotice:
            'Everyone in the group gets these roles and access to this app.',
          groupLabel: 'Group',
          groupPlaceholder: 'Select a group',
          groupRequired: 'Pick a group',
          noCandidates: 'Every group already has access here.',
          rolesLabel: 'Roles in this app',
          rolesPlaceholder: 'Select roles',
          rolesHint:
            'Only this app is affected. Roles in other apps stay as they are.',
          alsoGrants: 'This group also grants access elsewhere',
          submit: 'Save',
          cancel: 'Cancel'
        },
        create: {
          title: 'New group',
          submit: 'Create group',
          success: 'Group created',
          accessNotice:
            'Members of this group get the roles you pick here — and access to this app. People who do not have access yet will receive it.',
          membersHint:
            'Any member of the organization can be added, not only people who already use this app.',
          rolesHint:
            'Only this app’s roles are offered here. More can be added later from Users → Groups.'
        },
        revoke: {
          title: 'Revoke access',
          content:
            'Remove every role this app grants through “{{name}}”? Members keep access they hold personally or through another group.',
          confirm: 'Revoke'
        },
        messages: {
          rolesUpdated: 'Group roles updated',
          revoked: 'Group access revoked'
        }
      },
      navGroups: {
        access: 'Access',
        connection: 'Connection',
        monitor: 'Manage'
      },
      outboundWebhookDetail: {
        breadcrumb: 'Webhook',
        back: 'Back to {{app}}',
        overviewTitle: 'Overview',
        eventsTitle: 'Subscribed events',
        noEvents: 'No events selected, so nothing is delivered.',
        eventSummary: '{{events}} across {{entities}}',
        objectCount_one: '{{count}} object',
        objectCount_other: '{{count}} objects',
        updated: 'Last changed',
        stateActive: 'Active',
        stateInactive: 'Inactive'
      },
      outboundWebhooks: {
        create: 'Add webhook',
        empty: 'No endpoints yet. Add one to start receiving CRM events.',
        toolbar: { label: 'configured endpoints' },
        columns: {
          name: 'Name',
          url: 'Endpoint',
          events: 'Events',
          eventCount_one: '{{count}} event',
          eventCount_other: '{{count}} events',
          active: 'Active',
          created: 'Created'
        },
        actions: {
          reveal: 'Show signing secret',
          test: 'Send test webhook'
        },
        deleteModal: {
          title: 'Delete webhook?',
          content:
            'Deliveries stop immediately, including attempts already queued for retry.'
        },
        test: {
          title: 'Test delivery',
          accepted: 'The endpoint accepted the delivery ({{status}}).',
          rejected: 'The endpoint answered {{status}}.',
          unreachable: 'The endpoint could not be reached.',
          responseBody: 'Response from the endpoint',
          hint: 'The request is signed exactly like a real event, with the event name webhook.test. Some tools arm their test URL for a single call — press their listen button, then send again.',
          deliveryId: 'Delivery: {{id}}'
        },
        messages: { deleted: 'Webhook deleted' },
        managed: {
          tag: 'Squad',
          openInSquad: 'Open in Squad',
          editWarning:
            'Squad manages this webhook — changing the address or secret disconnects the agent.'
        },
        secret: {
          title: 'Signing secret',
          hint: 'Give this to whoever receives the events — they use it to verify the X-CRM-Signature header. Every time it is shown here is recorded in the activity log.'
        },
        events: {
          placeholder: 'Select the events to receive',
          selectAll: 'Select all',
          clear: 'Clear',
          unavailable:
            'The event list could not be loaded from this CRM instance.',
          unavailableHint:
            'The list is served by the CRM app itself. Check that the app is reachable, then reopen this form.'
        },
        verify: {
          title: 'Verifying deliveries',
          copy: 'Copy',
          intro:
            'Every delivery carries X-CRM-Signature: t=<unix>,v1=<hex> — an HMAC-SHA256 of "<t>.<raw body>" using the signing secret for this webhook. Recomputing it is how the receiver knows the request came from us and was not altered.',
          secretHint:
            'Take the secret from "Show signing secret" and keep it in your environment, not in code.',
          tips: {
            rawBody:
              'Sign the raw bytes. Parsing the JSON and serialising it again changes the bytes, and the signature will never match.',
            constantTime:
              'Compare with a constant-time function. A plain === leaks how much of the signature was correct.',
            replay:
              'Reject an old timestamp. Each retry is signed afresh, so a stale t means someone is replaying a captured request.',
            idempotency:
              'Deduplicate on X-CRM-Delivery. A delivery that timed out on your side is retried, so the same event can arrive twice.',
            retries:
              'Answer 2xx quickly and process afterwards. Anything else is retried five times over about two and a half hours, then dropped.'
          },
          n8n: 'n8n needs adapting. The template below implements GitHub\'s scheme — one header, signed over the body alone. For us: turn on Raw Body on the Webhook node, split t and v1 out of X-CRM-Signature, and sign "<t>.<raw body>". The Crypto and IF nodes cannot prepend the timestamp to raw bytes, so put the Node.js snippet above in a Code node instead.',
          n8nLink: 'n8n HMAC validation template'
        },
        form: {
          name: 'Name',
          namePlaceholder: 'For example, Lead routing',
          createTitle: 'New webhook',
          editTitle: 'Edit webhook',
          url: 'Endpoint URL',
          urlHttps: 'Only https URLs are allowed.',
          events: 'Events',
          eventsRequired: 'Select at least one event.',
          secret: 'Signing secret',
          secretPlaceholderCreate: 'Leave empty — we will generate one',
          secretPlaceholderEdit: 'Leave empty to keep the current secret',
          secretCreateHint:
            'Fill this in only if the receiving system requires its own value.',
          secretEditHint:
            'Replacing it breaks verification for whoever receives these events until they update it too.',
          secretTooShort: 'The secret must be at least {{min}} characters.',
          active: 'Active',
          activeHint:
            'Turning this off stops deliveries immediately, including attempts already queued for retry.'
        }
      },
      board: {
        searchPlaceholder: 'Search apps',
        filterAll: 'All',
        filterInstalled: 'Installed',
        filterAvailable: 'Available',
        createCustom: 'Create custom app',
        installedGroup: 'Installed',
        installedHint: 'Running in this workspace.',
        availableGroup: 'Available',
        availableHint: 'Not installed yet.',
        factType: 'Type',
        launch: 'Open {{name}} in a new tab',
        userCount_one: '{{count}} user',
        userCount_other: '{{count}} users',
        userCountUnknown: 'Users —',
        sortLabel: 'Sort apps',
        sort: {
          name: 'Name A–Z',
          '-name': 'Name Z–A',
          newest: 'Newest first',
          oldest: 'Oldest first'
        },
        factInstalled: 'Installed',
        openApp: 'Open',
        manageAccess: 'Manage access',
        install: 'Install',
        empty: {
          filtered: 'No apps match your search.',
          none: 'No apps are available for this workspace yet.'
        }
      },
      iconField: {
        pick: 'Choose an icon',
        reset: 'Reset',
        hint: 'An icon or your own image · PNG, JPG, SVG up to 1 MB',
        hintIconsOnly: 'An icon for the app'
      },
      createCustom: {
        defaultTitle: 'New custom app',
        defaultSubtitle: 'Workspace identity for any app',
        cancel: 'Cancel',
        submit: 'Create app',
        fields: {
          name: 'App name',
          nameExtra: 'Shown across Skalx and on the OAuth consent screen.',
          namePlaceholder: 'e.g. Edge gateway',
          description: 'Description',
          descriptionExtra:
            'Optional. Helps your team understand what this app does.',
          descriptionPlaceholder: 'One line describing this app.',
          icon: 'App icon'
        },
        connection: {
          domain: 'Application domain',
          domainExtra:
            'Optional. Authoritative host for redirect URIs and CORS. Persisted as application_domain.',
          appUrl: 'Application URL',
          appUrlExtra:
            'Optional. Where users land when they open the app from Skalx. Persisted as application_url.'
        }
      },
      customTab: {
        headerTitle: 'Custom applications',
        headerDescription:
          'Internal or third-party apps that authenticate through Skalx. Use OIDC to wire them up.',
        docs: 'Docs',
        create: 'Create custom app',
        authType: 'OIDC',
        empty: 'No custom apps yet.',
        noDeployment: 'No deployment URL yet.',
        users: 'Users',
        created: 'Created',
        status: {
          ready: 'Ready',
          draft: 'Draft'
        },
        menu: {
          open: 'Open app',
          manage: 'Manage',
          rotate: 'Rotate credentials',
          delete: 'Delete app'
        },
        howItWorks: {
          title: 'Skalx as the identity layer for any app',
          description:
            'Custom apps let you use Skalx for authentication, role management and audit trails in third-party or internal applications.',
          steps: {
            defineApp: 'Define app',
            issueCredentials: 'Issue credentials',
            connect: 'Connect with OIDC',
            grantAccess: 'Grant access'
          }
        },
        createDrawerTitle: 'New custom app',
        drawerPlaceholder: {
          title: 'Multi-step create flow lands in Step 5',
          description:
            'This drawer will guide you through identity, auth method, connection details and roles in four short steps.',
          note: 'For now the flow is being designed. Once Step 5 is approved, this drawer will be wired to the live applications API and create the app on submit.'
        }
      },
      catalogTab: {
        searchPlaceholder: 'Search the catalog…',
        shown: 'shown',
        submitApp: 'Submit an app →',
        featured: 'Featured',
        featuredFallbackDescription:
          'A built-in workspace app you can install in one click.',
        addToWorkspace: 'Add to workspace',
        manage: 'Manage',
        installed: 'Installed',
        popular: 'Popular',
        docs: 'Documentation',
        noDescription: 'No description provided.',
        orderName: 'Name (A → Z)',
        orderNameDesc: 'Name (Z → A)',
        orderNewest: 'Newest first',
        orderOldest: 'Oldest first',
        loadingMore: 'Loading more apps…',
        statusFilter: {
          all: 'All',
          installed: 'Installed',
          available: 'Available'
        },
        empty: {
          none: 'No apps in the catalog yet.',
          filtered: 'No apps match your filters.'
        }
      },
      installed: {
        kpi: {
          installed: 'Installed apps',
          activeSessions: 'Active sessions',
          totalUsers: 'Total users',
          totalUsersFooter: 'across {{count}} apps',
          needAttention: 'Need attention'
        },
        filters: {
          searchPlaceholder: 'Search apps…',
          typeAll: 'All types',
          typeBuiltin: 'Built-in',
          typeCustom: 'Custom',
          healthAll: 'All health',
          healthSoon:
            'Health filter — available once the API exposes per-app health.'
        },
        totalApps_one: '{{count}} app',
        totalApps_other: '{{count}} apps',
        totalApps: '{{count}} apps',
        columns: {
          app: 'App',
          type: 'Type',
          health: 'Health',
          users: 'Users',
          sessions: 'Sessions · 24h',
          errorRate: 'Error rate',
          created: 'Created'
        },
        type: {
          builtin: 'Built-in',
          custom: 'Custom'
        },
        actions: {
          addFromCatalog: 'Add from catalog',
          newCustom: 'New custom app',
          refresh: 'Refresh',
          density: 'Density (coming soon)'
        },
        rowMenu: {
          open: 'Open app',
          manage: 'Manage',
          credentials: 'Credentials',
          roles: 'Roles',
          uninstall: 'Uninstall'
        },
        empty: {
          none: 'No apps installed in this workspace yet.',
          filtered: 'No apps match your filters.'
        }
      },
      builtin: {
        installDrawerTitle: 'Install built-in app'
      },
      custom: {
        fields: {
          url: 'URL',
          urlInvalid: 'Enter a valid URL (https://...)'
        },
        delete: 'Delete app',
        deleteConfirm: {
          title: 'Delete this custom app?',
          description:
            'This action permanently removes the app, its role assignments and tokens. It cannot be undone.'
        }
      },
      catalog: {
        crm: {
          title: 'CRM workspace',
          description:
            'Pipeline, accounts, and sales operations aligned to workspace roles.'
        },
        hrm: {
          title: 'HRM workspace',
          description:
            'People data, SCIM-friendly provisioning, and HR workflows.'
        },
        identity: {
          title: 'Identity & access',
          description:
            'Tokens, SSO boundaries, and partner-facing auth surfaces.'
        },
        finance: {
          title: 'Finance & billing',
          description: 'Invoices, subscriptions, and revenue operations.'
        }
      },
      manage: 'Manage',
      status: {
        active: 'Active',
        archived: 'Archived',
        revoked: 'Revoked',
        expired: 'Expired'
      },
      messages: {
        created: 'App created successfully',
        updated: 'App updated successfully',
        deleted: 'App deleted',
        deleteTokenMissing:
          'App token is not loaded yet. Refresh the page and try again.',
        roleUpdated: 'Role updated successfully',
        customPermissionCreated: 'Custom permission created',
        customPermissionCreateFailed: 'Could not create custom permission'
      },
      loadError: 'Could not load applications for this workspace.',
      retry: 'Retry',
      empty: 'No applications yet.',
      noRepositoryTypes:
        'No application templates are available. Contact an administrator or check your workspace setup.',
      createForm: {
        instanceType: 'Application template',
        instanceTypePlaceholder: 'Select a template',
        platformConfigHint:
          'Choose how this app fits into the workspace platform so roles, provisioning, and API access stay consistent from day one.'
      },
      overview: {
        domain: 'Domain',
        appUrl: 'App URL',
        instanceType: 'Template',
        createdAt: 'Created',
        visibility: 'Visibility',
        appInfoTitle: 'Application information',
        editHint:
          'Name and description are saved to your application record. The icon is stored in this browser for display until the API supports application icons. Product context in the sections above stays in the workspace UI until dedicated settings endpoints are available.',
        coreWrappingHint:
          'Apps are expected to inherit workspace authentication, access control, and security defaults unless you explicitly model a dedicated SSO boundary.',
        templateConfigTitle: 'Template configuration surface',
        templateConfigDescription:
          'This template exposes {{count}} configurable keys that can be wrapped by the workspace platform.',
        templateConfigEmpty:
          'This template does not expose additional configuration keys through the current API.',
        appRolesCardTitle: 'App roles & permissions',
        appRolesCardDescription:
          'Define who can manage this app, its credentials, and integration settings. Use the Roles tab for the same controls in a dedicated view.',
        workspaceRolesAccessHint:
          'This app uses workspace roles for access. Assign members in the workspace Members and Roles sections; app-specific roles are hidden.',
        analyticsTitle: 'Usage & reliability',
        analyticsSessions: 'Active sessions (24h)',
        analyticsErrors: 'Error rate',
        analyticsLatency: 'P95 latency',
        dashboardsTitle: 'Dashboards',
        dashboardsHint: 'Pinned operational views for this app (mock).',
        agentsTitle: 'AI agents',
        agentsHint: 'Autonomous helpers scoped to this application (mock).',
        dangerZoneTitle: 'Danger zone',
        dangerZoneDescription:
          'Permanently delete this custom app and all its configuration.',
        dashboardItem: {
          health: 'Health & uptime',
          usage: 'Usage & quotas',
          security: 'Security posture'
        },
        agentItem: {
          support: 'Support triage',
          supportDesc: 'Drafts first responses from tickets and audit trails.',
          ops: 'Ops copilot',
          opsDesc: 'Summarizes incidents and suggests runbook steps.'
        }
      },
      settings: {
        edit: 'Edit settings',
        save: 'Save settings',
        saved: 'Template settings saved',
        default: 'Default',
        placeholder: 'Enter value'
      },
      productType: {
        built_in: 'Built-in',
        custom: 'Custom'
      },
      solution: {
        crm: 'CRM',
        hrm: 'HRM',
        identity: 'Identity',
        finance: 'Finance',
        operations: 'Operations',
        custom: 'Custom'
      },
      accessModel: {
        workspace_roles: 'Workspace roles',
        app_roles: 'App roles'
      },
      provisioning: {
        manual: 'Manual',
        jit: 'Just-in-time',
        scim: 'SCIM'
      },
      authMode: {
        workspace_core: 'Workspace auth core',
        dedicated_sso: 'Dedicated SSO boundary'
      },
      apiExposure: {
        internal: 'Internal',
        partner: 'Partner',
        public: 'Public'
      },
      configurationStatus: {
        ready: 'Ready',
        needsAttention: 'Needs attention'
      },
      visibility: {
        public: 'Public',
        private: 'Private'
      },
      columns: {
        app: 'App',
        domain: 'Domain',
        url: 'URL',
        instanceType: 'Template',
        visibility: 'Visibility',
        createdAt: 'Created',
        actions: 'Actions'
      },
      fields: {
        slug: 'Slug',
        goal: 'Goal',
        description: 'Description',
        owner: 'Owner',
        productType: 'Product type',
        solutionArea: 'Solution area',
        accessModel: 'Access model',
        provisioningMode: 'Provisioning',
        authMode: 'Auth boundary',
        apiExposure: 'API exposure',
        environment: 'Environment',
        status: 'Status'
      },
      environments: {
        development: 'Development',
        staging: 'Staging',
        production: 'Production'
      },
      tabs: {
        overview: 'Overview',
        users: 'Users',
        roles: 'Roles',
        credentials: 'Credentials',
        webhooks: 'Webhooks',
        audit: 'Audit',
        settings: 'Settings',
        access: 'Access',
        connection: 'Connection',
        activity: 'Activity'
      },
      segments: {
        users: 'Users',
        roles: 'Roles',
        oidc: 'OIDC',
        scim: 'SCIM',
        credentials: 'Credentials',
        webhooks: 'Webhooks'
      },
      overviewTab: {
        kpi: {
          activeSessions: 'Active sessions',
          errorRate: 'Error rate',
          p95Latency: 'P95 latency',
          monthlyActive: 'Monthly active users',
          noDataYet: 'No metrics from the API yet.'
        },
        usage: {
          title: 'Request volume',
          subtitle: 'Last 24 hours · 1h buckets.',
          empty: 'Usage charts arrive once the per-app metrics API is wired.'
        },
        info: {
          title: 'Application information',
          name: 'Name',
          template: 'Template',
          description: 'Description',
          domain: 'Domain',
          appUrl: 'Application URL',
          visibility: 'Visibility',
          created: 'Created',
          token: 'App token',
          version: 'Version'
        },
        activity: {
          title: 'Recent activity',
          empty: 'App-scoped audit events will appear once the API is exposed.'
        },
        apiNote:
          'Identity fields (name, template, domain, visibility, created) come from the live API. Metrics, version and activity fill in as those endpoints land.'
      },
      autoProvision: {
        title: 'Access for everyone',
        enableLabel: 'Give every member access by default',
        description:
          'Everyone in the workspace gets this app with the selected role — the members who are already here and everyone added later. Members who already have a role in this app keep it.',
        roleLabel: 'Default role',
        rolePlaceholder: 'Select a role',
        roleRequired: 'Pick the role members should get, or turn this off.'
      },
      settingsTab: {
        save: 'Save',
        reset: 'Reset',
        general: {
          title: 'General',
          name: 'Name',
          domain: 'Domain',
          domainReadOnly:
            'Domain is set when the app is installed and is not editable yet.',
          appUrl: 'Application URL',
          appUrlExtra: 'Where users land when they open this app.',
          description: 'Description',
          icon: 'App icon'
        },
        danger: {
          title: 'Danger zone',
          uninstall: {
            title: 'Uninstall app',
            description:
              'Removes the app from the workspace. User access, roles and credentials are deleted.',
            action: 'Uninstall'
          }
        }
      },
      auditTab: {
        tabs: {
          events: 'Events',
          exports: 'Exports'
        },
        title: 'Audit log',
        subtitle: 'Scoped to this application.',
        totalEvents_one: '{{count}} event',
        totalEvents_other: '{{count}} events',
        refresh: 'Refresh',
        loadError: 'Could not load audit events for this application.',
        retry: 'Retry',
        openDetails: 'Open details for {{event}}',
        filters: {
          searchPlaceholder: 'Search by description or actor…',
          actionPlaceholder: 'Action',
          entityTypePlaceholder: 'Entity type',
          dateRangeLabel: 'Date range',
          entityIdPlaceholder: 'Entity ID',
          actorTypePlaceholder: 'Actor type',
          actorIdPlaceholder: 'Actor',
          clear: 'Clear'
        },
        columns: {
          time: 'Time',
          application: 'Application',
          event: 'Event',
          actor: 'Actor',
          description: 'Description'
        },
        export: 'Export',
        noMatches: 'No events match the selected filters.',
        empty: 'No audit events for this application yet.'
      },
      auditDetail: {
        breadcrumb: 'Audit event',
        backToAudit: 'Back to audit log',
        loadError: 'Could not load this audit event.',
        sections: {
          actorAndRequest: 'Actor and request',
          additionalData: 'Additional data',
          changes: 'Changes',
          metadata: 'Metadata',
          localizedDescriptions: 'Localized descriptions'
        },
        fields: {
          description: 'Description',
          timestamp: 'Time',
          eventId: 'Event ID',
          eventType: 'Event type',
          channel: 'Channel',
          entityType: 'Entity type',
          entityId: 'Entity ID',
          category: 'Category',
          application: 'Application',
          applicationId: 'Application ID',
          organizationId: 'Organization ID',
          service: 'Service',
          actor: 'Actor',
          actorId: 'Actor ID',
          method: 'Method',
          clientIp: 'Client IP',
          url: 'Request URL'
        }
      },
      usersTab: {
        searchPlaceholder: 'Search by name or email…',
        totalUsers_one: '{{count}} user',
        totalUsers_other: '{{count}} users',
        totalUsers: '{{count}} users',
        refresh: 'Refresh',
        grantAccess: 'Grant access',
        grantAccessTitle: 'Grant app access',
        memberLabel: 'Member',
        memberPlaceholder: 'Select a workspace member',
        memberRequired: 'Choose a member.',
        roleLabel: 'Role',
        rolePlaceholder: 'Select a role (optional)',
        grantSuccess: 'Access granted',
        manageAccessTitle: 'Manage app access',
        updateSuccess: 'Access updated',
        removeAccess: 'Remove from app',
        removeConfirmTitle: 'Remove access?',
        removeConfirmBody:
          'This member loses access to this app, including its app roles. Their other apps are untouched.',
        removeSuccess: 'Access removed',
        noRoles: 'No roles',
        organizationScope: 'Workspace',
        columns: {
          user: 'User',
          roles: 'Roles',
          source: 'Source',
          userId: 'User ID',
          actions: 'Actions'
        },
        empty: {
          none: 'No users have access to this app yet.',
          filtered: 'No users match your search.'
        }
      },
      roles: {
        workspaceRolesTitle: 'Workspace role links',
        workspaceRolesHelp:
          'Choose workspace roles that should receive this app during onboarding. Map those roles to app permissions in the matrix below.',
        saveLinkedWorkspaceRoles: 'Save workspace links',
        linkedSaved: 'Workspace role links updated',
        workspaceRolesMatrixTitle: 'Workspace roles × app permissions',
        workspaceRolesMatrixHint:
          'For each linked workspace role, choose which app-level capabilities (platform permissions and custom permissions) apply. This is separate from app roles, which bundle permissions for assignments inside the app.',
        workspaceRolesMatrixNeedLinks:
          'Link at least one workspace role above to map permissions.',
        saveWorkspaceRolePermissionMap: 'Save workspace permission map',
        workspaceRolePermissionMapSaved: 'Workspace permission map saved',
        matrixTitle: 'Permission matrix',
        matrixHint:
          'Rows are permissions (platform + custom). Columns are app roles. Built-in roles are read-only.',
        matrix: {
          permission: 'Permission'
        },
        panelIntro:
          'App roles bundle permissions for this application. Custom roles can be edited or removed; built-in roles are fixed by the platform.',
        add: 'Add role',
        roleListTitle: 'App roles',
        modalTitle: 'Add app role',
        editModalTitle: 'Edit app role',
        viewModalTitle: 'App role',
        view: 'View',
        edit: 'Edit',
        viewDone: 'OK',
        systemBadge: 'Built-in',
        systemRoleHint:
          'This is a built-in role. Name and permissions are managed by the platform template.',
        descriptionLabel: 'Role description',
        permissionsLabel: 'Permissions',
        roleSourceLabel: 'Role source',
        workspaceRoleSelectLabel: 'Workspace role',
        workspaceRoleSelectPlaceholder: 'Select a workspace role',
        roleSource: {
          custom: 'Custom',
          workspace: 'Workspace'
        },
        removeConfirm: 'Delete this role?',
        columns: {
          name: 'Name',
          type: 'Type',
          permissions: 'Permissions',
          actions: 'Actions'
        },
        appCustomPermissionsTitle: 'App capability permissions',
        appCustomPermissionsHelp:
          'Register `code_name` values your product checks at runtime (like PropelAuth permission strings). Each row has a stable `id` for APIs and role assignments.',
        appCustomPermissionCodeName: 'Code name',
        appCustomPermissionDisplayName: 'Display name',
        appCustomPermissionDescription: 'Description',
        appCustomPermissionId: 'Permission id',
        addAppCustomPermission: 'Add custom permission',
        removeAppCustomPermissionConfirm:
          'Delete this permission? It will be removed from every role that references it.',
        appCustomPermissionDuplicate:
          'A permission with this code name already exists.',
        appCustomPermissionCodeInvalid:
          'Use lowercase letters, numbers, dots, hyphens, or underscores (1–64 chars).',
        customPermissionsPickerLabel: 'Custom app permissions',
        createCustomPermissionForRole:
          'Create custom permission and add to this role',
        customPermissionsSelectPlaceholder: 'Select custom permissions',
        customPermissionsSelectEmpty:
          'No custom permissions yet. Use the link below to create one.',
        permissionsOrCustomRequired:
          'Choose at least one platform permission or one custom permission.',
        module: 'Module/Resource',
        admin: 'Admin',
        adminHasFullAccess:
          'The admin role automatically has all permissions; it cannot be edited.',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        adminAll: 'All permissions',
        noPermissions: 'No permissions',
        selectViewFirst: 'Select View permission first',
        allPermissionTooltip:
          'Includes records from the whole team, not only own.',
        deleteRoleConfirm: 'Delete this role?',
        roleNamePlaceholder: 'Role name',
        roleDescriptionPlaceholder: 'Description (optional)',
        permissionsUpdated: 'Permissions updated',
        unsavedChanges_one: '{{count}} unsaved change',
        unsavedChanges_other: '{{count}} unsaved changes',
        resetToDefault: 'Reset',
        roleCreated: 'Role created',
        roleUpdated: 'Role updated',
        roleDeleted: 'Role deleted',
        deleteRoleWarning: 'This action cannot be undone.',
        deletingRole: 'Deleting role',
        usersWithRole_one: '{{count}} user has this role.',
        usersWithRole_other: '{{count}} users have this role.',
        selectReplacementRole: 'Reassign users to',
        replacementRoleDescription:
          'Existing users with this role will be moved to the selected role.',
        selectRolePlaceholder: 'Select a role',
        permissionsCatalogTitle: 'Permissions catalog',
        permissionsCatalogDescription:
          'Permissions available for assignment to roles in this app.',
        searchPermissions: 'Find a permission…',
        addPermission: 'Add permission',
        editPermission: 'Edit permission',
        permissionCode: 'Code',
        permissionCodePlaceholder: 'e.g. invoices.create',
        permissionCodeHelp:
          'Auto-generated from the label — edit if needed. Used in the API and audit logs.',
        permissionCodeImmutable: 'Code cannot be changed after creation.',
        permissionCodeRequired: 'Code is required.',
        permissionCodeInvalid:
          'Use lowercase letters, digits and . _ : - only.',
        permissionLabel: 'Label',
        permissionLabelPlaceholder: 'e.g. Approve invoices',
        permissionLabelRequired: 'Label is required.',
        permissionDescription: 'Description',
        permissionCreated: 'Permission created',
        permissionUpdated: 'Permission updated',
        permissionDeleted: 'Permission deleted',
        deletePermissionTitle: 'Delete permission?',
        deletePermissionWarning_one:
          '{{count}} role will lose this permission. This cannot be undone.',
        deletePermissionWarning_other:
          '{{count}} roles will lose this permission. This cannot be undone.',
        emptyPermissionsCatalog:
          'No permissions defined yet. Add the first one to start assigning to roles.'
      },
      credentials: {
        intro:
          'Create API tokens scoped to this application. The token value is shown only once at creation or rotation — copy it then and store it securely.',
        create: 'Create credential',
        createDrawerTitle: 'New credential',
        editDrawerTitle: 'Edit credential',
        rotate: 'Rotate',
        revoke: 'Revoke',
        expiresAt: 'Expires at',
        expiresAtPlaceholder: 'No expiration',
        noExpiry: 'Never',
        permissions: 'Permissions',
        permissionsHint:
          'Permissions this token will have when calling this app.',
        permissionsPlaceholder: 'Select permissions',
        selectAll: 'Select all',
        clear: 'Clear',
        noPermissions: 'No permissions',
        noPermissionsHint:
          'This token has no scoped permissions; it identifies the integration but cannot access protected endpoints.',
        lastUsed: 'Last used',
        neverUsed: 'Never used',
        revealTitle: 'Save your credential',
        revealWarning:
          'This is the only time you can view this token. Copy it now and store it securely.',
        revealDone: 'I saved it',
        rotateConfirmTitle: 'Rotate credential?',
        rotateConfirmBody:
          'A new token will be issued. This credential keeps working unless you revoke it below.',
        revokeConfirmTitle: 'Revoke credential?',
        revokeConfirmBody:
          'This token will stop working for all integrations using it. This action cannot be undone.',
        revokedReason: 'Reason: {{reason}}',
        revokedAt: 'Revoked {{at}}',
        empty: 'No credentials yet.',
        toolbar: {
          credentialsLabel: 'credentials'
        },
        columns: {
          name: 'Name',
          permissions: 'Permissions',
          expires: 'Expires',
          lastUsed: 'Last used',
          status: 'Status',
          actions: 'Actions'
        }
      },
      credentialDetail: {
        breadcrumb: 'Credential',
        back: 'Back to {{app}} credentials',
        overviewTitle: 'Overview'
      },
      webhooks: {
        soonBadge: 'Soon',
        disabledHint:
          'Webhooks for workspace apps are not available yet. This tab is preview-only.',
        url: 'Webhook URL',
        events: 'Events (comma separated)',
        create: 'Create webhook',
        modalTitle: 'Create webhook',
        removeConfirm: 'Delete this webhook?',
        columns: {
          name: 'Name',
          url: 'URL',
          events: 'Events',
          actions: 'Actions'
        }
      }
    },
    perm: {
      workspace_settings: 'Workspace settings',
      workspace_members: 'Members',
      workspace_roles: 'Roles',
      workspace_security: 'Security',
      workspace_audit: 'Audit log',
      apps_manage: 'Apps (use)',
      apps_roles: 'App roles',
      apps_credentials: 'App credentials'
    },
    roles: {
      sectionTitle: 'Functions/Roles',
      sectionDescription:
        'Role templates define which workspace and app permissions members receive.',
      sectionDescriptionApi:
        'Organization roles from the API. Admins have implicit full access; other roles use explicit permission assignments.',
      sectionDescriptionManage:
        'Define job functions and workspace roles. Permission bundles for apps are managed under each app; link roles to functions to keep the directory clear.',
      manageHint:
        'Function headcounts match members whose job title equals the function name (until member–function is stored by the API). Role headcounts use role assignments on each member.',
      tabs: {
        functions: 'Functions',
        roles: 'Roles'
      },
      rolesTabIntro:
        'Workspace roles are assigned to members. Permissions for applications are configured in each app.',
      drawerClose: 'Close',
      actions: {
        viewDetails: 'Details'
      },
      editRoleTitle: 'Edit role',
      form: {
        functionLabel: 'Function',
        functionHelp:
          'Optional link to a function from the Functions tab (stored in this browser until the API supports it).',
        functionPlaceholder: 'Select a function'
      },
      details: {
        roleTitle: 'Role details',
        membersWithRole: 'Members with this role',
        membersWithAssignment: 'Members with this job title',
        noMembers: 'No members to show.',
        moreMembers: '…and {{count}} more.'
      },
      columns: {
        role: 'Role',
        description: 'Description',
        isAdmin: 'Admin role',
        permissions: 'Permissions',
        customCodes: 'Custom codes',
        updated: 'Updated',
        actions: 'Actions',
        headcount: 'Headcount',
        linkedFunction: 'Function'
      },
      functions: {
        add: 'Add function',
        addTitle: 'New function',
        editTitle: 'Edit function',
        detailsTitle: 'Function details',
        intro:
          'Functions describe job types (e.g. Sales, Engineering). Match the function name to a member job title to drive headcount.',
        nameLabel: 'Function name',
        headcountTooltip:
          'Count of members whose job title matches this function name (case-insensitive).',
        deleteConfirm:
          'Delete this function? Links from roles to this function are removed.',
        columns: {
          name: 'Function',
          codename: 'Codename',
          description: 'Description',
          updated: 'Updated'
        },
        messages: {
          created: 'Function created',
          updated: 'Function updated',
          deleted: 'Function deleted'
        },
        api: {
          createSuccess: 'Function created',
          updateSuccess: 'Function updated',
          deleteSuccess: 'Function deleted'
        }
      },
      addRole: 'Add role',
      nameLabel: 'Role name',
      codenameLabel: 'Code name',
      codenamePlaceholder: 'Optional; generated from name if empty',
      descriptionLabel: 'Description',
      permissionsLabel: 'Permissions',
      permissionsPickerLabel: 'Permissions',
      permissionsPickerPlaceholder: 'Search and select permissions',
      customPermissionsLabel: 'Custom permission codes',
      customPermissionsHelp:
        'Optional codes for product-specific checks (e.g. feature flags). They are stored with the role and appear in the matrix below.',
      customPermissionDuplicate:
        'Duplicate custom permission codes are not allowed on the same role.',
      customPermissionCodePlaceholder: 'e.g. contacts.read, reports.export',
      customPermissionCodeRequired: 'Permission code is required',
      customPermissionCodeInvalid:
        'Use lowercase letters, numbers, dots, hyphens, or underscores (max 64 chars)',
      addCustomPermission: 'Add permission code',
      editPermissions: 'Edit permissions',
      editPermissionsTitle: 'Edit permissions',
      editApiPermissions: 'Edit permissions',
      editApiPermissionsTitle: 'Edit role permissions',
      deleteConfirm:
        'Delete this role? Members using it move to the default role.',
      adminProtected: 'Protected',
      adminBadge: 'Admin',
      system: 'System',
      builtIn: 'Built-in',
      api: {
        createSuccess: 'Role created',
        updateSuccess: 'Role updated',
        deleteSuccess: 'Role deleted'
      },
      rolesTableTitle: 'Roles',
      matrix: {
        sectionTitle: 'Role → permission matrix',
        description:
          'Organization-level API permissions and custom codes by role. Admin roles implicitly include every row.',
        permission: 'Permission',
        customCodeBadge: 'Custom',
        customCodeHint: 'Not an API permission; enforced in your apps.',
        adminTooltip: 'Admin roles receive all permissions automatically.',
        noRoles: 'No roles to display.',
        noPermissions: 'No organization permissions loaded.'
      }
    },
    orgRoles: {
      sectionTitle: 'Roles & permissions',
      sectionDescription:
        'Define organization roles and the access each role grants.',
      addRole: 'Add role',
      createRole: 'Create role',
      editRole: 'Edit role',
      newRole: 'New role',
      save: 'Save',
      saveChanges: 'Save changes',
      cancel: 'Cancel',
      searchRoles: 'Search roles…',
      searchPermissions: 'Find a permission…',
      permissionsAll: 'All',
      emptyRoles: {
        title: 'No roles yet',
        description:
          'Create your first custom role to control workspace access.'
      },
      kpi: {
        workspaceRoles: 'Workspace roles',
        customRoles: 'custom',
        permissionsCatalog: 'Permissions catalog',
        appScopedRoles: 'App-scoped roles',
        permissionsFooter: '{{count}} resources'
      },
      tabs: {
        roles: 'Workspace roles',
        permissions: 'Permissions catalog'
      },
      matrix: {
        title: 'Permissions matrix',
        description:
          'Workspace roles bundle permissions. Owner and admin roles grant everything; built-in roles are fixed by the platform.',
        moduleColumn: 'Module/Resource',
        hint: 'Changes apply to every member holding the role.',
        reset: 'Reset changes',
        adminHasFullAccess: 'Admin roles receive every workspace permission.',
        grantsEverything: 'All permissions',
        noPermissions: 'No permissions',
        needsViewFirst:
          'Grant the category’s View permission first — the others build on it.',
        permissionsInMatrixHint:
          'Permissions are granted in the matrix, not here.'
      },
      columns: {
        role: 'Role',
        type: 'Type',
        permissions: 'Permissions',
        actions: 'Actions'
      },
      types: {
        owner: 'Owner',
        admin: 'Admin',
        custom: 'Custom',
        builtin: 'Built-in',
        workspace: 'Workspace',
        app: 'App-scoped'
      },
      groups: {
        builtin: 'Built-in · workspace',
        custom: 'Custom · workspace',
        app: 'App-scoped'
      },
      filters: {
        all: 'All',
        granted: 'Granted',
        denied: 'Denied'
      },
      actions: {
        edit: 'Edit',
        duplicate: 'Duplicate',
        replaceAndDelete: 'Replace & delete',
        delete: 'Delete',
        assign: 'Assign',
        selectAll: 'Select all',
        clear: 'Clear'
      },
      form: {
        name: 'Role name',
        namePlaceholder: 'e.g. Compliance reviewer',
        codename: 'Code name',
        codenameHelp:
          'Optional machine-readable identifier (e.g. sales_manager).',
        description: 'Description',
        descriptionPlaceholder:
          'Read-only access to audit logs and security events.',
        permissions: 'Permissions',
        permissionsPlaceholder: 'Search and select permissions',
        permissionsAdminTooltip:
          'Admin roles automatically receive every permission.',
        permissionsGeneral: 'General'
      },
      messages: {
        created: 'Role created',
        updated: 'Role updated',
        deleted: 'Role deleted',
        replaced: 'Members reassigned and role removed',
        permissionsUpdated: 'Permissions updated'
      },
      detail: {
        membersWithRole: 'Members with this role',
        noMembers: 'No members yet.',
        permissions: 'Permissions',
        ownerSubtitle:
          'Owner role · grants every permission, including future ones',
        permissionsSummary: '{{granted}} of {{total}} permissions enabled',
        roleId: 'Role ID',
        builtinNotice: 'Built-in roles cannot be edited.',
        duplicateToCustomize: 'Duplicate to customize →',
        ownerNotice:
          'The Owner role automatically grants every permission, including any added in the future.',
        adminAppNotice:
          'Admin roles automatically receive every permission for their scope ({{scope}}).',
        scopeWorkspace: 'workspace',
        scopeApp: 'this application',
        emptySelection: 'Select a role to view its details and permissions.',
        permissionsGroupAll: 'All {{group}}',
        permissionsGroupCount: '{{granted}}/{{total}}'
      },
      permission: {
        catalogTitle: 'Permissions catalog',
        catalogDescription:
          'Every permission the platform defines for this workspace. Roles bundle them; the catalog itself is fixed.',
        categoryLabel: 'Category',
        allCategories: 'All categories',
        categories: {
          organization: 'Workspace',
          users: 'Members',
          roles: 'Roles',
          groups: 'Groups',
          applications: 'Applications',
          attachments: 'Attachments',
          audit: 'Audit'
        },
        rolesUsing_one: '{{count}} role',
        rolesUsing_other: '{{count}} roles',
        empty: 'No permissions in this workspace yet.',
        codeLabel: 'Code',
        labelLabel: 'Label',
        builtinTag: 'Built-in',
        usedByRoles: 'Used by'
      },
      deleteConfirmTitle: 'Delete "{{name}}"?',
      deleteConfirmDescription:
        'This role will be removed. Members assigned to it must be moved to another role first.',
      archiveConfirmTitle: 'Replace and delete "{{name}}"?',
      archiveConfirmDescription:
        '{{count}} members currently have this role. Choose a replacement role for them.',
      selectRole: 'Select a role...',
      archiveAndReassign: 'Reassign & delete',
      archiveReassignWarning:
        'All {{count}} members will be reassigned to the "{{role}}" role.'
    },
    roleDetail: {
      members: 'Members',
      created: 'Created',
      edit: 'Edit',
      membersWithRole: 'Members with this role',
      searchMembers: 'Search members...',
      teamsWithRole: 'Teams granting this role',
      noTeams: 'No team grants this role.',
      revokeTeamConfirm:
        'Revoke this role from the team? Its members lose it, unless they also hold it personally.',
      memberColumns: {
        name: 'Name',
        email: 'Email',
        team: 'Team',
        source: 'Granted via',
        assigned: 'Assigned'
      },
      source: {
        personal: 'Personal',
        group: 'Group',
        viaGroupHint: 'Granted through membership in the {{group}} group.',
        viaGroupHintUnknown: 'Granted through group membership.'
      }
    },
    security: {
      sectionTitle: 'Security',
      sectionDescription:
        'Workspace authentication policy, sign-in methods, and enterprise SSO / SCIM.',
      tabs: {
        policy: 'Policy',
        signIn: 'Sign-in methods',
        customProviders: 'Custom providers'
      },
      apiPolicyNotice:
        'This policy form uses mock data. MFA, invite rules, and JIT settings are not exposed on this API yet. Use the Sign-in methods tab for live workspace configuration.',
      saved: 'Security policy saved',
      missingPolicy: 'No security policy found for this workspace.',
      authMethods: 'Allowed sign-in methods',
      mfaPolicy: 'MFA policy',
      invitePolicy: 'Invitation policy',
      jitProvisioning: 'Just-in-time provisioning from SSO',
      method: {
        password: 'Password',
        google: 'Google',
        microsoft: 'Microsoft',
        sso: 'Enterprise SSO'
      },
      mfa: {
        optional: 'Optional',
        requiredAdmins: 'Required for admins',
        requiredAll: 'Required for everyone'
      },
      invite: {
        inviteOnly: 'Invite only',
        domainRestricted: 'Domain restricted',
        open: 'Open join (trusted domains)'
      },
      policyCardTitle: 'Authentication policy',
      savePolicy: 'Save policy'
    },
    customProviders: {
      title: 'Custom identity providers',
      description:
        'Connect this workspace to your own OIDC, OAuth 2.0, or SAML 2.0 identity provider. Each provider becomes a sign-in option for members of this workspace.',
      addProvider: 'Add custom provider',
      editProvider: 'Edit custom provider',
      empty: 'No custom providers yet.',
      deleteConfirm:
        'Delete the "{{name}}" provider? Members linked to it will lose this sign-in option.',
      protocols: {
        oidc: 'OpenID Connect',
        oauth2: 'OAuth 2.0',
        saml2: 'SAML 2.0'
      },
      sections: {
        connection: 'Connection',
        claimMapping: 'Identity claim mapping'
      },
      columns: {
        name: 'Name',
        slug: 'Slug',
        protocol: 'Protocol',
        enabled: 'Enabled',
        actions: 'Actions'
      },
      actions: {
        edit: 'Edit',
        delete: 'Delete'
      },
      fields: {
        name: 'Display name',
        slug: 'Slug (URL identifier)',
        logo: 'Logo',
        logoNone: 'No logo (default shield)',
        logoPreset: 'Use a preset',
        logoPresetPick: 'Preset logo',
        logoUrl: 'Custom URL',
        logoUrlInput: 'Logo URL',
        logoUrlHelp:
          'Direct link to an SVG, PNG, or JPG (e.g. https://cdn.example.com/logo.svg).',
        logoPreview: 'Preview:',
        slugInvalid:
          'Slug must start with a letter and contain only lowercase letters, digits, hyphens, or underscores.',
        slugHelp: 'Used in callback URLs. Cannot be changed after creation.',
        protocol: 'Protocol',
        enabled: 'Enabled for sign-in',
        clientId: 'Client ID',
        clientSecret: 'Client secret',
        clientSecretHelp: 'Leave blank to keep the existing secret.',
        scope: 'Scope',
        issuerUrl: 'Issuer URL',
        issuerUrlHelp:
          "OIDC provider's base URL with /.well-known/openid-configuration support.",
        authorizeUrl: 'Authorize URL',
        authorizeUrlOptional:
          'Authorize URL (optional, discovered from issuer)',
        tokenUrl: 'Token URL',
        tokenUrlOptional: 'Token URL (optional, discovered from issuer)',
        userinfoUrl: 'Userinfo URL',
        userinfoUrlOptional: 'Userinfo URL (optional, discovered from issuer)',
        jwksUrl: 'JWKS URL',
        jwksUrlOptional: 'JWKS URL (optional, discovered from issuer)',
        samlEntityId: 'IdP entity ID',
        samlSsoUrl: 'SSO URL (HTTP-Redirect binding)',
        samlSloUrl: 'Single logout URL (optional)',
        samlX509Cert: 'IdP signing certificate (PEM)',
        samlX509CertHelp:
          'Public certificate the IdP uses to sign assertions. Paste the full PEM block.',
        emailClaim: 'Email claim',
        firstNameClaim: 'First name claim',
        lastNameClaim: 'Last name claim'
      },
      messages: {
        created: 'Custom provider created',
        updated: 'Custom provider updated',
        deleted: 'Custom provider deleted'
      }
    },
    authentication: {
      sectionTitle: 'Authentication',
      sectionDescription:
        'Control how members sign in to this workspace — sign-in methods, custom identity providers, and authentication policy.',
      previewTag: 'Preview',
      activeUsersTooltip_one: '{{count}} active user uses this method',
      activeUsersTooltip_other: '{{count}} active users use this method',
      tabs: {
        signIn: 'Sign-in methods',
        customProviders: 'Custom providers',
        policy: 'Policy'
      },
      summary: {
        title: 'Authentication methods',
        description:
          'Toggle built-in sign-in methods below or add a custom OIDC, OAuth 2.0, or SAML 2.0 identity provider.',
        active: 'Active',
        custom: 'Custom',
        ssoUsers: 'SSO users'
      },
      providersCard: {
        title: 'Sign-in providers',
        description:
          'Providers the workspace runs on its own credentials. Personal Google sign-in works without them.',
        setupGuide: 'Setup guide →',
        builtInGroup: 'Built-in methods'
      },
      providers: {
        password: 'Password',
        passwordSubtitle: 'Email + password',
        emailOtp: 'Email OTP',
        emailOtpSubtitle: 'One-time code by email',
        qrLogin: 'QR code',
        qrLoginSubtitle: 'Passwordless approval from mobile',
        google: 'Google',
        googleSubtitle:
          'Your own Google OAuth client — limits sign-in to your organization',
        entraid: 'Microsoft Entra ID',
        entraidSubtitle:
          'Your own Entra ID app — limits sign-in to your tenant',
        apple: 'Apple',
        appleSubtitle: 'Your own Apple service ID and key',
        passkey: 'Passkey / WebAuthn',
        passkeySubtitle: 'Hardware keys, Touch ID, Windows Hello',
        appleTeamId: 'Team ID',
        apiPendingLabel: 'API pending',
        apiPendingHint:
          'Backend endpoint for this provider is not deployed yet — toggling has no effect.',
        needsSetupLabel: 'Needs setup',
        needsSetupHint:
          'Enabled but credentials are missing. Click the gear to complete setup.',
        mockOnlyLabel: 'Preview',
        mockOnlyHint: 'This field is not yet sent to the API.',
        setupGuide: 'Open setup guide',
        credentialsTitle: 'Credentials',
        noConfigTitle: 'Works out of the box',
        noConfigGeneric:
          'This provider has no per-workspace configuration. Toggle it on or off in the providers list.',
        noConfig: {
          password:
            'Password sign-in is built in. Toggle it off only after a verified SSO connection is in place.',
          passkey:
            'Passkey / WebAuthn relies on each user enrolling a credential from their profile — no admin setup required.',
          email_otp:
            'Email OTP delivers a one-time code by email. The backend endpoint is still being wired — this row is a preview.',
          qr_login:
            'QR code sign-in lets members approve a browser login from the Skalx mobile app.'
        }
      },
      actions: {
        settings: 'Provider settings',
        save: 'Save changes',
        reset: 'Reset',
        setup: 'Open setup',
        viewInfo: 'View info'
      },
      additionalSettings: {
        title: 'Additional authorization settings',
        description:
          'Workspace-level controls stored as authentication configuration.',
        autoProvisionDefaultRole: 'Default role',
        enforceSso: {
          title: 'Enforce SSO for all members',
          description:
            'Disable password sign-in once an SSO connection is verified for every member. Password remains available for recovery only.'
        },
        selfServiceJoin: {
          title: 'Allow self-service join requests',
          description:
            'Users with a verified workspace domain can request to join. Admins approve from the Members page.'
        },
        autoProvision: {
          title: 'Auto-provision users from identity providers',
          description:
            'When a user signs in via SSO for the first time, automatically create the account with the default role.'
        }
      },
      customProviders: {
        title: 'Custom identity providers',
        description:
          'Connect this workspace to your own OIDC, OAuth 2.0, or SAML 2.0 identity provider. Each provider becomes a sign-in option for members.',
        docs: 'Docs',
        add: 'Add custom provider',
        addProvider: 'Add custom provider',
        editProvider: 'Edit custom provider',
        addProviderHint: 'Connect any OIDC, OAuth 2.0, or SAML 2.0 IdP',
        createProvider: 'Create provider',
        setupGuide: 'OIDC setup guide →',
        emptyTitle: 'No custom providers yet',
        emptyDescription:
          'Add Auth0, Okta, Keycloak or any OIDC / SAML provider to let members sign in with your existing identity stack.',
        searchPlaceholder: 'Search by name, slug or issuer',
        noResultsTitle: 'No providers match your search',
        noResultsDescription:
          'Nothing matches "{{search}}". Clear the search to see every provider.',
        deleteConfirm:
          'Delete the "{{name}}" provider? Members linked to it will lose this sign-in option.',
        lastSyncLabel: 'Last updated',
        callbacksHint:
          "Copy these URLs into your identity provider's allowed redirect list.",
        protocols: {
          oidc: 'OpenID Connect',
          oauth2: 'OAuth 2.0',
          saml2: 'SAML 2.0'
        },
        sections: {
          identity: 'Identity',
          connection: 'Connection',
          attributeMapping: 'Attribute mapping',
          provisioning: 'Provisioning',
          callbackUrls: 'Callback URLs',
          oidcAdvanced: 'Advanced — override OIDC discovery'
        },
        columns: {
          name: 'Name',
          slug: 'Slug',
          protocol: 'Protocol',
          enabled: 'Enabled'
        },
        actions: {
          edit: 'Edit provider',
          delete: 'Delete',
          deleteProvider: 'Delete provider',
          test: 'Test connection',
          rotate: 'Rotate secret',
          audit: 'View audit'
        },
        callbacks: {
          redirect: 'Redirect URI',
          logout: 'Logout URI',
          metadata: 'Metadata URL'
        },
        fields: {
          displayName: 'Display name',
          slug: 'Slug (URL identifier)',
          slugHelp: 'Used in callback URLs. Cannot be changed after creation.',
          slugInvalid:
            'Slug must start with a letter and contain only lowercase letters, digits, hyphens, or underscores.',
          protocol: 'Protocol',
          enabled: 'Enabled for sign-in',
          logo: 'Logo',
          logoNone: 'No logo (default shield)',
          logoPreset: 'Use a preset',
          logoPresetPick: 'Preset logo',
          logoUrl: 'Custom URL',
          logoUrlInput: 'Logo URL',
          logoUrlHelp:
            'Direct link to an SVG, PNG, or JPG (e.g. https://cdn.example.com/logo.svg).',
          logoPreview: 'Preview:',
          clientId: 'Client ID',
          clientSecret: 'Client secret',
          clientSecretHelp: 'Leave blank to keep the existing secret.',
          scope: 'Scope',
          issuerUrl: 'Issuer URL',
          issuerUrlHelp:
            "OIDC provider's base URL with /.well-known/openid-configuration support.",
          authorizeUrl: 'Authorize URL',
          authorizeUrlOptional:
            'Authorize URL (optional, discovered from issuer)',
          tokenUrl: 'Token URL',
          tokenUrlOptional: 'Token URL (optional, discovered from issuer)',
          userinfoUrl: 'Userinfo URL',
          userinfoUrlOptional:
            'Userinfo URL (optional, discovered from issuer)',
          jwksUrl: 'JWKS URL',
          jwksUrlOptional: 'JWKS URL (optional, discovered from issuer)',
          samlEntityId: 'IdP entity ID',
          samlSsoUrl: 'SSO URL (HTTP-Redirect binding)',
          samlSloUrl: 'Single logout URL (optional)',
          samlX509Cert: 'IdP signing certificate (PEM)',
          samlX509CertHelp:
            'Public certificate the IdP uses to sign assertions. Paste the full PEM block.',
          emailClaim: 'Email claim',
          firstNameClaim: 'First name claim',
          lastNameClaim: 'Last name claim',
          provisioningOnFirstSignIn: 'On first sign-in'
        },
        provisioning: {
          jitTitle: 'Just-in-time provisioning',
          jitDescription:
            'Create the user automatically with the default role.',
          approvalTitle: 'Require admin approval',
          approvalDescription:
            'Sign-in attempts create a request that an admin must approve.',
          explicitTitle: 'Pre-provisioned users only',
          explicitDescription:
            'Reject sign-ins for users not already in the workspace.'
        },
        messages: {
          created: 'Custom provider created',
          updated: 'Custom provider updated',
          deleted: 'Custom provider deleted'
        }
      },
      policy: {
        shippingSoon: 'Authentication policy is shipping soon.',
        shippingSoonDescription:
          "The fields below preview what you'll be able to configure when it lands.",
        password: {
          title: 'Password policy',
          minLength: 'Minimum length',
          reusePrevention: 'Reuse prevention',
          maxAge: 'Maximum age',
          characters_one: '{{count}} character',
          characters_other: '{{count}} characters',
          noRestriction: 'No restriction',
          lastN_one: 'Last {{count}} password',
          lastN_other: 'Last {{count}} passwords',
          neverExpires: 'Never expires',
          days_one: '{{count}} day',
          days_other: '{{count}} days',
          requireUpper: 'Require uppercase',
          requireLower: 'Require lowercase',
          requireNumber: 'Require number',
          requireSymbol: 'Require symbol',
          rejectLeaked: 'Reject leaked passwords (HIBP)'
        },
        mfa: {
          title: 'MFA policy',
          requireMfaAdmins: 'Require MFA for owners and admins',
          requireMfaAll: 'Require MFA for all members',
          allowSmsFallback: 'Allow SMS as a fallback method',
          requireWebAuthnOwners: 'Require WebAuthn for owners'
        },
        session: {
          title: 'Session policy',
          idleTimeout: 'Idle timeout',
          absoluteTimeout: 'Absolute timeout',
          minutes_one: '{{count}} minute',
          minutes_other: '{{count}} minutes',
          days_one: '{{count}} day',
          days_other: '{{count}} days'
        }
      }
    },
    ssoScim: {
      sectionTitle: 'SSO / SCIM',
      sectionDescription:
        'Enterprise SSO connections and SCIM directory sync for this workspace.',
      ssoTitle: 'SSO connections',
      scimTitle: 'SCIM provisioning',
      ssoEmpty: 'No SSO connections yet.',
      scimEmpty: 'No SCIM connection configured.',
      enabled: 'Enabled',
      disabled: 'Disabled',
      scimProvider: 'Provider',
      scimStatus: 'Status',
      scimEndpoint: 'Endpoint',
      scimToken: 'Bearer token (last four)',
      scimGroupMapping: 'Group → role mapping',
      scimLastSync: 'Last sync',
      columns: {
        name: 'Name',
        provider: 'Provider',
        protocol: 'Protocol',
        domain: 'Email domain',
        status: 'Status',
        certRotated: 'Cert rotated',
        actions: 'Actions'
      },
      addConnection: 'Add SSO connection',
      addScimConnection: 'Add SCIM connection',
      addModalTitle: 'Add SSO connection',
      providerLabel: 'Provider',
      protocolLabel: 'Protocol',
      domainLabel: 'Email domain',
      createSuccess: 'SSO connection added',
      protocol: {
        saml: 'SAML 2.0',
        oidc: 'OpenID Connect'
      },
      connectionStatus: {
        active: 'Active',
        inactive: 'Inactive'
      },
      actions: {
        activate: 'Activate',
        deactivate: 'Deactivate',
        rotateCertificate: 'Rotate certificate',
        remove: 'Remove',
        syncNow: 'Run sync',
        rotateToken: 'Rotate token',
        disconnect: 'Disconnect',
        enableScim: 'Enable SCIM'
      },
      confirmRemoveSso:
        'Remove this SSO connection? Members using it may be affected.',
      confirmDisconnectScim:
        'Disconnect SCIM for this workspace? Directory sync will stop until you enable it again.',
      enableScimDrawerTitle: 'Enable SCIM',
      scimEndpointUrlLabel: 'SCIM base URL',
      messages: {
        ssoRemoved: 'SSO connection removed',
        certificateRotated: 'Certificate rotation recorded',
        scimSynced: 'Directory sync completed',
        tokenRotated: 'SCIM token rotated',
        scimDisconnected: 'SCIM disconnected',
        scimEnabled: 'SCIM enabled'
      }
    },
    domains: {
      sectionTitle: 'Domains',
      sectionDescription: 'Verified domains and how new members may join.',
      empty: 'No domain rules yet.',
      verified: {
        yes: 'Verified',
        no: 'Pending'
      },
      columns: {
        domain: 'Domain',
        mode: 'Join policy',
        verified: 'Verification',
        actions: 'Actions'
      },
      mode: {
        allow_invite: 'Invite with domain email',
        auto_join: 'Auto-join',
        claim_required: 'Claim / admin approval'
      },
      tableTitle: 'Domain rules',
      addDomain: 'Add domain',
      addModalTitle: 'Add domain rule',
      domainLabel: 'Domain',
      modeLabel: 'Join policy',
      createSuccess: 'Domain rule added',
      verifyDomain: 'Mark verified',
      deleteDomain: 'Remove',
      confirmDelete: 'Remove this domain rule?',
      verifiedSuccess: 'Domain marked as verified',
      deletedSuccess: 'Domain rule removed'
    },
    auditPage: {
      sectionTitle: 'Audit log',
      sectionDescription:
        'Every change in the workspace — searchable, exportable, retained 90 days.',
      empty: 'No audit events for this workspace yet.',
      noMatches: 'No events match the current filters.',
      openDetails: 'Open details for {{event}}',
      actor: 'Actor',
      target: 'Target',
      searchPlaceholder: 'Search events…',
      dateRangeLabel: 'Date range',
      tabs: {
        events: 'Events',
        exports: 'Exports'
      },
      filters: {
        allActions: 'Action',
        allSeverities: 'Severity',
        allApplications: 'Application',
        allActors: 'Actor',
        allActorTypes: 'Actor type',
        entityId: 'Entity ID',
        clear: 'Clear'
      },
      toolbar: {
        events_one: '{{count}} event',
        events_other: '{{count}} events',
        refresh: 'Refresh'
      },
      actions: {
        export: 'Export'
      },
      exportModal: {
        title: 'Export audit log',
        description:
          'Generate a downloadable archive of audit events. Ready archives appear in the Exports list.',
        periodLabel: 'Period',
        formatLabel: 'Format',
        formatCsv: 'CSV',
        formatXlsx: 'Excel (XLSX)',
        formatJsonl: 'JSON Lines',
        filtersLabel: 'Filters that will be applied',
        filtersNone: 'No filters — all events in the selected period',
        filters: {
          service: 'Service',
          search: 'Search',
          action: 'Action',
          severity: 'Severity',
          application_id: 'Application',
          entity_type: 'Entity type',
          entity_id: 'Entity ID',
          actor_id: 'Actor'
        },
        submit: 'Request export',
        cancel: 'Cancel',
        queued: 'Export requested — it will appear in the Exports list soon.',
        viewExports: 'View exports',
        failed: 'Could not queue the export. Please try again.'
      },
      exports: {
        empty: 'No exports yet — request one from the Events tab.',
        total_one: '{{count}} export',
        total_other: '{{count}} exports',
        refresh: 'Refresh',
        filters: {
          allStatuses: 'Status',
          includeAppScoped: 'Include app-scoped'
        },
        columns: {
          period: 'Period',
          format: 'Format',
          status: 'Status',
          requestedBy: 'Requested by',
          fileSize: 'Size',
          createdAt: 'Created',
          actions: 'Actions'
        },
        status: {
          pending: 'Pending',
          processing: 'Processing',
          ready: 'Ready',
          failed: 'Failed'
        },
        actions: {
          download: 'Download',
          delete: 'Delete'
        },
        bulk: {
          selected_one: '{{count}} selected',
          selected_other: '{{count}} selected',
          delete: 'Delete selected',
          clear: 'Clear selection'
        },
        confirmDeleteTitle: 'Delete this export?',
        confirmDeleteContent:
          'The archive will be removed and cannot be recovered.',
        confirmBulkDeleteTitle: 'Delete selected exports?',
        confirmBulkDeleteContent:
          '{{count}} archives will be removed and cannot be recovered.',
        deleteSuccess: 'Export deleted.',
        bulkDeleteSuccess: 'Selected exports deleted.',
        deleteFailed: 'Could not delete the export. Please try again.',
        downloadFailed: 'Could not download the export. Please try again.'
      },
      columns: {
        time: 'Time',
        application: 'Application',
        severity: 'Severity',
        actor: 'Actor',
        action: 'Action',
        description: 'Description',
        target: 'Target',
        scope: 'Scope',
        ip: 'IP'
      },
      pagination: {
        range: '{{from}}–{{to}} of {{total}}'
      }
    },
    settings: {
      sectionTitle: 'Settings',
      sectionDescription: 'Manage your workspace configuration',
      general: 'General',
      workspaceName: 'Workspace name',
      domain: 'Domain',
      save: 'Save changes',
      saved: 'Settings saved successfully',
      savedFields: 'Saved fields: name, domain, logo',
      auditChanges: 'Audit changes',
      auditChangesPreview: 'Workspace change-history is not wired yet.',
      changeDomain: 'Change domain',
      domainLockedHint:
        'The workspace domain is locked. Click "Change domain" to unlock with a confirmation step.',
      domainUnlockedNotice:
        'Domain editing is unlocked. Changes will be applied on Save and will break existing login URLs.',
      domainConfirmTitle: 'Change workspace domain?',
      domainConfirmDescription:
        'Type the current domain to unlock domain editing for "{{name}}".',
      domainConfirmWarning:
        'Changing the domain breaks existing sign-in URLs, magic links, and any external integrations that reference it. Notify your members before saving.',
      domainConfirmButton: 'Unlock domain editing',
      descriptionLabel: 'Description',
      descriptionHelp:
        'Optional. Shown in the workspace switcher and on the public sign-in page.',
      descriptionPlaceholder: 'One-line description of this workspace',
      languages: {
        default: 'Default language',
        defaultHelp:
          'New members and anyone without a saved preference start in this language.',
        enabled: 'Enabled languages',
        enabledHelp:
          'Only these languages are offered to members in their profile settings.',
        enabledRequired: 'Enable at least one language.',
        defaultMustBeEnabled:
          'The default language must be one of the enabled languages.',
        placeholder: 'Select languages'
      },
      branding: {
        title: 'Branding',
        scope: 'Applies to sign-in pages & emails',
        recommended: 'Recommended',
        primaryColor: 'Primary color',
        signInBackground: 'Sign-in background',
        signInBackgroundHint:
          'PNG or JPG, up to 2 MB. The image fills the sign-in panel and may be cropped.',
        bgSolid: 'Solid',
        bgGradient: 'Gradient',
        bgImage: 'Image',
        dragDrop: 'Drag & drop, or click to upload',
        fileTypes: 'Any image, up to 5 MB · SVG up to {{svgSize}} MB',
        fileTooLarge: 'Image must be smaller than 5 MB',
        pickerHint:
          'Image or gradient · fills the sign-in panel and may be cropped.',
        configure: 'Configure',
        apply: 'Apply',
        upload: 'Upload',
        change: 'Change',
        remove: 'Remove',
        emailFromName: 'Email "from" name',
        poweredByTitle: 'Show "Powered by Skalx" badge',
        poweredByDescription:
          'Visible on sign-in pages. Available on Business and above; hide it on Enterprise.'
      },
      danger: {
        deleteTitle: 'Delete this workspace',
        deleteDescription:
          'Permanently delete this workspace and all its data.',
        deleteWarning: 'This cannot be undone.',
        deleteWarningBlock:
          'Every user, role, app, audit event and API key in this workspace will be permanently deleted.',
        deleteButton: 'Delete workspace',
        deleteConfirmTitle: 'Delete workspace',
        deleteConfirmDescription:
          'Type the workspace name "{{name}}" to confirm permanent deletion.',
        transferTitle: 'Transfer ownership',
        transferDescription:
          'Hand this workspace over to another member. You stay an admin.',
        transferButton: 'Transfer ownership',
        transferMemberLabel: 'New owner',
        transferMemberPlaceholder: 'Pick a member',
        transferConfirmDescription:
          'They gain full control of the workspace, including billing and deletion. You keep admin access but cannot undo this yourself.',
        transferSuccess: '{{name}} is now the workspace owner',
        acting: 'Acting on:'
      },
      footer: {
        created: 'Created {{date}}'
      },
      dangerZone: 'Danger Zone',
      deleteSuccess: 'Workspace deleted successfully',
      typeToConfirm: 'Type "{{name}}" to confirm',
      demoDataSection: 'Demo data',
      demoDataDescription: 'Manage example data inside this workspace',
      recreateDemoDataTitle: 'Recreate demo data',
      recreateDemoDataDescription:
        'Seed example data using the selected industry preset. Existing records may be overwritten.',
      recreateDemoData: 'Recreate',
      recreateDemoDataConfirmTitle: 'Recreate demo data',
      recreateDemoDataConfirmDescription:
        'Choose what kind of demo data you want to create for this workspace.',
      clearDemoDataTitle: 'Clear demo data',
      clearDemoDataDescription:
        'Wipe demo records across all connected services (CRM, HRM, etc.). The workspace structure, members and settings stay intact.',
      clearDemoData: 'Clear',
      clearDemoDataConfirmTitle: 'Clear demo data?',
      clearDemoDataConfirmDescription:
        'Demo records (candidates, deals, contacts and other example entities) will be permanently removed from every connected service.',
      clearDemoDataWarning: 'This will permanently delete demo records',
      demoDataBuildStarted: 'Demo data build started',
      demoDataNothingToCreate:
        'Nothing to create for this demo data type in this workspace',
      demoDataNothingToClear:
        'There is no demo data to clear in this workspace',
      demoDataIndustryLabel: 'Demo data type',
      demoDataIndustryRequired: 'Please choose a demo data type',
      demoDataInstallMissingAppsLabel: 'Add missing apps first',
      demoDataInstallMissingAppsHint:
        "Turn this on if the selected demo data needs apps that aren't in this workspace yet. Otherwise, demo data for missing apps will be skipped."
    }
  },
  workspaces: {
    onboarding: {
      documentTitle: 'Set up your workspace',
      creating: 'Creating the workspace…',
      createWorkspace: 'Create workspace',
      backToWorkspace: 'Back to workspace',
      steps: {
        details: 'Details',
        template: 'Template',
        attribution: 'How you found us',
        invite: 'Invite members',
        done: 'Done'
      },
      details: {
        title: 'Set up your workspace',
        iconLabel: 'Workspace icon',
        iconUpload: 'Upload',
        iconChange: 'Replace',
        addressShort: 'At least {{min}}',
        iconPreview: 'Preview picture',
        iconRemove: 'Remove picture',
        iconHint:
          'PNG or JPG up to {{max}}×{{max}} px, or SVG. Square images look best.',
        iconError: {
          format: 'Only PNG, JPG and SVG images are supported.',
          dimensions:
            'The image is larger than {{max}}×{{max}} px. Resize it and try again.',
          unreadable: 'That file could not be read as an image.'
        },
        nameLabel: 'Company name',
        namePlaceholder: 'Enter your company name…',
        addressLabel: 'Company address',
        addressPlaceholder: 'your-company',
        addressFree: 'Available',
        addressTaken: 'Taken',
        sizeLabel: 'Company size'
      },
      join: {
        title: 'Your company is already on Skalx',
        subtitle:
          'Your email domain belongs to a workspace that already exists. Ask to be let in, rather than starting a second one beside it.',
        existingWorkspace: 'Existing workspace',
        request: 'Request access',
        requested: 'Request sent',
        createInstead: 'Create a separate workspace instead',
        pendingTitle: 'Waiting for an administrator',
        pendingBody:
          'An administrator of this workspace has been notified. You will get an email as soon as they decide.',
        rejectedTitle: 'Declined'
      },
      companySize: {
        '1-10': '1–10',
        '11-50': '10+',
        '51-200': '50+',
        '201-1000': '200+'
      },
      template: {
        title: 'Would you like to add sample data to explore the platform?',
        subtitle:
          'Choose your industry for relevant examples, or select Generic.',
        industryEyebrow: 'Industry',
        priorityEyebrow: 'Your main priority',
        clean: 'Clean workspace'
      },
      priority: {
        deal_pipeline: 'Manage a deal pipeline',
        stop_losing_deals: 'Stop losing deals',
        automate_routine: 'Automate follow-ups',
        forecast_revenue: 'Forecast revenue',
        customer_support: 'Answer customers faster',
        off_spreadsheets: 'Move off spreadsheets',
        other: 'Something else'
      },
      attribution: {
        title: 'How did you find us?',
        options: {
          google: 'Google',
          youtube: 'YouTube',
          linkedin: 'LinkedIn',
          reviews: 'Review sites',
          referral: 'Referral',
          ai_assistant: 'AI assistant',
          event: 'Event',
          press: 'Press',
          other: 'Other'
        }
      },
      invite: {
        title: 'Invite your team',
        emailPlaceholder: 'teammate@company.com',
        addAnother: 'Add another',
        removeRow: 'Remove this row',
        skip: 'Skip for now',
        send: 'Send invites',
        roles: {
          member: 'Member',
          admin: 'Admin',
          viewer: 'Viewer — not available yet'
        }
      },
      errors: {
        nameRequired: 'Workspace name is required.',
        handleTooShort: 'Company address needs at least 3 characters.',
        sizeRequired: 'Pick a company size.',
        industryRequired:
          'Pick an industry, or choose a clean workspace — this decides what loads next.',
        priorityRequired: 'Pick your main priority.',
        authRequired: 'Leave at least one sign-in method enabled.',
        googleClientIdRequired:
          'Google SSO needs a client ID, otherwise the option cannot sign anyone in.',
        inviteInvalid: 'One of the email addresses isn’t valid.'
      },
      done: {
        titleWorking: 'Setting up workspace “{{name}}”',
        title: 'Workspace “{{name}}” is ready',
        open: 'Open workspace',
        setupRunning: 'Setting up the environment (loading demo data)',
        setupFinished: 'Environment ready',
        setupView: 'Details',
        copyLink: 'Copy invite link',
        linkCopied: 'Link copied',
        copyFailed: 'Could not copy the link.',
        profileFailed:
          'The workspace exists, but your answers could not be saved, so nothing was set up from them. You can build the sample data from Workspace settings.',
        invitesFailed: 'Some invitations could not be sent.',
        photoFailed:
          'The workspace picture could not be attached. You can upload it again in Workspace settings.',
        authFailed:
          'Sign-in methods could not be fully applied. Finish that in Authentication.',
        build: {
          members: 'Members',
          steps: 'What is being set up',
          activity: 'Recent activity',
          starting: 'Queueing the build',
          ready: 'Ready — you can open it',
          failed: 'Some steps did not finish',
          preparing: 'Preparing your workspace',
          writing: 'writing…',
          status: {
            queued: 'queued',
            running: 'running',
            done: 'done',
            failed: 'failed',
            skipped: 'skipped'
          },
          stepNames: {
            roles: 'Roles and permissions',
            signIn: 'Sign-in methods',
            apps: 'Applications',
            members: 'Members and access',
            demoData: 'Demo data'
          },
          industry: 'Industry',
          priority: 'Main goal',
          demoSkipped: 'Demo data skipped — the workspace is empty',
          byYourChoice: 'your choice',
          emptyTitle: 'The workspace is empty — start with your first record',
          emptyBody:
            'Import your own data or add a deal by hand · demo data can be built later',
          emptyAction: 'Import'
        },
        checks: {
          created: 'Workspace {{name}} created',
          owner: 'You are the owner of this workspace',
          authMethods: '{{count}} sign-in methods active',
          template: 'Apps enabled, data built from the {{preset}} template',
          cleanWorkspace: 'Clean workspace — no sample data was loaded',
          invites: '{{count}} invites sent',
          noInvites: 'No invites sent yet'
        },
        cards: {
          steps: '{{count}} steps',
          crm: {
            title: 'Set up CRM',
            badge: 'Recommended',
            body: 'Get your real pipeline in and connect the channels your clients already use.',
            items: {
              import: 'Import your existing data',
              pipeline: 'Shape your opportunity pipeline',
              messengers: 'Connect messengers',
              email: 'Connect email & calendar'
            }
          },
          workspace: {
            title: 'Set up your workspace',
            body: 'Bring your team in, decide who can do what, and turn on SSO and MFA.',
            items: {
              invite: 'Invite your team',
              roles: 'Roles & permissions',
              auth: 'Authentication & security',
              settings: 'Workspace settings'
            }
          }
        }
      },
      preview: {
        activity: 'Recent activity',
        nav: {
          workspace: 'Workspace',
          home: 'Home',
          overview: 'Overview',
          identity: 'Identity',
          users: 'Users',
          organization: 'Organization',
          roles: 'Roles',
          authentication: 'Authentication',
          applications: 'Applications',
          apps: 'Apps',
          agents: 'Agents',
          compliance: 'Compliance',
          audit: 'Audit log',
          graph: 'Company graph',
          settings: 'Settings',
          workspaceSettings: 'Workspace settings'
        },
        meta: {
          primaryDomain: 'Primary domain',
          created: 'Created',
          today: 'Today',
          yourRole: 'Your role',
          owner: 'owner'
        },
        stats: {
          title: 'Workspace stats',
          members: 'Members',
          apps: 'Apps',
          roles: 'Roles',
          authMethods: 'Sign-in methods'
        },
        greeting: {
          morning: 'Good morning, {{name}}.',
          afternoon: 'Good afternoon, {{name}}.',
          evening: 'Good evening, {{name}}.'
        }
      },
      spotlight: {
        name: {
          label: 'Company name',
          why: 'the header everyone lands on'
        },
        logo: {
          label: 'Workspace icon',
          why: 'the tile in the sidebar and app rail'
        },
        handle: {
          label: 'Company address',
          why: 'the URL your team signs in at'
        },
        domain: {
          label: 'Primary domain',
          why: 'identifies this workspace everywhere'
        },
        template: {
          label: 'Applications',
          why: 'the industry decides what goes into the demo data'
        },
        security: {
          label: 'Sign-in methods',
          why: 'editable later in Authentication'
        },
        members: { label: 'Members', why: 'invited people appear here' },
        role: { label: 'Your role', why: 'owner — full control' }
      }
    },
    pageTitle: 'Workspaces',
    pickerDescription: 'Pick a workspace to jump into, or spin up a new one.',
    searchPlaceholder: 'Search by name or domain',
    empty: "You don't belong to any workspace yet.",
    emptyFiltered: 'No workspaces match your search.',
    clearSearch: 'Clear search',
    externalAccess: 'Opens in workspace',
    members: 'members',
    member: 'member',
    membersCount_one: '{{count}} member',
    membersCount_other: '{{count}} members',
    backToList: 'Back to workspaces',
    accessDenied: {
      noAccess: {
        title: 'Wrong account',
        description:
          "The account you're signed in with doesn't have access to this workspace. Sign in with a different account to continue.",
        switchAccount: 'Sign in with a different account',
        backToWorkspaces: 'Go to your workspaces'
      },
      insufficientRole: {
        title: "You don't have access to this",
        description:
          'You do not hold the permission this section requires. Ask a workspace admin to grant it.',
        goToSection: 'Go to {{section}}'
      }
    },
    create: {
      eyebrow: 'New workspace',
      title: 'Create workspace',
      description:
        'Set up a workspace for your team in a few quick steps. You can change everything later in Workspace settings.',
      details: {
        title: 'Workspace details',
        subtitle: 'Give your workspace an identity and a URL.',
        nameLabel: 'Workspace name',
        namePlaceholder: 'Acme, Inc.',
        nameHelper:
          'A recognizable name shown to your team. You can change it later.',
        domainLabel: 'Workspace domain',
        domainPlaceholder: 'acme',
        domainHelper:
          'Lowercase letters, numbers and dashes. Used as your workspace URL.'
      },
      logo: {
        label: 'Workspace logo',
        change: 'Change',
        remove: 'Remove',
        upload: 'Upload logo',
        hint: 'PNG or JPG, up to 2 MB. Square images look best.'
      },
      submit: 'Create workspace',
      backToDetails: 'Back to details',
      auth: {
        applyFailed:
          'Workspace was created, but authorization methods could not be fully applied. You can finish setup in Workspace Settings.'
      },
      demoDataFailed:
        'Workspace was created, but demo data could not be imported. You can still use your workspace.',
      submitFailedSwitchedStep:
        'Workspace could not be created. Check the highlighted field on the previous step.',
      steps: {
        details: 'Workspace details',
        authorization: 'Authorization',
        basics: 'Details',
        template: 'Template',
        security: 'Security'
      },
      stepCounter: 'Step {{current}} of {{total}}',
      template: {
        label: 'Workspace template',
        withBuiltIn: 'Workspace with built-in apps and demo setup',
        clean: 'Clean workspace (no built-in apps)',
        cleanDescription: 'Start empty — perfect for trying things out.',
        builtInPreset: 'Built-in apps preset',
        loadingPresets: 'Loading presets…'
      },
      authorization: {
        methodsLabel: 'Authorization methods',
        methodsHint: 'Enable at least one sign-in option for this workspace.',
        customTitle: 'Custom authorization providers',
        customEmpty:
          'No custom providers yet. Add one if this workspace needs a dedicated enterprise identity setup.',
        atLeastOneMethod:
          'At least one sign-in method must remain enabled for this workspace.',
        password: 'Login + password'
      },
      invite: {
        stepTitle: 'Invite Members',
        title: 'Invite your team',
        description:
          'Add members to get started. You can always invite more later.',
        byEmail: 'Invite by email',
        emailPlaceholder: 'Enter email address',
        selectRole: 'Select role',
        defaultRole: 'Default role',
        chipPlaceholder: 'Enter email…',
        chipPlaceholderMore: 'Add another email…',
        chipHint:
          'Press Enter, comma or Tab to add. Paste a list to add multiple at once.',
        invalidEmails: 'Invalid emails skipped: {{emails}}',
        add: 'Add',
        pending: 'Pending invitations ({{count}})',
        orgRole: {
          admin: 'Admin',
          employee: 'Employee'
        },
        appRoles: 'Per-application roles',
        appRolesHint:
          'Assign a role for each application this member will use.',
        noApplications: 'No applications available in this workspace yet.',
        skipForNow: 'Skip for now',
        sendAndFinish: 'Send Invites & Finish',
        sent: 'Sent {{count}} invitation(s)',
        sendFailed: 'Workspace created, but some invitations could not be sent.'
      }
    }
  },
  workspaceSwitcher: {
    placeholder: 'Switch workspace',
    ariaLabel: 'Active workspace'
  },
  workspaceAuth: {
    personalMethodsTitle: 'Personal sign-in methods in this workspace',
    personalMethodsDescription:
      'Link or unlink your personal account methods for workspace "{{workspace}}".'
  },
  account: {
    settings: {
      pageTitle: 'Account settings',
      pageSubtitle:
        'Manage your personal profile, sign-in methods, and preferences. Create or join workspaces from the Workspaces section when you are ready.',
      navAriaLabel: 'Account settings sections'
    },
    menu: {
      basic: 'Basic profile',
      authentication: 'Authentication',
      audit: 'Audit',
      security: 'Security',
      connectedAccounts: 'Connected accounts',
      notifications: 'Notifications',
      sessions: 'Sessions & devices'
    },
    section: {
      personal: 'Basic profile',
      personalDescription:
        'View and update your contact details and personal information.',
      authentication: 'Authentication',
      authenticationDescription:
        'Manage your connected sign-in methods and security policies.',
      audit: 'Audit',
      auditDescription:
        'Review recent activity and security events on your account.',
      security: 'Security',
      notifications: 'Notifications',
      notificationsDescription:
        'Control which notifications you receive and review recent activity.',
      connectedAccounts: 'Connected accounts',
      sessions: 'Sessions & devices',
      sessionsDescription:
        'View active sessions across your devices and revoke access when needed.'
    },
    authentication: {
      mfa: {
        title: 'Multi-factor authentication',
        description:
          'Require an additional verification step when signing in to keep your account safer.',
        toggle: 'Enable MFA',
        regenerateBackupCodes: 'Regenerate backup codes',
        downloadBackupCodes: 'Download backup codes'
      },
      providers: {
        password: 'Password',
        google: 'Google',
        apple: 'Apple'
      },
      connectedAccounts: {
        title: 'Connected sign-in methods',
        disconnect: 'Unlink',
        required: 'Required',
        link: 'Link',
        linkProvider: 'Link {{provider}}',
        setPassword: 'Set password',
        notLinked: 'Not linked'
      },
      setPassword: {
        title: 'Set password',
        description:
          'Create a password so you can also sign in with your email and password.',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        submit: 'Set password',
        passwordRequired: 'Password is required',
        confirmRequired: 'Please confirm your password',
        passwordsMustMatch: 'Passwords do not match'
      },
      security: {
        title: 'Sign-in policy',
        allowPassword: 'Allow password sign-in',
        allowSocial: 'Allow social sign-in',
        refreshTokenLifetimeDays: 'Refresh token lifetime (days)',
        trustedDeviceDays: 'Trusted device validity (days)'
      }
    },
    messages: {
      settingsSaved: 'Security settings updated',
      passwordSet: 'Password set successfully',
      providerLinked: 'Provider linked successfully',
      providerUnlinked: 'Provider unlinked successfully',
      outlookConnected: 'Outlook connected successfully',
      outlookDisconnected: 'Outlook disconnected successfully',
      gmailConnected: 'Gmail connected successfully',
      gmailDisconnected: 'Gmail disconnected successfully',
      sessionRevoked: 'Session revoked',
      sessionsRevoked: 'All other sessions were revoked',
      passkeyAdded: 'Passkey registered',
      passkeyRemoved: 'Passkey removed',
      passkeyAborted: 'Passkey registration was cancelled',
      passkeyAlreadyRegistered:
        'This device is already registered as a passkey',
      recoveryRegenerated: 'New recovery codes generated',
      trustRevoked: 'Trust removed from device'
    },
    securityCenter: {
      pageDescription:
        'Strengthen your account with passkeys, backup recovery codes, and trusted devices. Password changes apply to email sign-in.',
      policyHint:
        'Trusted devices remain recognized for {{days}} days (also set under Authentication → Sign-in policy as “Trusted device validity”).',
      passkeys: {
        title: 'Passkeys',
        description:
          'Passkeys let you sign in without a password using your device biometrics or security key.',
        add: 'Add passkey',
        addTitle: 'Register a passkey',
        nameLabel: 'Friendly name',
        namePlaceholder: 'e.g. MacBook Touch ID',
        delete: 'Remove',
        deleteConfirm:
          'Remove this passkey? You will no longer be able to use it to sign in.',
        empty: 'No passkeys yet. Add one to sign in faster and more safely.',
        columns: {
          name: 'Name',
          credential: 'Credential',
          platform: 'Platform',
          added: 'Added',
          lastUsed: 'Last used',
          actions: 'Actions'
        },
        platform: {
          web: 'Web',
          mobile: 'Mobile'
        }
      },
      recovery: {
        title: 'Recovery codes',
        description:
          'If you lose access to your MFA device, use a one-time recovery code. Store codes in a safe place; each code works once.',
        remaining: '{{count}} codes remaining',
        none: 'You have not generated recovery codes yet.',
        mfaDisabled:
          'Enable two-factor authentication first to use recovery codes.',
        regenerate: 'Generate new codes',
        regenerateWarning:
          'This invalidates all existing codes immediately. You must save the new codes before closing the dialog.',
        modalTitle: 'Save your recovery codes',
        modalDescription:
          'These codes will not be shown again. Copy them to a password manager or print them.',
        copy: 'Copy all',
        download: 'Download',
        copied: 'Copied to clipboard',
        done: 'Done'
      },
      trustedDevices: {
        title: 'Trusted devices',
        description:
          'Devices you marked as trusted can skip some MFA prompts until they expire. This is separate from active sessions.',
        columns: {
          device: 'Device',
          trustedAt: 'Trusted on',
          lastUsed: 'Last used',
          actions: 'Actions'
        },
        revoke: 'Revoke trust',
        revokeConfirm:
          'This device will need to fully verify on next sign-in. Continue?',
        unknownDevice: 'Unknown device',
        empty: 'No trusted devices recorded.'
      },
      password: {
        title: 'Password',
        description:
          'Update the password for your email sign-in. For security, we verify the request before you choose a new password.',
        changeDescription: 'Enter your current password and choose a new one.',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmPassword: 'Confirm new password',
        changeButton: 'Change password',
        currentPasswordRequired: 'Current password is required',
        passwordRequired: 'Password is required',
        confirmRequired: 'Please confirm your password',
        passwordsMustMatch: 'Passwords do not match',
        passwordChanged: 'Password changed successfully',
        forgotPassword: 'Forgot your password?',
        requestHint:
          'We will email you a secure link to continue. You may be asked to confirm with MFA.',
        requestButton: 'Email me a password reset link',
        requestSent:
          'Check your email for a link to finish changing your password.',
        noPasswordMethod:
          'You do not have a Skalx password on this account (for example, you only use social or SSO sign-in). Use your provider to manage credentials, or add email/password under Authentication.'
      }
    },
    avatar: {
      change: 'Change avatar',
      upload_title: 'Upload avatar',
      upload_description: 'Drag and drop files here',
      upload_select: 'select',
      upload_hint: 'Supports uploading a single file',
      save: 'Save',
      delete: 'Delete',
      only_images: 'Only image files are allowed',
      upload_success: 'Avatar updated successfully',
      delete_success: 'Avatar removed successfully',
      card_title: 'Avatar',
      card_description: 'Upload a profile picture for your account.',
      zoom: 'Zoom',
      rotate: 'Rotate',
      svg_no_crop: 'Vector files are uploaded as they are, without cropping.'
    },
    notifications: {
      description: 'Control what account events notify you and how often.',
      activityTitle: 'Recent account activity',
      bell: {
        title: 'Notifications',
        markAllRead: 'Mark all read',
        markedAllRead: 'All notifications marked as read',
        empty: 'No notifications yet'
      },
      preferences: {
        title: 'Preferences',
        categoryColumn: 'Category',
        saveSuccess: 'Preferences saved',
        rows: {
          roleChanged: 'Role changed',
          roleReplaced: 'Role replaced',
          securityNotification: 'Security notifications',
          workspaceInvite: 'Workspace invitations',
          supportReply: 'Support replies',
          auditExport: 'Audit log exports',
          crmActivity: 'CRM activity',
          hrmActivity: 'HRM activity'
        },
        channels: {
          email: 'Email',
          push: 'Push',
          internal: 'In-app'
        }
      }
    },
    audit: {
      description:
        'Review important account-level changes such as connected providers, security updates, and session actions.',
      empty: 'No audit events yet.',
      noMatches: 'No events match the current filters.',
      actor: 'Actor',
      target: 'Target',
      searchPlaceholder: 'Search events',
      dateRangeLabel: 'Date range',
      filters: {
        allApplications: 'Application',
        allEventTypes: 'Event type',
        allSeverities: 'Severity',
        clear: 'Clear',
        startDate: 'Start date',
        endDate: 'End date'
      },
      toolbar: {
        events_one: '{{count}} event',
        events_other: '{{count}} events',
        refresh: 'Refresh'
      },
      columns: {
        time: 'Time',
        event: 'Event',
        application: 'Application',
        description: 'Description',
        severity: 'Severity',
        ip: 'IP'
      }
    },
    sessions: {
      description:
        'Review active devices and revoke sessions you no longer trust.',
      columns: {
        device: 'Device',
        workspace: 'Workspace',
        location: 'Location',
        lastActive: 'Last active',
        status: 'Status',
        actions: 'Actions'
      },
      noWorkspace: 'Account',
      current: 'Current',
      currentHint:
        'This is the session you are using. Sign out from the header menu instead.',
      active: 'Active',
      revoked: 'Revoked',
      revoke: 'Revoke',
      revokeConfirm:
        'Revoke this session? The device will be signed out immediately.',
      revokeCurrentConfirm:
        'Revoke the current session? You will be signed out on this device.',
      revokeOidcConfirm:
        'Revoke session for {{name}}? You will need to sign in again from that app.',
      revokeAllOther: 'Revoke all other sessions',
      revokeAllOtherConfirm:
        'Revoke every other session? All other devices will be signed out.',
      empty: 'No active sessions',
      kind: {
        oidc: 'Third-party app'
      },
      authMethod: {
        password: 'Password',
        google: 'Google',
        entraid: 'Microsoft',
        apple: 'Apple',
        email_otp: 'Email code',
        passkey: 'Passkey',
        qr_login: 'QR code'
      },
      messages: {
        revoked: 'Session revoked',
        revokedAll: 'All other sessions were revoked'
      }
    }
  },
  edit: 'Edit',
  personal_details: 'Personal Details',
  personal_details_description:
    'Your personal information for billing purposes',
  phone: 'Phone',
  address_information: 'Address Information',
  address_information_description: 'Your billing address details',
  address: 'Address',
  country_state: 'Country / State',
  town_city: 'Town / City',
  postal_code: 'Postal Code',
  data_save_success: 'Data saved successfully',
  save: 'Save',
  please_input: 'Please enter a value',
  cancel: 'Cancel',
  soon: 'Soon',
  invalid_email: 'Invalid email',
  please_select_organization: 'Please select an organization',
  organizations: {
    header: 'Organizations',
    users: 'users'
  },
  created_on: 'Created on',
  roles: {
    admin: 'Admin',
    employee: 'Employee',
    owner: 'Owner'
  },
  go_to_management_dashboard: 'Go to Management Dashboard',
  no_results: 'No results',
  for_the: 'for the',
  delete: 'Delete',
  total: 'Total',
  user: 'User',
  last_activity: 'Last activity',
  job_title: 'Job title',
  role: 'Role',
  teams: 'Teams',
  all: 'All',
  offline: 'Offline',
  online: 'Online',
  search: 'Search',
  filters: 'Filters',
  more_filters: 'More filters',
  reset: 'Reset',
  apply: 'Apply',
  actions: 'Actions',
  filtering_by: 'Applied filters',
  clear_all: 'Clear all',
  entity_selected: '{{count}} {{entity}} selected',
  count_selected: '{{count}} selected',
  deselect: 'Deselect',
  clear_selection: 'Clear selection',
  more_actions: 'More',
  view: 'View',
  contact_information: 'Contact Information',
  contact_information_description: "Details about the person's contact",
  personal_information: 'Personal Information',
  personal_information_description: "Details about the person's personal info",
  role_information: 'Role Information',
  role_information_description: "Details about the person's role",
  position: 'Position',
  about_me: 'About me',
  linkedin_url: 'LinkedIn',
  role_information_updated: 'Role information has been updated',
  profile: 'Profile',
  change_password: 'Change password',
  new_password: 'New password',
  password_change_success: 'Password changed successfully',
  current_password: 'Current password',
  information_updated_success: 'Information updated successfully',
  enter_your_initial_email: 'Enter your initial email',
  add_organization: 'Create workspace',
  name: 'Name',
  domain_name: 'Domain name',
  input_placeholder: 'Input here...',
  organization_add_success: 'Organization added successfully',
  deleted_success: 'Deleted successfully',
  delete_organization_confirmation:
    'Are you sure you want to delete the organization?',
  confirm: 'Confirm',
  settings: 'Settings',
  column_settings_title: 'Columns',
  column_settings_configure: 'Configure columns',
  column_settings_customize: 'Customize columns',
  table_settings: 'Table settings',
  column_settings_reset: 'Reset',
  column_settings_search: 'Find a field',
  column_settings_shown: 'Shown',
  column_settings_hidden: 'Hidden',
  column_settings_hide_all: 'Hide all',
  column_settings_show_all: 'Show all',
  column_settings_not_found: 'No fields match',
  column_settings_pin_left: 'Pin to the left',
  column_settings_pin_right: 'Pin to the right',
  column_settings_unpin: 'Unpin',
  column_settings_move: 'Move',
  apps: 'Apps',
  workspaceSettingsTabs: {
    general: 'General',
    authorization: 'Authorization',
    mockNotice:
      'This tab is currently a mock inspired by settings patterns from example SaaS apps.',
    automation: {
      tab: 'Automation',
      title: 'Automation & provisioning',
      items: {
        provisioning: 'Automatic user provisioning (SCIM)',
        lifecycle: 'Workspace lifecycle policy',
        directory: 'Directory sync scheduling'
      }
    },
    audit: {
      tab: 'Audit & compliance',
      title: 'Audit and compliance controls',
      items: {
        retention: 'Audit log retention policy',
        alerting: 'Suspicious access alerting',
        exports: 'Scheduled compliance exports'
      }
    },
    generalDangerZone: {
      title: 'Danger zone',
      description:
        'Delete this workspace permanently. This action cannot be undone.',
      deleteAction: 'Delete workspace'
    }
  },
  organization_info: 'Organization info',
  organization_info_description:
    'Basic details about your organization displayed across the system.',
  authMethods: {
    title: 'Authentication methods',
    description:
      'Control password and social sign-in for this organization, enable federation templates when you need them, and add fully custom providers.',
    existingProvidersTitle: 'Sign-in providers',
    existingProvidersDescription:
      'Built-in methods sync with the organization API. Federation templates and custom providers use local workspace preview storage until backend endpoints exist.',
    builtInProvidersSubtitle: 'Built-in methods',
    federationProvidersSubtitle: 'Federation templates',
    federationProvidersDescription:
      'Pre-filled IdP templates. Turn a template on only when you use it, then add credentials and endpoints.',
    customProvidersCardTitle: 'Custom providers',
    customProvidersCardDescription:
      'Add your own OIDC, OAuth2, or SAML 2.0 connections. Each provider opens in the drawer for full configuration.',
    addCustomProviderTitle: 'Add custom provider',
    editCustomProviderTitle: 'Edit custom provider',
    clientProvidersTitle: 'Custom client providers',
    clientProvidersDescription:
      'Add external authorization providers used by your client applications.',
    customProvider: 'Custom provider',
    addProvider: 'Add provider',
    selectProviderPlaceholder: 'Select provider template',
    addFromCatalog: 'Add selected provider',
    addCustomProvider: 'Add custom provider',
    catalog: {
      google: 'Google',
      entra: 'Microsoft Entra ID',
      magicLink: 'Magic Link',
      github: 'GitHub',
      apple: 'Apple',
      oktaSaml: 'Okta SAML'
    },
    protocol: 'Protocol',
    scope: 'Scope',
    issuerUrl: 'Issuer URL',
    jwksUrl: 'JWKS URL',
    authorizeUrl: 'Authorize URL',
    tokenUrl: 'Token URL',
    additionalSettings: 'Additional authorization settings',
    additionalSettingsDescription:
      'These settings are client-level controls and are stored as workspace configuration.',
    enforceSso: 'Enforce SSO for all members',
    enforceSsoHint:
      'When enabled, members can sign in only via the configured SSO provider. Password and other login methods are disabled for everyone except workspace owners.',
    allowSelfServiceJoin: 'Allow self-service join requests',
    allowSelfServiceJoinHint:
      'When enabled, users with a verified email matching the workspace domain can request to join without an invitation. Admins still approve each request.',
    autoProvisionUsers: 'Auto-provision users from identity providers',
    autoProvisionUsersHint:
      "When enabled, accounts are created automatically the first time a user signs in via a configured identity provider, using the IdP's profile data.",
    defaultRole: 'Default role for newly provisioned users',
    roles: {
      member: 'Member',
      admin: 'Admin',
      viewer: 'Viewer'
    },
    password: 'Password',
    emailOtp: 'Email OTP',
    qrLogin: 'QR code',
    google: 'Google',
    entraid: 'Entra ID',
    apple: 'Apple',
    passkey: 'Passkey / WebAuthn',
    setupInstructionsTitle: 'Setup instructions',
    docsLabel: 'Setup documentation:',
    openDocs: 'Open guide',
    redirectUrlsTitle: 'Authorized redirect URLs',
    accountAppRedirectUrls: 'Account UI',
    platformWebRedirectUrls: 'EBS Platform Web',
    backendApiRedirectUrls:
      'Backend API (same URL works for all organizations)',
    mailboxRedirectUrls: 'Mailbox connect — Outlook integration',
    googleSetupHint:
      'Create an OAuth 2.0 Client ID (Web application), then paste Client ID and Client secret below.',
    entraidSetupHint:
      'Create a Microsoft Entra app registration, then paste Client ID, Client secret, and Tenant ID below. Register both redirect URLs under the Web platform — the second one is what the Outlook mailbox integration uses.',
    appleSetupHint:
      'Create a Sign in with Apple Service ID in your Apple Developer account, then paste the Service ID, private key (PEM), Team ID, and Key ID below.',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    tenantId: 'Tenant ID',
    teamId: 'Team ID',
    keyId: 'Key ID',
    appleServiceId: 'Service ID',
    applePrivateKey: 'Private Key (PEM)',
    leaveEmptyToKeep: 'Leave empty to keep current secret',
    leaveEmptyToKeepKey: 'Leave empty to keep current key'
  },
  profileAuthMethods: {
    tab: 'My authentication methods',
    defaultMethods: 'Default (system) methods',
    defaultMethodsDescription:
      'Used to sign in to your account regardless of organization.',
    perOrganization: 'Per organization',
    perOrganizationDescription:
      'Methods enabled for each organization; link to use them when signing in there.',
    no_organizations: 'You have no organizations.',
    linked: 'Linked',
    not_linked: 'Not linked',
    change_password: 'Change password',
    link: 'Link',
    unlink: 'Unlink',
    unlinkConfirmTitle: 'Unlink Google?',
    unlinkConfirmContent:
      'You will no longer be able to sign in with Google for this account.',
    connectSuccess: 'Google account linked successfully.',
    connectCallbackMissingParams:
      'Invalid response from Google. Please try again.',
    unlinkConfirmTitleEntraid: 'Unlink Microsoft?',
    unlinkConfirmContentEntraid:
      'You will no longer be able to sign in with Microsoft for this account.',
    connectSuccessEntraid: 'Microsoft account linked successfully.',
    unlinkConfirmTitleApple: 'Unlink Apple?',
    unlinkConfirmContentApple:
      'You will no longer be able to sign in with Apple for this account.',
    connectSuccessApple: 'Apple account linked successfully.',
    loadError: 'Failed to load authentication methods for this organization.',
    retry: 'Retry',
    noMethodsConfigured:
      'No authentication methods are configured for this organization yet.',
    noEnabledMethods:
      'No authentication methods are enabled for this organization.',
    enabled: 'Enabled',
    disabled: 'Disabled',
    managedByOrganization: 'Managed by organization settings'
  },
  logo: 'Logo',
  change: 'Change',
  organization_name: 'Organization name',

  disable_success: 'Disabled successfully',
  disable_user_confirmation: 'Are you sure you want to disable the user?',
  disable: 'Disable',
  pagination: {
    total: '{{from}} to {{to}} of {{total}} results',
    range: '{{from}}–{{to}} of {{total}}'
  },
  organization_deleted: 'Organization deleted successfully',
  no_organization_apps:
    'No organization apps found, to add an app login to the',
  management_dashboard: 'management dashboard.',
  only_upload_image: 'You can only upload image files!',
  svgUpload: {
    tooLarge: 'An SVG file must be smaller than {{size}} MB.',
    unreadable: 'This SVG could not be read as an image.'
  },
  industry: 'Industry',
  select_for_example_data: 'Select for example data',
  please_select: 'Please select...',
  reset_data_in_applications: 'Reset data in applications',
  do_you_want_to_reset: 'Do you want to reset?',
  do_you_want_to_reset_description:
    'All data in all applications will be reset to their default state (according to industry if applicable). This operation cannot be undone after confirming.',
  we_are_preparing_your_data:
    'We are preparing your dashboard by loading data, setting up, and updating information. This will not take long, please wait.',
  information: 'Information',
  loading_data: 'Loading data',
  we_are_setting: "We're setting things up for you. This won't take long!",
  show_details: 'Show details',
  hide_details: 'Hide details',
  demoPresets_healthcare_title: 'Healthcare',
  demoPresets_healthcare_description:
    'Solutions designed for clinics, hospitals and medical services.',
  demoPresets_noData_title: 'No Data',
  demoPresets_noData_description:
    'Creates an application without any demo data.',
  demoPresets_generic_title: 'Generic',
  demoPresets_generic_description:
    'General-purpose preset suitable for various industries.',
  demoPresets_education_title: 'Education',
  demoPresets_education_description:
    'Tools and workflows for schools, universities and learning centers.',
  demoPresets_retail_title: 'Retail',
  demoPresets_retail_description:
    'Solutions tailored for shops, stores and retail operations.',
  demoPresets_finance_title: 'Finance',
  demoPresets_finance_description:
    'Banking and financial service–oriented workflows.',
  healthcare: 'Healthcare',
  no_data: 'No Data',
  generic: 'Generic',
  education: 'Education',
  retail: 'Retail',
  finance: 'Finance',
  go_to_organization: 'Go to workspace',
  something_went_wrong: 'Something went wrong',
  please_try_again: 'Please try again',
  retry: 'Retry',
  setup_completed: 'Setup Completed',
  setup_completed_description:
    'Your organization setup is complete and ready to use.',
  in_progress: 'In progress',
  show_more: 'Show more',
  show_less: 'Show less',
  demoPresets_informationTechnology_title: 'Information Technology',
  demoPresets_informationTechnology_description:
    'Solutions and tools for software development, systems, and digital infrastructure.',
  information_technology: 'Information Technology'
}

export default en
